require("core-js/modules/es.array.flat");

require("core-js/modules/es.array.unscopables.flat");

require("core-js/modules/es.promise.finally");

var _slicedToArray = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _regeneratorRuntime = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapNativeSuper = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _get = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _toConsumableArray = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createClass = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/opt/build/repo/gatsby-justice-hub/node_modules/@babel/runtime/helpers/classCallCheck");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["<button @click=\"", "\" class=\"typeform-button\"><slot>Launch Me</slot></button>"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["<button @click=\"", "\" style=\"", "\"><slot>Launch Me</slot></button>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        <div style=\"\n          height: ", ";\n          width: ", ";\n        \">\n        </div>\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["<p style=\"color: darkred;\">Invalid Typeform URL <br/><small><a href=\"https://github.com/Typeform/typeform-elements\">Typeform Elements</a></small></p>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e24) { throw _e24; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e25) { didErr = true; err = _e25; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var typeformEmbed = function (e) {
  "use strict";
  /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
  
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
  
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

  function t(e, t, n, r) {
    var o,
        i = arguments.length,
        a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
      (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
    }
    return i > 3 && a && Object.defineProperty(t, n, a), a;
    /**
         * @license
         * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
         * This code may only be used under the BSD style license found at
         * http://polymer.github.io/LICENSE.txt
         * The complete set of authors may be found at
         * http://polymer.github.io/AUTHORS.txt
         * The complete set of contributors may be found at
         * http://polymer.github.io/CONTRIBUTORS.txt
         * Code distributed by Google as part of the polymer project is also
         * subject to an additional IP rights grant found at
         * http://polymer.github.io/PATENTS.txt
         */
  }

  var n = new WeakMap(),
      r = function r(e) {
    return "function" == typeof e && n.has(e);
  },
      o = void 0 !== window.customElements && void 0 !== window.customElements.polyfillWrapFlushCallback,
      i = function i(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    for (; t !== n;) {
      var _n = t.nextSibling;
      e.removeChild(t), t = _n;
    }
  },
      a = {},
      s = {},
      c = "{{lit-".concat(String(Math.random()).slice(2), "}}"),
      u = "<!--".concat(c, "-->"),
      l = new RegExp("".concat(c, "|").concat(u));

  var d = function d(e, t) {
    _classCallCheck(this, d);

    this.parts = [], this.element = t;
    var n = [],
        r = [],
        o = document.createTreeWalker(t.content, 133, null, !1);
    var i = 0,
        a = -1,
        s = 0;
    var u = e.strings,
        _d = e.values.length;

    for (; s < _d;) {
      var _e = o.nextNode();

      if (null !== _e) {
        if (a++, 1 === _e.nodeType) {
          if (_e.hasAttributes()) {
            var _t = _e.attributes,
                _n2 = _t.length;
            var _r = 0;

            for (var _e2 = 0; _e2 < _n2; _e2++) {
              p(_t[_e2].name, "$lit$") && _r++;
            }

            for (; _r-- > 0;) {
              var _t2 = u[s],
                  _n3 = m.exec(_t2)[2],
                  _r2 = _n3.toLowerCase() + "$lit$",
                  _o = _e.getAttribute(_r2);

              _e.removeAttribute(_r2);

              var _i = _o.split(l);

              this.parts.push({
                type: "attribute",
                index: a,
                name: _n3,
                strings: _i
              }), s += _i.length - 1;
            }
          }

          "TEMPLATE" === _e.tagName && (r.push(_e), o.currentNode = _e.content);
        } else if (3 === _e.nodeType) {
          var _t3 = _e.data;

          if (_t3.indexOf(c) >= 0) {
            var _r3 = _e.parentNode,
                _o2 = _t3.split(l),
                _i2 = _o2.length - 1;

            for (var _t4 = 0; _t4 < _i2; _t4++) {
              var _n4 = void 0,
                  _i3 = _o2[_t4];

              if ("" === _i3) _n4 = h();else {
                var _e3 = m.exec(_i3);

                null !== _e3 && p(_e3[2], "$lit$") && (_i3 = _i3.slice(0, _e3.index) + _e3[1] + _e3[2].slice(0, -"$lit$".length) + _e3[3]), _n4 = document.createTextNode(_i3);
              }
              _r3.insertBefore(_n4, _e), this.parts.push({
                type: "node",
                index: ++a
              });
            }

            "" === _o2[_i2] ? (_r3.insertBefore(h(), _e), n.push(_e)) : _e.data = _o2[_i2], s += _i2;
          }
        } else if (8 === _e.nodeType) if (_e.data === c) {
          var _t5 = _e.parentNode;
          null !== _e.previousSibling && a !== i || (a++, _t5.insertBefore(h(), _e)), i = a, this.parts.push({
            type: "node",
            index: a
          }), null === _e.nextSibling ? _e.data = "" : (n.push(_e), a--), s++;
        } else {
          var _t6 = -1;

          for (; -1 !== (_t6 = _e.data.indexOf(c, _t6 + 1));) {
            this.parts.push({
              type: "node",
              index: -1
            }), s++;
          }
        }
      } else o.currentNode = r.pop();
    }

    for (var _i4 = 0, _n5 = n; _i4 < _n5.length; _i4++) {
      var _e4 = _n5[_i4];

      _e4.parentNode.removeChild(_e4);
    }
  };

  var p = function p(e, t) {
    var n = e.length - t.length;
    return n >= 0 && e.slice(n) === t;
  },
      f = function f(e) {
    return -1 !== e.index;
  },
      h = function h() {
    return document.createComment("");
  },
      m = /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */


  var y = /*#__PURE__*/function () {
    function y(e, t, n) {
      _classCallCheck(this, y);

      this.__parts = [], this.template = e, this.processor = t, this.options = n;
    }

    _createClass(y, [{
      key: "update",
      value: function update(e) {
        var t = 0;

        var _iterator = _createForOfIteratorHelper(this.__parts),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _n6 = _step.value;
            void 0 !== _n6 && _n6.setValue(e[t]), t++;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var _iterator2 = _createForOfIteratorHelper(this.__parts),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e5 = _step2.value;
            void 0 !== _e5 && _e5.commit();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }, {
      key: "_clone",
      value: function _clone() {
        var e = o ? this.template.element.content.cloneNode(!0) : document.importNode(this.template.element.content, !0),
            t = [],
            n = this.template.parts,
            r = document.createTreeWalker(e, 133, null, !1);
        var i,
            a = 0,
            s = 0,
            c = r.nextNode();

        for (; a < n.length;) {
          if (i = n[a], f(i)) {
            var _this$__parts;

            for (; s < i.index;) {
              s++, "TEMPLATE" === c.nodeName && (t.push(c), r.currentNode = c.content), null === (c = r.nextNode()) && (r.currentNode = t.pop(), c = r.nextNode());
            }

            if ("node" === i.type) {
              var _e6 = this.processor.handleTextExpression(this.options);

              _e6.insertAfterNode(c.previousSibling), this.__parts.push(_e6);
            } else (_this$__parts = this.__parts).push.apply(_this$__parts, _toConsumableArray(this.processor.handleAttributeExpressions(c, i.name, i.strings, this.options)));

            a++;
          } else this.__parts.push(void 0), a++;
        }

        return o && (document.adoptNode(e), customElements.upgrade(e)), e;
      }
    }]);

    return y;
  }();
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */


  var v = " ".concat(c, " ");

  var b = /*#__PURE__*/function () {
    function b(e, t, n, r) {
      _classCallCheck(this, b);

      this.strings = e, this.values = t, this.type = n, this.processor = r;
    }

    _createClass(b, [{
      key: "getHTML",
      value: function getHTML() {
        var e = this.strings.length - 1;
        var t = "",
            n = !1;

        for (var _r4 = 0; _r4 < e; _r4++) {
          var _e7 = this.strings[_r4],
              _o3 = _e7.lastIndexOf("\x3c!--");

          n = (_o3 > -1 || n) && -1 === _e7.indexOf("--\x3e", _o3 + 1);

          var _i5 = m.exec(_e7);

          t += null === _i5 ? _e7 + (n ? v : u) : _e7.substr(0, _i5.index) + _i5[1] + _i5[2] + "$lit$" + _i5[3] + c;
        }

        return t += this.strings[e], t;
      }
    }, {
      key: "getTemplateElement",
      value: function getTemplateElement() {
        var e = document.createElement("template");
        return e.innerHTML = this.getHTML(), e;
      }
    }]);

    return b;
  }();
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */


  var g = function g(e) {
    return null === e || !("object" == typeof e || "function" == typeof e);
  },
      w = function w(e) {
    return Array.isArray(e) || !(!e || !e[Symbol.iterator]);
  };

  var _ = /*#__PURE__*/function () {
    function _(e, t, n) {
      _classCallCheck(this, _);

      this.dirty = !0, this.element = e, this.name = t, this.strings = n, this.parts = [];

      for (var _e8 = 0; _e8 < n.length - 1; _e8++) {
        this.parts[_e8] = this._createPart();
      }
    }

    _createClass(_, [{
      key: "_createPart",
      value: function _createPart() {
        return new x(this);
      }
    }, {
      key: "_getValue",
      value: function _getValue() {
        var e = this.strings,
            t = e.length - 1;
        var n = "";

        for (var _r5 = 0; _r5 < t; _r5++) {
          n += e[_r5];
          var _t7 = this.parts[_r5];

          if (void 0 !== _t7) {
            var _e9 = _t7.value;
            if (g(_e9) || !w(_e9)) n += "string" == typeof _e9 ? _e9 : String(_e9);else {
              var _iterator3 = _createForOfIteratorHelper(_e9),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _t8 = _step3.value;
                  n += "string" == typeof _t8 ? _t8 : String(_t8);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        }

        return n += e[t], n;
      }
    }, {
      key: "commit",
      value: function commit() {
        this.dirty && (this.dirty = !1, this.element.setAttribute(this.name, this._getValue()));
      }
    }]);

    return _;
  }();

  var x = /*#__PURE__*/function () {
    function x(e) {
      _classCallCheck(this, x);

      this.value = void 0, this.committer = e;
    }

    _createClass(x, [{
      key: "setValue",
      value: function setValue(e) {
        e === a || g(e) && e === this.value || (this.value = e, r(e) || (this.committer.dirty = !0));
      }
    }, {
      key: "commit",
      value: function commit() {
        for (; r(this.value);) {
          var _e10 = this.value;
          this.value = a, _e10(this);
        }

        this.value !== a && this.committer.commit();
      }
    }]);

    return x;
  }();

  var S = /*#__PURE__*/function () {
    function S(e) {
      _classCallCheck(this, S);

      this.value = void 0, this.__pendingValue = void 0, this.options = e;
    }

    _createClass(S, [{
      key: "appendInto",
      value: function appendInto(e) {
        this.startNode = e.appendChild(h()), this.endNode = e.appendChild(h());
      }
    }, {
      key: "insertAfterNode",
      value: function insertAfterNode(e) {
        this.startNode = e, this.endNode = e.nextSibling;
      }
    }, {
      key: "appendIntoPart",
      value: function appendIntoPart(e) {
        e.__insert(this.startNode = h()), e.__insert(this.endNode = h());
      }
    }, {
      key: "insertAfterPart",
      value: function insertAfterPart(e) {
        e.__insert(this.startNode = h()), this.endNode = e.endNode, e.endNode = this.startNode;
      }
    }, {
      key: "setValue",
      value: function setValue(e) {
        this.__pendingValue = e;
      }
    }, {
      key: "commit",
      value: function commit() {
        for (; r(this.__pendingValue);) {
          var _e11 = this.__pendingValue;
          this.__pendingValue = a, _e11(this);
        }

        var e = this.__pendingValue;
        e !== a && (g(e) ? e !== this.value && this.__commitText(e) : e instanceof b ? this.__commitTemplateResult(e) : e instanceof Node ? this.__commitNode(e) : w(e) ? this.__commitIterable(e) : e === s ? (this.value = s, this.clear()) : this.__commitText(e));
      }
    }, {
      key: "__insert",
      value: function __insert(e) {
        this.endNode.parentNode.insertBefore(e, this.endNode);
      }
    }, {
      key: "__commitNode",
      value: function __commitNode(e) {
        this.value !== e && (this.clear(), this.__insert(e), this.value = e);
      }
    }, {
      key: "__commitText",
      value: function __commitText(e) {
        var t = this.startNode.nextSibling,
            n = "string" == typeof (e = null == e ? "" : e) ? e : String(e);
        t === this.endNode.previousSibling && 3 === t.nodeType ? t.data = n : this.__commitNode(document.createTextNode(n)), this.value = e;
      }
    }, {
      key: "__commitTemplateResult",
      value: function __commitTemplateResult(e) {
        var t = this.options.templateFactory(e);
        if (this.value instanceof y && this.value.template === t) this.value.update(e.values);else {
          var _n7 = new y(t, e.processor, this.options),
              _r6 = _n7._clone();

          _n7.update(e.values), this.__commitNode(_r6), this.value = _n7;
        }
      }
    }, {
      key: "__commitIterable",
      value: function __commitIterable(e) {
        Array.isArray(this.value) || (this.value = [], this.clear());
        var t = this.value;
        var n,
            r = 0;

        var _iterator4 = _createForOfIteratorHelper(e),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _o4 = _step4.value;
            n = t[r], void 0 === n && (n = new S(this.options), t.push(n), 0 === r ? n.appendIntoPart(this) : n.insertAfterPart(t[r - 1])), n.setValue(_o4), n.commit(), r++;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        r < t.length && (t.length = r, this.clear(n && n.endNode));
      }
    }, {
      key: "clear",
      value: function clear() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.startNode;
        i(this.startNode.parentNode, e.nextSibling, this.endNode);
      }
    }]);

    return S;
  }();

  var C = /*#__PURE__*/function () {
    function C(e, t, n) {
      _classCallCheck(this, C);

      if (this.value = void 0, this.__pendingValue = void 0, 2 !== n.length || "" !== n[0] || "" !== n[1]) throw new Error("Boolean attributes can only contain a single expression");
      this.element = e, this.name = t, this.strings = n;
    }

    _createClass(C, [{
      key: "setValue",
      value: function setValue(e) {
        this.__pendingValue = e;
      }
    }, {
      key: "commit",
      value: function commit() {
        for (; r(this.__pendingValue);) {
          var _e12 = this.__pendingValue;
          this.__pendingValue = a, _e12(this);
        }

        if (this.__pendingValue === a) return;
        var e = !!this.__pendingValue;
        this.value !== e && (e ? this.element.setAttribute(this.name, "") : this.element.removeAttribute(this.name), this.value = e), this.__pendingValue = a;
      }
    }]);

    return C;
  }();

  var k = /*#__PURE__*/function (_ref) {
    _inherits(k, _ref);

    var _super = _createSuper(k);

    function k(e, t, n) {
      var _this;

      _classCallCheck(this, k);

      _this = _super.call(this, e, t, n), _this.single = 2 === n.length && "" === n[0] && "" === n[1];
      return _this;
    }

    _createClass(k, [{
      key: "_createPart",
      value: function _createPart() {
        return new E(this);
      }
    }, {
      key: "_getValue",
      value: function _getValue() {
        return this.single ? this.parts[0].value : _get(_getPrototypeOf(k.prototype), "_getValue", this).call(this);
      }
    }, {
      key: "commit",
      value: function commit() {
        this.dirty && (this.dirty = !1, this.element[this.name] = this._getValue());
      }
    }]);

    return k;
  }(_);

  var E = /*#__PURE__*/function (_x) {
    _inherits(E, _x);

    var _super2 = _createSuper(E);

    function E() {
      _classCallCheck(this, E);

      return _super2.apply(this, arguments);
    }

    return E;
  }(x);

  var O = !1;

  try {
    var _e13 = {
      get capture() {
        return O = !0, !1;
      }

    };
    window.addEventListener("test", _e13, _e13), window.removeEventListener("test", _e13, _e13);
  } catch (e) {}

  var P = /*#__PURE__*/function () {
    function P(e, t, n) {
      var _this2 = this;

      _classCallCheck(this, P);

      this.value = void 0, this.__pendingValue = void 0, this.element = e, this.eventName = t, this.eventContext = n, this.__boundHandleEvent = function (e) {
        return _this2.handleEvent(e);
      };
    }

    _createClass(P, [{
      key: "setValue",
      value: function setValue(e) {
        this.__pendingValue = e;
      }
    }, {
      key: "commit",
      value: function commit() {
        for (; r(this.__pendingValue);) {
          var _e14 = this.__pendingValue;
          this.__pendingValue = a, _e14(this);
        }

        if (this.__pendingValue === a) return;
        var e = this.__pendingValue,
            t = this.value,
            n = null == e || null != t && (e.capture !== t.capture || e.once !== t.once || e.passive !== t.passive),
            o = null != e && (null == t || n);
        n && this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options), o && (this.__options = T(e), this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options)), this.value = e, this.__pendingValue = a;
      }
    }, {
      key: "handleEvent",
      value: function handleEvent(e) {
        "function" == typeof this.value ? this.value.call(this.eventContext || this.element, e) : this.value.handleEvent(e);
      }
    }]);

    return P;
  }();

  var T = function T(e) {
    return e && (O ? {
      capture: e.capture,
      passive: e.passive,
      once: e.once
    } : e.capture);
  }
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  ;

  var A = new ( /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    _createClass(_class, [{
      key: "handleAttributeExpressions",
      value: function handleAttributeExpressions(e, t, n, r) {
        var o = t[0];

        if ("." === o) {
          return new k(e, t.slice(1), n).parts;
        }

        return "@" === o ? [new P(e, t.slice(1), r.eventContext)] : "?" === o ? [new C(e, t.slice(1), n)] : new _(e, t, n).parts;
      }
    }, {
      key: "handleTextExpression",
      value: function handleTextExpression(e) {
        return new S(e);
      }
    }]);

    return _class;
  }())();
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */

  function j(e) {
    var t = N.get(e.type);
    void 0 === t && (t = {
      stringsArray: new WeakMap(),
      keyString: new Map()
    }, N.set(e.type, t));
    var n = t.stringsArray.get(e.strings);
    if (void 0 !== n) return n;
    var r = e.strings.join(c);
    return n = t.keyString.get(r), void 0 === n && (n = new d(e, e.getTemplateElement()), t.keyString.set(r, n)), t.stringsArray.set(e.strings, n), n;
  }

  var N = new Map(),
      M = new WeakMap();
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */

  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */

  (window.litHtmlVersions || (window.litHtmlVersions = [])).push("1.1.2");

  var I = function I(e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }

    return new b(e, t, "html", A);
  }
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */
  ;

  function R(e, t) {
    var n = e.element.content,
        r = e.parts,
        o = document.createTreeWalker(n, 133, null, !1);
    var i = F(r),
        a = r[i],
        s = -1,
        c = 0;
    var u = [];
    var l = null;

    for (; o.nextNode();) {
      s++;
      var _e15 = o.currentNode;

      for (_e15.previousSibling === l && (l = null), t.has(_e15) && (u.push(_e15), null === l && (l = _e15)), null !== l && c++; void 0 !== a && a.index === s;) {
        a.index = null !== l ? -1 : a.index - c, i = F(r, i), a = r[i];
      }
    }

    u.forEach(function (e) {
      return e.parentNode.removeChild(e);
    });
  }

  var L = function L(e) {
    var t = 11 === e.nodeType ? 0 : 1;
    var n = document.createTreeWalker(e, 133, null, !1);

    for (; n.nextNode();) {
      t++;
    }

    return t;
  },
      F = function F(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    for (var _n8 = t + 1; _n8 < e.length; _n8++) {
      var _t9 = e[_n8];
      if (f(_t9)) return _n8;
    }

    return -1;
  };
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */


  var U = function U(e, t) {
    return "".concat(e, "--").concat(t);
  };

  var D = !0;
  void 0 === window.ShadyCSS ? D = !1 : void 0 === window.ShadyCSS.prepareTemplateDom && (console.warn("Incompatible ShadyCSS version detected. Please update to at least @webcomponents/webcomponentsjs@2.0.2 and @webcomponents/shadycss@1.3.1."), D = !1);

  var V = function V(e) {
    return function (t) {
      var n = U(t.type, e);
      var r = N.get(n);
      void 0 === r && (r = {
        stringsArray: new WeakMap(),
        keyString: new Map()
      }, N.set(n, r));
      var o = r.stringsArray.get(t.strings);
      if (void 0 !== o) return o;
      var i = t.strings.join(c);

      if (o = r.keyString.get(i), void 0 === o) {
        var _n9 = t.getTemplateElement();

        D && window.ShadyCSS.prepareTemplateDom(_n9, e), o = new d(t, _n9), r.keyString.set(i, o);
      }

      return r.stringsArray.set(t.strings, o), o;
    };
  },
      W = ["html", "svg"],
      $ = new Set(),
      z = function z(e, t, n) {
    $.add(e);
    var r = n ? n.element : document.createElement("template"),
        o = t.querySelectorAll("style"),
        i = o.length;
    if (0 === i) return void window.ShadyCSS.prepareTemplateStyles(r, e);
    var a = document.createElement("style");

    for (var _e16 = 0; _e16 < i; _e16++) {
      var _t10 = o[_e16];
      _t10.parentNode.removeChild(_t10), a.textContent += _t10.textContent;
    }

    (function (e) {
      W.forEach(function (t) {
        var n = N.get(U(t, e));
        void 0 !== n && n.keyString.forEach(function (e) {
          var t = e.element.content,
              n = new Set();
          Array.from(t.querySelectorAll("style")).forEach(function (e) {
            n.add(e);
          }), R(e, n);
        });
      });
    })(e);

    var s = r.content;
    n ? function (e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var r = e.element.content,
          o = e.parts;
      if (null == n) return void r.appendChild(t);
      var i = document.createTreeWalker(r, 133, null, !1);
      var a = F(o),
          s = 0,
          c = -1;

      for (; i.nextNode();) {
        for (c++, i.currentNode === n && (s = L(t), n.parentNode.insertBefore(t, n)); -1 !== a && o[a].index === c;) {
          if (s > 0) {
            for (; -1 !== a;) {
              o[a].index += s, a = F(o, a);
            }

            return;
          }

          a = F(o, a);
        }
      }
    }(n, a, s.firstChild) : s.insertBefore(a, s.firstChild), window.ShadyCSS.prepareTemplateStyles(r, e);
    var c = s.querySelector("style");
    if (window.ShadyCSS.nativeShadow && null !== c) t.insertBefore(c.cloneNode(!0), t.firstChild);else if (n) {
      s.insertBefore(a, s.firstChild);

      var _e17 = new Set();

      _e17.add(a), R(n, _e17);
    }
  };

  window.JSCompiler_renameProperty = function (e, t) {
    return e;
  };

  var B = {
    toAttribute: function toAttribute(e, t) {
      switch (t) {
        case Boolean:
          return e ? "" : null;

        case Object:
        case Array:
          return null == e ? e : JSON.stringify(e);
      }

      return e;
    },
    fromAttribute: function fromAttribute(e, t) {
      switch (t) {
        case Boolean:
          return null !== e;

        case Number:
          return null === e ? null : Number(e);

        case Object:
        case Array:
          return JSON.parse(e);
      }

      return e;
    }
  },
      q = function q(e, t) {
    return t !== e && (t == t || e == e);
  },
      H = {
    attribute: !0,
    type: String,
    converter: B,
    reflect: !1,
    hasChanged: q
  },
      G = Promise.resolve(!0);

  var K = /*#__PURE__*/function (_HTMLElement) {
    _inherits(K, _HTMLElement);

    var _super3 = _createSuper(K);

    function K() {
      var _this3;

      _classCallCheck(this, K);

      _this3 = _super3.call(this), _this3._updateState = 0, _this3._instanceProperties = void 0, _this3._updatePromise = G, _this3._hasConnectedResolver = void 0, _this3._changedProperties = new Map(), _this3._reflectingProperties = void 0, _this3.initialize();
      return _this3;
    }

    _createClass(K, [{
      key: "initialize",
      value: function initialize() {
        this._saveInstanceProperties(), this._requestUpdate();
      }
    }, {
      key: "_saveInstanceProperties",
      value: function _saveInstanceProperties() {
        var _this4 = this;

        this.constructor._classProperties.forEach(function (e, t) {
          if (_this4.hasOwnProperty(t)) {
            var _e18 = _this4[t];
            delete _this4[t], _this4._instanceProperties || (_this4._instanceProperties = new Map()), _this4._instanceProperties.set(t, _e18);
          }
        });
      }
    }, {
      key: "_applyInstanceProperties",
      value: function _applyInstanceProperties() {
        var _this5 = this;

        this._instanceProperties.forEach(function (e, t) {
          return _this5[t] = e;
        }), this._instanceProperties = void 0;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this._updateState = 32 | this._updateState, this._hasConnectedResolver && (this._hasConnectedResolver(), this._hasConnectedResolver = void 0);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {}
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(e, t, n) {
        t !== n && this._attributeToProperty(e, n);
      }
    }, {
      key: "_propertyToAttribute",
      value: function _propertyToAttribute(e, t) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : H;

        var r = this.constructor,
            o = r._attributeNameForProperty(e, n);

        if (void 0 !== o) {
          var _e19 = r._propertyValueToAttribute(t, n);

          if (void 0 === _e19) return;
          this._updateState = 8 | this._updateState, null == _e19 ? this.removeAttribute(o) : this.setAttribute(o, _e19), this._updateState = -9 & this._updateState;
        }
      }
    }, {
      key: "_attributeToProperty",
      value: function _attributeToProperty(e, t) {
        if (8 & this._updateState) return;

        var n = this.constructor,
            r = n._attributeToPropertyMap.get(e);

        if (void 0 !== r) {
          var _e20 = n._classProperties.get(r) || H;

          this._updateState = 16 | this._updateState, this[r] = n._propertyValueFromAttribute(t, _e20), this._updateState = -17 & this._updateState;
        }
      }
    }, {
      key: "_requestUpdate",
      value: function _requestUpdate(e, t) {
        var n = !0;

        if (void 0 !== e) {
          var _r7 = this.constructor,
              _o5 = _r7._classProperties.get(e) || H;

          _r7._valueHasChanged(this[e], t, _o5.hasChanged) ? (this._changedProperties.has(e) || this._changedProperties.set(e, t), !0 !== _o5.reflect || 16 & this._updateState || (void 0 === this._reflectingProperties && (this._reflectingProperties = new Map()), this._reflectingProperties.set(e, _o5))) : n = !1;
        }

        !this._hasRequestedUpdate && n && this._enqueueUpdate();
      }
    }, {
      key: "requestUpdate",
      value: function requestUpdate(e, t) {
        return this._requestUpdate(e, t), this.updateComplete;
      }
    }, {
      key: "_enqueueUpdate",
      value: function () {
        var _enqueueUpdate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this6 = this;

          var e, t, n, _e21;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this._updateState = 4 | this._updateState;
                  n = this._updatePromise;
                  this._updatePromise = new Promise(function (n, r) {
                    e = n, t = r;
                  });
                  _context.prev = 3;
                  _context.next = 6;
                  return n;

                case 6:
                  _context.next = 10;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](3);

                case 10:
                  _context.t1 = this._hasConnected;

                  if (_context.t1) {
                    _context.next = 14;
                    break;
                  }

                  _context.next = 14;
                  return new Promise(function (e) {
                    return _this6._hasConnectedResolver = e;
                  });

                case 14:
                  _context.prev = 14;
                  _e21 = this.performUpdate();
                  _context.t2 = null != _e21;

                  if (!_context.t2) {
                    _context.next = 20;
                    break;
                  }

                  _context.next = 20;
                  return _e21;

                case 20:
                  _context.next = 25;
                  break;

                case 22:
                  _context.prev = 22;
                  _context.t3 = _context["catch"](14);
                  t(_context.t3);

                case 25:
                  e(!this._hasRequestedUpdate);

                case 26:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 8], [14, 22]]);
        }));

        function _enqueueUpdate() {
          return _enqueueUpdate2.apply(this, arguments);
        }

        return _enqueueUpdate;
      }()
    }, {
      key: "performUpdate",
      value: function performUpdate() {
        this._instanceProperties && this._applyInstanceProperties();
        var e = !1;
        var t = this._changedProperties;

        try {
          e = this.shouldUpdate(t), e && this.update(t);
        } catch (t) {
          throw e = !1, t;
        } finally {
          this._markUpdated();
        }

        e && (1 & this._updateState || (this._updateState = 1 | this._updateState, this.firstUpdated(t)), this.updated(t));
      }
    }, {
      key: "_markUpdated",
      value: function _markUpdated() {
        this._changedProperties = new Map(), this._updateState = -5 & this._updateState;
      }
    }, {
      key: "_getUpdateComplete",
      value: function _getUpdateComplete() {
        return this._updatePromise;
      }
    }, {
      key: "shouldUpdate",
      value: function shouldUpdate(e) {
        return !0;
      }
    }, {
      key: "update",
      value: function update(e) {
        var _this7 = this;

        void 0 !== this._reflectingProperties && this._reflectingProperties.size > 0 && (this._reflectingProperties.forEach(function (e, t) {
          return _this7._propertyToAttribute(t, _this7[t], e);
        }), this._reflectingProperties = void 0);
      }
    }, {
      key: "updated",
      value: function updated(e) {}
    }, {
      key: "firstUpdated",
      value: function firstUpdated(e) {}
    }, {
      key: "_hasConnected",
      get: function get() {
        return 32 & this._updateState;
      }
    }, {
      key: "_hasRequestedUpdate",
      get: function get() {
        return 4 & this._updateState;
      }
    }, {
      key: "hasUpdated",
      get: function get() {
        return 1 & this._updateState;
      }
    }, {
      key: "updateComplete",
      get: function get() {
        return this._getUpdateComplete();
      }
    }], [{
      key: "_ensureClassProperties",
      value: function _ensureClassProperties() {
        var _this8 = this;

        if (!this.hasOwnProperty(JSCompiler_renameProperty("_classProperties", this))) {
          this._classProperties = new Map();

          var e = Object.getPrototypeOf(this)._classProperties;

          void 0 !== e && e.forEach(function (e, t) {
            return _this8._classProperties.set(t, e);
          });
        }
      }
    }, {
      key: "createProperty",
      value: function createProperty(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : H;
        if (this._ensureClassProperties(), this._classProperties.set(e, t), t.noAccessor || this.prototype.hasOwnProperty(e)) return;
        var n = "symbol" == typeof e ? Symbol() : "__".concat(e);
        Object.defineProperty(this.prototype, e, {
          get: function get() {
            return this[n];
          },
          set: function set(t) {
            var r = this[e];
            this[n] = t, this._requestUpdate(e, r);
          },
          configurable: !0,
          enumerable: !0
        });
      }
    }, {
      key: "finalize",
      value: function finalize() {
        var e = Object.getPrototypeOf(this);

        if (e.hasOwnProperty("finalized") || e.finalize(), this.finalized = !0, this._ensureClassProperties(), this._attributeToPropertyMap = new Map(), this.hasOwnProperty(JSCompiler_renameProperty("properties", this))) {
          var _e22 = this.properties,
              t = [].concat(_toConsumableArray(Object.getOwnPropertyNames(_e22)), _toConsumableArray("function" == typeof Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(_e22) : []));

          var _iterator5 = _createForOfIteratorHelper(t),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _n10 = _step5.value;
              this.createProperty(_n10, _e22[_n10]);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      }
    }, {
      key: "_attributeNameForProperty",
      value: function _attributeNameForProperty(e, t) {
        var n = t.attribute;
        return !1 === n ? void 0 : "string" == typeof n ? n : "string" == typeof e ? e.toLowerCase() : void 0;
      }
    }, {
      key: "_valueHasChanged",
      value: function _valueHasChanged(e, t) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : q;
        return n(e, t);
      }
    }, {
      key: "_propertyValueFromAttribute",
      value: function _propertyValueFromAttribute(e, t) {
        var n = t.type,
            r = t.converter || B,
            o = "function" == typeof r ? r : r.fromAttribute;
        return o ? o(e, n) : e;
      }
    }, {
      key: "_propertyValueToAttribute",
      value: function _propertyValueToAttribute(e, t) {
        if (void 0 === t.reflect) return;
        var n = t.type,
            r = t.converter;
        return (r && r.toAttribute || B.toAttribute)(e, n);
      }
    }, {
      key: "observedAttributes",
      get: function get() {
        var _this9 = this;

        this.finalize();
        var e = [];
        return this._classProperties.forEach(function (t, n) {
          var r = _this9._attributeNameForProperty(n, t);

          void 0 !== r && (_this9._attributeToPropertyMap.set(r, n), e.push(r));
        }), e;
      }
    }]);

    return K;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  K.finalized = !0;
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */

  var Y = function Y(e) {
    return function (t) {
      return "function" == typeof t ? function (e, t) {
        return window.customElements.define(e, t), t;
      }(e, t) : function (e, t) {
        var n = t.kind,
            r = t.elements;
        return {
          kind: n,
          elements: r,
          finisher: function finisher(t) {
            window.customElements.define(e, t);
          }
        };
      }(e, t);
    };
  },
      J = function J(e, t) {
    return "method" === t.kind && t.descriptor && !("value" in t.descriptor) ? Object.assign({}, t, {
      finisher: function finisher(n) {
        n.createProperty(t.key, e);
      }
    }) : {
      kind: "field",
      key: Symbol(),
      placement: "own",
      descriptor: {},
      initializer: function initializer() {
        "function" == typeof t.initializer && (this[t.key] = t.initializer.call(this));
      },
      finisher: function finisher(n) {
        n.createProperty(t.key, e);
      }
    };
  };

  function Q(e) {
    return function (t, n) {
      return void 0 !== n ? function (e, t, n) {
        t.constructor.createProperty(n, e);
      }(e, t, n) : J(e, t);
    };
  }
  /**
      @license
      Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
      This code may only be used under the BSD style license found at
      http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
      http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
      found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
      part of the polymer project is also subject to an additional IP rights grant
      found at http://polymer.github.io/PATENTS.txt
      */


  var Z = "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
      X = Symbol();

  var ee = /*#__PURE__*/function () {
    function ee(e, t) {
      _classCallCheck(this, ee);

      if (t !== X) throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
      this.cssText = e;
    }

    _createClass(ee, [{
      key: "toString",
      value: function toString() {
        return this.cssText;
      }
    }, {
      key: "styleSheet",
      get: function get() {
        return void 0 === this._styleSheet && (Z ? (this._styleSheet = new CSSStyleSheet(), this._styleSheet.replaceSync(this.cssText)) : this._styleSheet = null), this._styleSheet;
      }
    }]);

    return ee;
  }();
  /**
       * @license
       * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
       * This code may only be used under the BSD style license found at
       * http://polymer.github.io/LICENSE.txt
       * The complete set of authors may be found at
       * http://polymer.github.io/AUTHORS.txt
       * The complete set of contributors may be found at
       * http://polymer.github.io/CONTRIBUTORS.txt
       * Code distributed by Google as part of the polymer project is also
       * subject to an additional IP rights grant found at
       * http://polymer.github.io/PATENTS.txt
       */


  (window.litElementVersions || (window.litElementVersions = [])).push("2.2.1");

  var te = function te(e) {
    return e.flat ? e.flat(1 / 0) : function e(t) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      for (var _r8 = 0, _o6 = t.length; _r8 < _o6; _r8++) {
        var _o7 = t[_r8];
        Array.isArray(_o7) ? e(_o7, n) : n.push(_o7);
      }

      return n;
    }(e);
  };

  var ne = /*#__PURE__*/function (_K) {
    _inherits(ne, _K);

    var _super4 = _createSuper(ne);

    function ne() {
      _classCallCheck(this, ne);

      return _super4.apply(this, arguments);
    }

    _createClass(ne, [{
      key: "initialize",
      value: function initialize() {
        _get(_getPrototypeOf(ne.prototype), "initialize", this).call(this), this.renderRoot = this.createRenderRoot(), window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot && this.adoptStyles();
      }
    }, {
      key: "createRenderRoot",
      value: function createRenderRoot() {
        return this.attachShadow({
          mode: "open"
        });
      }
    }, {
      key: "adoptStyles",
      value: function adoptStyles() {
        var e = this.constructor._styles;
        0 !== e.length && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow ? Z ? this.renderRoot.adoptedStyleSheets = e.map(function (e) {
          return e.styleSheet;
        }) : this._needsShimAdoptedStyleSheets = !0 : window.ShadyCSS.ScopingShim.prepareAdoptedCssText(e.map(function (e) {
          return e.cssText;
        }), this.localName));
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(ne.prototype), "connectedCallback", this).call(this), this.hasUpdated && void 0 !== window.ShadyCSS && window.ShadyCSS.styleElement(this);
      }
    }, {
      key: "update",
      value: function update(e) {
        var _this10 = this;

        _get(_getPrototypeOf(ne.prototype), "update", this).call(this, e);

        var t = this.render();
        t instanceof b && this.constructor.render(t, this.renderRoot, {
          scopeName: this.localName,
          eventContext: this
        }), this._needsShimAdoptedStyleSheets && (this._needsShimAdoptedStyleSheets = !1, this.constructor._styles.forEach(function (e) {
          var t = document.createElement("style");
          t.textContent = e.cssText, _this10.renderRoot.appendChild(t);
        }));
      }
    }, {
      key: "render",
      value: function render() {}
    }], [{
      key: "finalize",
      value: function finalize() {
        _get(_getPrototypeOf(ne), "finalize", this).call(this), this._styles = this.hasOwnProperty(JSCompiler_renameProperty("styles", this)) ? this._getUniqueStyles() : this._styles || [];
      }
    }, {
      key: "_getUniqueStyles",
      value: function _getUniqueStyles() {
        var e = this.styles,
            t = [];

        if (Array.isArray(e)) {
          te(e).reduceRight(function (e, t) {
            return e.add(t), e;
          }, new Set()).forEach(function (e) {
            return t.unshift(e);
          });
        } else e && t.push(e);

        return t;
      }
    }]);

    return ne;
  }(K);

  ne.finalized = !0, ne.render = function (e, t, n) {
    if (!n || "object" != typeof n || !n.scopeName) throw new Error("The `scopeName` option is required.");
    var r = n.scopeName,
        o = M.has(t),
        a = D && 11 === t.nodeType && !!t.host,
        s = a && !$.has(r),
        c = s ? document.createDocumentFragment() : t;

    if (function (e, t, n) {
      var r = M.get(t);
      void 0 === r && (i(t, t.firstChild), M.set(t, r = new S(Object.assign({
        templateFactory: j
      }, n))), r.appendInto(t)), r.setValue(e), r.commit();
    }(e, c, Object.assign({
      templateFactory: V(r)
    }, n)), s) {
      var _e23 = M.get(c);

      M.delete(c);

      var _n11 = _e23.value instanceof y ? _e23.value.template : void 0;

      z(r, c, _n11), i(t, t.firstChild), t.appendChild(c), M.set(t, _e23);
    }

    !o && a && window.ShadyCSS.styleElement(t.host);
  };

  var re,
      oe = function (e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }(function (e) {
    e.exports = function (e) {
      var t = {};

      function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          configurable: !1,
          enumerable: !0,
          get: r
        });
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "/", n(n.s = 73);
    }([function (e, t) {
      e.exports = "object" == typeof window && window && window.Math == Math ? window : "object" == typeof self && self && self.Math == Math ? self : Function("return this")();
    }, function (e, t, n) {
      var r = n(20)("wks"),
          o = n(58),
          i = n(0).Symbol,
          a = n(115);

      e.exports = function (e) {
        return r[e] || (r[e] = a && i[e] || (a ? i : o)("Symbol." + e));
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        n.d(t, "version", function () {
          return a;
        }), n.d(t, "DOM", function () {
          return P;
        }), n.d(t, "Children", function () {
          return E;
        }), n.d(t, "render", function () {
          return b;
        }), n.d(t, "createClass", function () {
          return W;
        }), n.d(t, "createPortal", function () {
          return x;
        }), n.d(t, "createFactory", function () {
          return O;
        }), n.d(t, "createElement", function () {
          return N;
        }), n.d(t, "cloneElement", function () {
          return I;
        }), n.d(t, "isValidElement", function () {
          return R;
        }), n.d(t, "findDOMNode", function () {
          return D;
        }), n.d(t, "unmountComponentAtNode", function () {
          return S;
        }), n.d(t, "Component", function () {
          return K;
        }), n.d(t, "PureComponent", function () {
          return Y;
        }), n.d(t, "unstable_renderSubtreeIntoContainer", function () {
          return w;
        }), n.d(t, "unstable_batchedUpdates", function () {
          return J;
        }), n.d(t, "__spread", function () {
          return F;
        });
        var r = n(4),
            o = n.n(r);
        n.d(t, "PropTypes", function () {
          return o.a;
        });
        var i = n(81),
            a = "15.1.0",
            s = "a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan".split(" "),
            c = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
            u = "undefined" != typeof Symbol && Symbol.for ? Symbol.for("__preactCompatWrapper") : "__preactCompatWrapper",
            l = {
          constructor: 1,
          render: 1,
          shouldComponentUpdate: 1,
          componentWillReceiveProps: 1,
          componentWillUpdate: 1,
          componentDidUpdate: 1,
          componentWillMount: 1,
          componentDidMount: 1,
          componentWillUnmount: 1,
          componentDidUnmount: 1
        },
            d = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/,
            p = {},
            f = !1;

        try {
          f = "production" !== e.env.NODE_ENV;
        } catch (e) {}

        function h() {
          return null;
        }

        var m = Object(i.c)("a", null).constructor;
        m.prototype.$$typeof = c, m.prototype.preactCompatUpgraded = !1, m.prototype.preactCompatNormalized = !1, Object.defineProperty(m.prototype, "type", {
          get: function get() {
            return this.nodeName;
          },
          set: function set(e) {
            this.nodeName = e;
          },
          configurable: !0
        }), Object.defineProperty(m.prototype, "props", {
          get: function get() {
            return this.attributes;
          },
          set: function set(e) {
            this.attributes = e;
          },
          configurable: !0
        });
        var y = i.d.event;

        i.d.event = function (e) {
          return y && (e = y(e)), e.persist = Object, e.nativeEvent = e, e;
        };

        var v = i.d.vnode;

        function b(e, t, n) {
          var r = t && t._preactCompatRendered && t._preactCompatRendered.base;
          r && r.parentNode !== t && (r = null), !r && t && (r = t.firstElementChild);

          for (var o = t.childNodes.length; o--;) {
            t.childNodes[o] !== r && t.removeChild(t.childNodes[o]);
          }

          var a = Object(i.e)(e, t, r);
          return t && (t._preactCompatRendered = a && (a._component || {
            base: a
          })), "function" == typeof n && n(), a && a._component || a;
        }

        i.d.vnode = function (e) {
          if (!e.preactCompatUpgraded) {
            e.preactCompatUpgraded = !0;
            var t = e.nodeName,
                n = e.attributes = null == e.attributes ? {} : F({}, e.attributes);
            "function" == typeof t ? (!0 === t[u] || t.prototype && "isReactComponent" in t.prototype) && (e.children && "" === String(e.children) && (e.children = void 0), e.children && (n.children = e.children), e.preactCompatNormalized || M(e), function (e) {
              var t = e.nodeName,
                  n = e.attributes;
              e.attributes = {}, t.defaultProps && F(e.attributes, t.defaultProps);
              n && F(e.attributes, n);
            }(e)) : (e.children && "" === String(e.children) && (e.children = void 0), e.children && (n.children = e.children), n.defaultValue && (n.value || 0 === n.value || (n.value = n.defaultValue), delete n.defaultValue), function (e, t) {
              var n, r, o;

              if (t) {
                for (o in t) {
                  if (n = d.test(o)) break;
                }

                if (n) for (o in r = e.attributes = {}, t) {
                  t.hasOwnProperty(o) && (r[d.test(o) ? o.replace(/([A-Z0-9])/, "-$1").toLowerCase() : o] = t[o]);
                }
              }
            }(e, n));
          }

          v && v(e);
        };

        var g = function g() {};

        function w(e, t, n, r) {
          var o = b(Object(i.c)(g, {
            context: e.context
          }, t), n),
              a = o._component || o.base;
          return r && r.call(a, o), a;
        }

        function _(e) {
          w(this, e.vnode, e.container);
        }

        function x(e, t) {
          return Object(i.c)(_, {
            vnode: e,
            container: t
          });
        }

        function S(e) {
          var t = e._preactCompatRendered && e._preactCompatRendered.base;
          return !(!t || t.parentNode !== e) && (Object(i.e)(Object(i.c)(h), e, t), !0);
        }

        g.prototype.getChildContext = function () {
          return this.props.context;
        }, g.prototype.render = function (e) {
          return e.children[0];
        };
        var C,
            k = [],
            E = {
          map: function map(e, t, n) {
            return null == e ? null : (e = E.toArray(e), n && n !== e && (t = t.bind(n)), e.map(t));
          },
          forEach: function forEach(e, t, n) {
            if (null == e) return null;
            e = E.toArray(e), n && n !== e && (t = t.bind(n)), e.forEach(t);
          },
          count: function count(e) {
            return e && e.length || 0;
          },
          only: function only(e) {
            if (1 !== (e = E.toArray(e)).length) throw new Error("Children.only() expects only one child.");
            return e[0];
          },
          toArray: function toArray(e) {
            return null == e ? [] : k.concat(e);
          }
        };

        function O(e) {
          return N.bind(null, e);
        }

        for (var P = {}, T = s.length; T--;) {
          P[s[T]] = O(s[T]);
        }

        function A(e, t) {
          for (var n = t || 0; n < e.length; n++) {
            var r = e[n];
            Array.isArray(r) ? A(r) : r && "object" == typeof r && !R(r) && (r.props && r.type || r.attributes && r.nodeName || r.children) && (e[n] = N(r.type || r.nodeName, r.props || r.attributes, r.children));
          }
        }

        function j(e) {
          var t,
              n = e[u];
          return n ? !0 === n ? e : n : (n = W({
            displayName: (t = e).displayName || t.name,
            render: function render() {
              return t(this.props, this.context);
            }
          }), Object.defineProperty(n, u, {
            configurable: !0,
            value: !0
          }), n.displayName = e.displayName, n.propTypes = e.propTypes, n.defaultProps = e.defaultProps, Object.defineProperty(e, u, {
            configurable: !0,
            value: n
          }), n);
        }

        function N() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          return A(e, 2), M(i.c.apply(void 0, e));
        }

        function M(e) {
          var t;
          e.preactCompatNormalized = !0, function (e) {
            var t = e.attributes || (e.attributes = {});
            L.enumerable = "className" in t, t.className && (t.class = t.className);
            Object.defineProperty(t, "className", L);
          }(e), "function" != typeof (t = e.nodeName) || t.prototype && t.prototype.render || (e.nodeName = j(e.nodeName));
          var n,
              r,
              o = e.attributes.ref,
              i = o && typeof o;
          return !C || "string" !== i && "number" !== i || (e.attributes.ref = (n = o, (r = C)._refProxies[n] || (r._refProxies[n] = function (e) {
            r && r.refs && (r.refs[n] = e, null === e && (delete r._refProxies[n], r = null));
          }))), function (e) {
            var t = e.nodeName,
                n = e.attributes;
            if (!n || "string" != typeof t) return;
            var r = {};

            for (var o in n) {
              r[o.toLowerCase()] = o;
            }

            r.ondoubleclick && (n.ondblclick = n[r.ondoubleclick], delete n[r.ondoubleclick]);

            if (r.onchange && ("textarea" === t || "input" === t.toLowerCase() && !/^fil|che|rad/i.test(n.type))) {
              var i = r.oninput || "oninput";
              n[i] || (n[i] = z([n[i], n[r.onchange]]), delete n[r.onchange]);
            }
          }(e), e;
        }

        function I(e, t) {
          for (var n = [], r = arguments.length - 2; r-- > 0;) {
            n[r] = arguments[r + 2];
          }

          if (!R(e)) return e;
          var o = e.attributes || e.props,
              a = Object(i.c)(e.nodeName || e.type, F({}, o), e.children || o && o.children),
              s = [a, t];
          return n && n.length ? s.push(n) : t && t.children && s.push(t.children), M(i.b.apply(void 0, s));
        }

        function R(e) {
          return e && (e instanceof m || e.$$typeof === c);
        }

        var L = {
          configurable: !0,
          get: function get() {
            return this.class;
          },
          set: function set(e) {
            this.class = e;
          }
        };

        function F(e, t) {
          for (var n = arguments, r = 1, o = void 0; r < arguments.length; r++) {
            if (o = n[r]) for (var i in o) {
              o.hasOwnProperty(i) && (e[i] = o[i]);
            }
          }

          return e;
        }

        function U(e, t) {
          for (var n in e) {
            if (!(n in t)) return !0;
          }

          for (var r in t) {
            if (e[r] !== t[r]) return !0;
          }

          return !1;
        }

        function D(e) {
          return e && (e.base || 1 === e.nodeType && e) || null;
        }

        function V() {}

        function W(e) {
          function t(e, t) {
            !function (e) {
              for (var t in e) {
                var n = e[t];
                "function" != typeof n || n.__bound || l.hasOwnProperty(t) || ((e[t] = n.bind(e)).__bound = !0);
              }
            }(this), K.call(this, e, t, p), B.call(this, e, t);
          }

          return (e = F({
            constructor: t
          }, e)).mixins && function (e, t) {
            for (var n in t) {
              t.hasOwnProperty(n) && (e[n] = z(t[n].concat(e[n] || k), "getDefaultProps" === n || "getInitialState" === n || "getChildContext" === n));
            }
          }(e, function (e) {
            for (var t = {}, n = 0; n < e.length; n++) {
              var r = e[n];

              for (var o in r) {
                r.hasOwnProperty(o) && "function" == typeof r[o] && (t[o] || (t[o] = [])).push(r[o]);
              }
            }

            return t;
          }(e.mixins)), e.statics && F(t, e.statics), e.propTypes && (t.propTypes = e.propTypes), e.defaultProps && (t.defaultProps = e.defaultProps), e.getDefaultProps && (t.defaultProps = e.getDefaultProps.call(t)), V.prototype = K.prototype, t.prototype = F(new V(), e), t.displayName = e.displayName || "Component", t;
        }

        function $(e, t, n) {
          if ("string" == typeof t && (t = e.constructor.prototype[t]), "function" == typeof t) return t.apply(e, n);
        }

        function z(e, t) {
          return function () {
            for (var n, r = arguments, o = this, i = 0; i < e.length; i++) {
              var a = $(o, e[i], r);
              if (t && null != a) for (var s in n || (n = {}), a) {
                a.hasOwnProperty(s) && (n[s] = a[s]);
              } else void 0 !== a && (n = a);
            }

            return n;
          };
        }

        function B(e, t) {
          q.call(this, e, t), this.componentWillReceiveProps = z([q, this.componentWillReceiveProps || "componentWillReceiveProps"]), this.render = z([q, H, this.render || "render", G]);
        }

        function q(e, t) {
          if (e) {
            var n = e.children;

            if (n && Array.isArray(n) && 1 === n.length && ("string" == typeof n[0] || "function" == typeof n[0] || n[0] instanceof m) && (e.children = n[0], e.children && "object" == typeof e.children && (e.children.length = 1, e.children[0] = e.children)), f) {
              var r = "function" == typeof this ? this : this.constructor,
                  i = this.propTypes || r.propTypes,
                  a = this.displayName || r.name;
              i && o.a.checkPropTypes(i, e, "prop", a);
            }
          }
        }

        function H(e) {
          C = this;
        }

        function G() {
          C === this && (C = null);
        }

        function K(e, t, n) {
          i.a.call(this, e, t), this.state = this.getInitialState ? this.getInitialState() : {}, this.refs = {}, this._refProxies = {}, n !== p && B.call(this, e, t);
        }

        function Y(e, t) {
          K.call(this, e, t);
        }

        function J(e) {
          e();
        }

        F(K.prototype = new i.a(), {
          constructor: K,
          isReactComponent: {},
          replaceState: function replaceState(e, t) {
            for (var n in this.setState(e, t), this.state) {
              n in e || delete this.state[n];
            }
          },
          getDOMNode: function getDOMNode() {
            return this.base;
          },
          isMounted: function isMounted() {
            return !!this.base;
          }
        }), V.prototype = K.prototype, Y.prototype = new V(), Y.prototype.isPureReactComponent = !0, Y.prototype.shouldComponentUpdate = function (e, t) {
          return U(this.props, e) || U(this.state, t);
        };
        var Q = {
          version: a,
          DOM: P,
          PropTypes: o.a,
          Children: E,
          render: b,
          createClass: W,
          createPortal: x,
          createFactory: O,
          createElement: N,
          cloneElement: I,
          isValidElement: R,
          findDOMNode: D,
          unmountComponentAtNode: S,
          Component: K,
          PureComponent: Y,
          unstable_renderSubtreeIntoContainer: w,
          unstable_batchedUpdates: J,
          __spread: F
        };
        t.default = Q;
      }.call(t, n(3));
    }, function (e, t) {
      var n,
          r,
          o = e.exports = {};

      function i() {
        throw new Error("setTimeout has not been defined");
      }

      function a() {
        throw new Error("clearTimeout has not been defined");
      }

      function s(e) {
        if (n === setTimeout) return setTimeout(e, 0);
        if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

        try {
          return n(e, 0);
        } catch (t) {
          try {
            return n.call(null, e, 0);
          } catch (t) {
            return n.call(this, e, 0);
          }
        }
      }

      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : i;
        } catch (e) {
          n = i;
        }

        try {
          r = "function" == typeof clearTimeout ? clearTimeout : a;
        } catch (e) {
          r = a;
        }
      }();
      var c,
          u = [],
          l = !1,
          d = -1;

      function p() {
        l && c && (l = !1, c.length ? u = c.concat(u) : d = -1, u.length && f());
      }

      function f() {
        if (!l) {
          var e = s(p);
          l = !0;

          for (var t = u.length; t;) {
            for (c = u, u = []; ++d < t;) {
              c && c[d].run();
            }

            d = -1, t = u.length;
          }

          c = null, l = !1, function (e) {
            if (r === clearTimeout) return clearTimeout(e);
            if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

            try {
              r(e);
            } catch (t) {
              try {
                return r.call(null, e);
              } catch (t) {
                return r.call(this, e);
              }
            }
          }(e);
        }
      }

      function h(e, t) {
        this.fun = e, this.array = t;
      }

      function m() {}

      o.nextTick = function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }
        u.push(new h(e, t)), 1 !== u.length || l || s(f);
      }, h.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = m, o.addListener = m, o.once = m, o.off = m, o.removeListener = m, o.removeAllListeners = m, o.emit = m, o.prependListener = m, o.prependOnceListener = m, o.listeners = function (e) {
        return [];
      }, o.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, o.cwd = function () {
        return "/";
      }, o.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, o.umask = function () {
        return 0;
      };
    }, function (e, t, n) {
      (function (t) {
        if ("production" !== t.env.NODE_ENV) {
          var r = n(42);
          e.exports = n(77)(r.isElement, !0);
        } else e.exports = n(80)();
      }).call(t, n(3));
    }, function (e, t) {
      e.exports = function (e) {
        return "object" == typeof e ? null !== e : "function" == typeof e;
      };
    }, function (e, t, n) {
      var r = n(5);

      e.exports = function (e) {
        if (!r(e)) throw TypeError(String(e) + " is not an object");
        return e;
      };
    }, function (e, t) {
      var n = {}.hasOwnProperty;

      e.exports = function (e, t) {
        return n.call(e, t);
      };
    }, function (e, t, n) {
      var r = n(14),
          o = n(35);
      e.exports = n(13) ? function (e, t, n) {
        return r.f(e, t, o(1, n));
      } : function (e, t, n) {
        return e[t] = n, e;
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.redirectToUrl = t.omit = t.noop = t.applyIOSIframeResizeHack = t.applyIOSFooterHack = t.debounce = t.fixSafariScroll = t.isElementInViewport = t.ensureMetaViewport = t.replaceExistingKeys = t.appendParamsToUrl = t.updateQueryStringParameter = t.broadcastMessage = t.callIfEmbedIdMatches = t.checkEmbedId = t.DOMAIN = void 0;
      var r = a(n(43)),
          o = n(16),
          i = a(n(44));

      function a(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      t.DOMAIN = "admin.typeform.com";

      var s = t.checkEmbedId = function (e, t) {
        return t.detail && t.detail.embedId === e;
      };

      t.callIfEmbedIdMatches = function (e, t) {
        return function (n) {
          s(t, n) && e(n);
        };
      }, t.broadcastMessage = function (e, t) {
        t.data.embedId === e && (0, i.default)(t);
      }, t.updateQueryStringParameter = function (e, t, n) {
        var r = new RegExp("([?&])" + e + "=.*?(&|$)", "i"),
            o = -1 !== n.indexOf("?") ? "&" : "?";
        return n.match(r) ? n.replace(r, "$1" + e + "=" + t + "$2") : n + o + e + "=" + t;
      }, t.appendParamsToUrl = function (e, t) {
        var n = [],
            o = (0, r.default)(e, !0),
            i = o.query,
            a = o.origin,
            s = o.pathname.replace(/\/$/, ""),
            c = Object.assign({}, i, t);
        return Object.keys(c).forEach(function (e) {
          n.push(encodeURIComponent(e) + "=" + encodeURIComponent(c[e]));
        }), "" + a + s + "?" + n.join("&");
      }, t.replaceExistingKeys = function (e, t) {
        return Object.keys(t).reduce(function (n, r) {
          var o = t[r];
          return null != o && null != e[r] && !1 !== e[r] && (n[o] = e[r]), n;
        }, {});
      }, t.ensureMetaViewport = function () {
        if (document.querySelector) {
          var e = document.querySelector("meta[name=viewport]"),
              t = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
          if (e) e.setAttribute("content", t);else {
            var n = document.createElement("meta");
            n.content = t, n.name = "viewport", document.head.appendChild(n);
          }
        }
      }, t.isElementInViewport = function (e) {
        if (window.top !== window) return !1;
        var t = e.getBoundingClientRect(),
            n = .2 * t.height,
            r = window.innerWidth || document.documentElement.clientWidth,
            o = window.innerHeight || document.documentElement.clientHeight;
        return t.top >= -n && t.left >= -n && t.bottom <= o + n && t.right <= r + n;
      }, t.fixSafariScroll = function (e) {
        !(0, o.isMobile)(navigator.userAgent) && (0, o.isSafari)(navigator.userAgent) && e.addEventListener("load", function () {
          return setTimeout(function () {
            var t = window.getComputedStyle(e).height;
            return e.setAttribute("height", e.offsetHeight + 1 + "px"), setTimeout(function () {
              e.setAttribute("height", t);
            }, 1);
          }, 1e3);
        });
      }, t.debounce = function (e, t, n) {
        var r = void 0;
        return function () {
          for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
            i[a] = arguments[a];
          }

          var s = function s() {
            r = null, e.call.apply(e, [n].concat(i));
          };

          clearTimeout(r), r = setTimeout(s, t);
        };
      }, t.applyIOSFooterHack = function (e) {
        (0, o.isIOSDevice)(navigator.userAgent) && (e.setAttribute("scrolling", "no"), e.style.height = "1px", e.style.minHeight = "100%");
      }, t.applyIOSIframeResizeHack = function (e) {
        (0, o.isIOSDevice)(navigator.userAgent) && (e.style.maxHeight = "100%", e.style.maxWidth = "100%", e.style.minHeight = "100%", e.style.minWidth = "100%", e.style.width = 0);
      }, t.noop = function () {
        return null;
      };

      t.omit = function (e, t) {
        t[e];
        return function (e, t) {
          var n = {};

          for (var r in e) {
            t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
          }

          return n;
        }(t, [e]);
      };

      t.redirectToUrl = function (e) {
        var t = e.detail.url;

        try {
          var n = document.createElement("a");
          n.href = t, document.body.appendChild(n), n.click(), document.body.removeChild(n);
        } catch (e) {}
      };
    }, function (e, t) {
      e.exports = function (e) {
        try {
          return !!e();
        } catch (e) {
          return !0;
        }
      };
    }, function (e, t) {
      var n = {}.toString;

      e.exports = function (e) {
        return n.call(e).slice(8, -1);
      };
    }, function (e, t, n) {
      var r = n(0),
          o = n(34).f,
          i = n(8),
          a = n(19),
          s = n(37),
          c = n(108),
          u = n(59);

      e.exports = function (e, t) {
        var n,
            l,
            d,
            p,
            f,
            h = e.target,
            m = e.global,
            y = e.stat;
        if (n = m ? r : y ? r[h] || s(h, {}) : (r[h] || {}).prototype) for (l in t) {
          if (p = t[l], d = e.noTargetGet ? (f = o(n, l)) && f.value : n[l], !u(m ? l : h + (y ? "." : "#") + l, e.forced) && void 0 !== d) {
            if (typeof p == typeof d) continue;
            c(p, d);
          }

          (e.sham || d && d.sham) && i(p, "sham", !0), a(n, l, p, e);
        }
      };
    }, function (e, t, n) {
      e.exports = !n(10)(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (e, t, n) {
      var r = n(13),
          o = n(56),
          i = n(6),
          a = n(55),
          s = Object.defineProperty;
      t.f = r ? s : function (e, t, n) {
        if (i(e), t = a(t, !0), i(n), o) try {
          return s(e, t, n);
        } catch (e) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
        return "value" in n && (e[t] = n.value), e;
      };
    }, function (e, t) {
      e.exports = {};
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      t.isScreenBig = function () {
        return window.screen.width >= 1024 && window.screen.height >= 768;
      }, t.isMobile = function (e) {
        return /mobile|tablet|android/i.test(e.toLowerCase());
      }, t.isSafari = function (e) {
        return /^((?!chrome|android).)*safari/i.test(e.toLowerCase());
      }, t.isIOSDevice = function (e) {
        return /ip(hone|od|ad)/i.test(e.toLowerCase());
      };
    }, function (e, t, n) {
      (function (e) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.keyframes = t.injectGlobal = t.css = void 0;
        var r = a(n(2)),
            o = a(n(88)),
            i = a(n(93));

        function a(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        var s = void 0 !== e ? e : {},
            c = (0, o.default)(s);
        t.css = c.css, t.injectGlobal = c.injectGlobal, t.keyframes = c.keyframes;
        t.default = (0, i.default)(c, r.default);
      }).call(t, n(25));
    }, function (e, t, n) {
      var r = n(27),
          o = n(28);

      e.exports = function (e) {
        return r(o(e));
      };
    }, function (e, t, n) {
      var r = n(0),
          o = n(8),
          i = n(7),
          a = n(37),
          s = n(57),
          c = n(22),
          u = c.get,
          l = c.enforce,
          d = String(s).split("toString");
      n(20)("inspectSource", function (e) {
        return s.call(e);
      }), (e.exports = function (e, t, n, s) {
        var c = !!s && !!s.unsafe,
            u = !!s && !!s.enumerable,
            p = !!s && !!s.noTargetGet;
        "function" == typeof n && ("string" != typeof t || i(n, "name") || o(n, "name", t), l(n).source = d.join("string" == typeof t ? t : "")), e !== r ? (c ? !p && e[t] && (u = !0) : delete e[t], u ? e[t] = n : o(e, t, n)) : u ? e[t] = n : a(t, n);
      })(Function.prototype, "toString", function () {
        return "function" == typeof this && u(this).source || s.call(this);
      });
    }, function (e, t, n) {
      var r = n(0),
          o = n(37),
          i = r["__core-js_shared__"] || o("__core-js_shared__", {});
      (e.exports = function (e, t) {
        return i[e] || (i[e] = void 0 !== t ? t : {});
      })("versions", []).push({
        version: "3.0.1",
        mode: n(21) ? "pure" : "global",
        copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
      });
    }, function (e, t) {
      e.exports = !1;
    }, function (e, t, n) {
      var r,
          o,
          i,
          a = n(107),
          s = n(5),
          c = n(8),
          u = n(7),
          l = n(38),
          d = n(31),
          p = n(0).WeakMap;

      if (a) {
        var f = new p(),
            h = f.get,
            m = f.has,
            y = f.set;
        r = function r(e, t) {
          return y.call(f, e, t), t;
        }, o = function o(e) {
          return h.call(f, e) || {};
        }, i = function i(e) {
          return m.call(f, e);
        };
      } else {
        var v = l("state");
        d[v] = !0, r = function r(e, t) {
          return c(e, v, t), t;
        }, o = function o(e) {
          return u(e, v) ? e[v] : {};
        }, i = function i(e) {
          return u(e, v);
        };
      }

      e.exports = {
        set: r,
        get: o,
        has: i,
        enforce: function enforce(e) {
          return i(e) ? o(e) : r(e, {});
        },
        getterFor: function getterFor(e) {
          return function (t) {
            var n;
            if (!s(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
            return n;
          };
        }
      };
    }, function (e, t) {
      e.exports = function (e) {
        if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
        return e;
      };
    }, function (e, t, n) {
      e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function (e, t) {
      var n;

      n = function () {
        return this;
      }();

      try {
        n = n || Function("return this")() || (0, eval)("this");
      } catch (e) {
        "object" == typeof window && (n = window);
      }

      e.exports = n;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      },
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
          i = n(2),
          a = u(i),
          s = u(n(4)),
          c = n(9);

      function u(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      var l = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

          return n.iframeRef = null, n.handleLoad = n.handleLoad.bind(n), n.getRef = n.getRef.bind(n), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), o(t, [{
          key: "shouldComponentUpdate",
          value: function value(e) {
            return e.src !== this.props.src;
          }
        }, {
          key: "getRef",
          value: function value(e) {
            this.iframeRef = e;
          }
        }, {
          key: "handleLoad",
          value: function value() {
            var e = this;
            this.iframeRef.style.height = this.iframeRef.offsetHeight + 1 + "px", setTimeout(function () {
              e.iframeRef.style.height = "", (0, c.applyIOSFooterHack)(e.iframeRef), (0, c.applyIOSIframeResizeHack)(e.iframeRef), e.props.onLoad && e.props.onLoad(e.iframeRef);
            }, 1);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.style,
                n = function (e, t) {
              var n = {};

              for (var r in e) {
                t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
              }

              return n;
            }(e, ["style"]);

            return a.default.createElement("iframe", r({}, n, {
              "data-qa": "iframe",
              frameBorder: "0",
              height: "100%",
              onLoad: this.handleLoad,
              ref: this.getRef,
              src: this.props.src,
              style: r({
                border: 0
              }, t),
              width: "100%"
            }));
          }
        }]), t;
      }(i.Component);

      l.propTypes = {
        src: s.default.string.isRequired,
        onLoad: s.default.func,
        style: s.default.object
      }, t.default = l;
    }, function (e, t, n) {
      var r = n(10),
          o = n(11),
          i = "".split;
      e.exports = r(function () {
        return !Object("z").propertyIsEnumerable(0);
      }) ? function (e) {
        return "String" == o(e) ? i.call(e, "") : Object(e);
      } : Object;
    }, function (e, t) {
      e.exports = function (e) {
        if (null == e) throw TypeError("Can't call method on " + e);
        return e;
      };
    }, function (e, t, n) {
      var r = n(30),
          o = Math.min;

      e.exports = function (e) {
        return e > 0 ? o(r(e), 9007199254740991) : 0;
      };
    }, function (e, t) {
      var n = Math.ceil,
          r = Math.floor;

      e.exports = function (e) {
        return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
      };
    }, function (e, t) {
      e.exports = {};
    }, function (e, t) {
      e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }, function (e, t, n) {
      var r = n(28);

      e.exports = function (e) {
        return Object(r(e));
      };
    }, function (e, t, n) {
      var r = n(13),
          o = n(54),
          i = n(35),
          a = n(18),
          s = n(55),
          c = n(7),
          u = n(56),
          l = Object.getOwnPropertyDescriptor;
      t.f = r ? l : function (e, t) {
        if (e = a(e), t = s(t, !0), u) try {
          return l(e, t);
        } catch (e) {}
        if (c(e, t)) return i(!o.f.call(e, t), e[t]);
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        return {
          enumerable: !(1 & e),
          configurable: !(2 & e),
          writable: !(4 & e),
          value: t
        };
      };
    }, function (e, t, n) {
      var r = n(5),
          o = n(0).document,
          i = r(o) && r(o.createElement);

      e.exports = function (e) {
        return i ? o.createElement(e) : {};
      };
    }, function (e, t, n) {
      var r = n(0),
          o = n(8);

      e.exports = function (e, t) {
        try {
          o(r, e, t);
        } catch (n) {
          r[e] = t;
        }

        return t;
      };
    }, function (e, t, n) {
      var r = n(20)("keys"),
          o = n(58);

      e.exports = function (e) {
        return r[e] || (r[e] = o(e));
      };
    }, function (e, t, n) {
      var r = n(23);

      e.exports = function (e, t, n) {
        if (r(e), void 0 === t) return e;

        switch (n) {
          case 0:
            return function () {
              return e.call(t);
            };

          case 1:
            return function (n) {
              return e.call(t, n);
            };

          case 2:
            return function (n, r) {
              return e.call(t, n, r);
            };

          case 3:
            return function (n, r, o) {
              return e.call(t, n, r, o);
            };
        }

        return function () {
          return e.apply(t, arguments);
        };
      };
    }, function (e, t, n) {
      var r = n(14).f,
          o = n(7),
          i = n(1)("toStringTag");

      e.exports = function (e, t, n) {
        e && !o(e = n ? e : e.prototype, i) && r(e, i, {
          configurable: !0,
          value: t
        });
      };
    }, function (e, t, n) {
      e.exports = n(0);
    }, function (e, t, n) {
      (function (t) {
        "production" === t.env.NODE_ENV ? e.exports = n(75) : e.exports = n(76);
      }).call(t, n(3));
    }, function (e, t, n) {
      (function (t) {
        var r = n(82),
            o = n(83),
            i = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
            a = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//,
            s = [["#", "hash"], ["?", "query"], function (e) {
          return e.replace("\\", "/");
        }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d+)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]],
            c = {
          hash: 1,
          query: 1
        };

        function u(e) {
          var n,
              r = ("undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {}).location || {},
              o = {},
              i = typeof (e = e || r);
          if ("blob:" === e.protocol) o = new d(unescape(e.pathname), {});else if ("string" === i) for (n in o = new d(e, {}), c) {
            delete o[n];
          } else if ("object" === i) {
            for (n in e) {
              n in c || (o[n] = e[n]);
            }

            void 0 === o.slashes && (o.slashes = a.test(e.href));
          }
          return o;
        }

        function l(e) {
          var t = i.exec(e);
          return {
            protocol: t[1] ? t[1].toLowerCase() : "",
            slashes: !!t[2],
            rest: t[3]
          };
        }

        function d(e, t, n) {
          if (!(this instanceof d)) return new d(e, t, n);
          var i,
              a,
              c,
              p,
              f,
              h,
              m = s.slice(),
              y = typeof t,
              v = this,
              b = 0;

          for ("object" !== y && "string" !== y && (n = t, t = null), n && "function" != typeof n && (n = o.parse), t = u(t), i = !(a = l(e || "")).protocol && !a.slashes, v.slashes = a.slashes || i && t.slashes, v.protocol = a.protocol || t.protocol || "", e = a.rest, a.slashes || (m[3] = [/(.*)/, "pathname"]); b < m.length; b++) {
            "function" != typeof (p = m[b]) ? (c = p[0], h = p[1], c != c ? v[h] = e : "string" == typeof c ? ~(f = e.indexOf(c)) && ("number" == typeof p[2] ? (v[h] = e.slice(0, f), e = e.slice(f + p[2])) : (v[h] = e.slice(f), e = e.slice(0, f))) : (f = c.exec(e)) && (v[h] = f[1], e = e.slice(0, f.index)), v[h] = v[h] || i && p[3] && t[h] || "", p[4] && (v[h] = v[h].toLowerCase())) : e = p(e);
          }

          n && (v.query = n(v.query)), i && t.slashes && "/" !== v.pathname.charAt(0) && ("" !== v.pathname || "" !== t.pathname) && (v.pathname = function (e, t) {
            for (var n = (t || "/").split("/").slice(0, -1).concat(e.split("/")), r = n.length, o = n[r - 1], i = !1, a = 0; r--;) {
              "." === n[r] ? n.splice(r, 1) : ".." === n[r] ? (n.splice(r, 1), a++) : a && (0 === r && (i = !0), n.splice(r, 1), a--);
            }

            return i && n.unshift(""), "." !== o && ".." !== o || n.push(""), n.join("/");
          }(v.pathname, t.pathname)), r(v.port, v.protocol) || (v.host = v.hostname, v.port = ""), v.username = v.password = "", v.auth && (p = v.auth.split(":"), v.username = p[0] || "", v.password = p[1] || ""), v.origin = v.protocol && v.host && "file:" !== v.protocol ? v.protocol + "//" + v.host : "null", v.href = v.toString();
        }

        d.prototype = {
          set: function set(e, t, n) {
            var i = this;

            switch (e) {
              case "query":
                "string" == typeof t && t.length && (t = (n || o.parse)(t)), i[e] = t;
                break;

              case "port":
                i[e] = t, r(t, i.protocol) ? t && (i.host = i.hostname + ":" + t) : (i.host = i.hostname, i[e] = "");
                break;

              case "hostname":
                i[e] = t, i.port && (t += ":" + i.port), i.host = t;
                break;

              case "host":
                i[e] = t, /:\d+$/.test(t) ? (t = t.split(":"), i.port = t.pop(), i.hostname = t.join(":")) : (i.hostname = t, i.port = "");
                break;

              case "protocol":
                i.protocol = t.toLowerCase(), i.slashes = !n;
                break;

              case "pathname":
              case "hash":
                if (t) {
                  var a = "pathname" === e ? "/" : "#";
                  i[e] = t.charAt(0) !== a ? a + t : t;
                } else i[e] = t;

                break;

              default:
                i[e] = t;
            }

            for (var c = 0; c < s.length; c++) {
              var u = s[c];
              u[4] && (i[u[1]] = i[u[1]].toLowerCase());
            }

            return i.origin = i.protocol && i.host && "file:" !== i.protocol ? i.protocol + "//" + i.host : "null", i.href = i.toString(), i;
          },
          toString: function toString(e) {
            e && "function" == typeof e || (e = o.stringify);
            var t,
                n = this,
                r = n.protocol;
            r && ":" !== r.charAt(r.length - 1) && (r += ":");
            var i = r + (n.slashes ? "//" : "");
            return n.username && (i += n.username, n.password && (i += ":" + n.password), i += "@"), i += n.host + n.pathname, (t = "object" == typeof n.query ? e(n.query) : n.query) && (i += "?" !== t.charAt(0) ? "?" + t : t), n.hash && (i += n.hash), i;
          }
        }, d.extractProtocol = l, d.location = u, d.qs = o, e.exports = d;
      }).call(t, n(25));
    }, function (e, t, n) {
      (function (e) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = a(n(84)),
            o = a(n(85)),
            i = a(n(86));

        function a(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        var s = /(\.typeform)\.(com|io)$/;

        t.default = function (t) {
          if (!function (t) {
            if ("development" === e.env.NODE_ENV) return !0;
            var n = new RegExp("^(?:f|ht)tp(?:s)?://([^/]+)", "im"),
                r = t.origin.match(n);
            if (!(r && r.length > 1)) return !1;
            var o = r[1].toString();
            return !!s.test(o);
          }(t = t.originalEvent || t)) return !1;
          (0, i.default)(t.data) ? window.location.href = t.data : (0, o.default)(t.data) && t.data.hasOwnProperty("type") ? window.dispatchEvent(new r.default(t.data.type, {
            detail: t.data
          })) : window.dispatchEvent(new r.default(t.data));
        };
      }).call(t, n(3));
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function () {
        return Math.random().toString(36).substr(2, 5);
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.POPUP_MODES = t.DRAWER_RIGHT = t.DRAWER = t.POPUP = t.DEFAULT_AUTOCLOSE_TIMEOUT = void 0;

      var r,
          o = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      },
          i = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
          a = n(2),
          s = m(a),
          c = m(n(4)),
          u = m(n(87)),
          l = m(n(17)),
          d = m(n(26)),
          p = m(n(95)),
          f = n(9),
          h = m(n(97));

      function m(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function y(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      var v = t.DEFAULT_AUTOCLOSE_TIMEOUT = 5,
          b = t.POPUP = "popup",
          g = t.DRAWER = "drawer_left",
          w = t.DRAWER_RIGHT = "drawer_right",
          _ = (t.POPUP_MODES = (y(r = {}, b, "popup-blank"), y(r, g, "popup-classic"), y(r, w, "popup-drawer"), r), (0, l.default)("div", {
        target: "e1o3ysfi0"
      })("visibility:", function (e) {
        return e.open ? "visible" : "hidden";
      }, ";opacity:", function (e) {
        return e.open ? 1 : 0;
      }, ";position:", function (e) {
        return e.isContained ? "absolute" : "fixed";
      }, ";max-width:100%;z-index:10001;")),
          x = (0, l.default)("div", {
        target: "e1o3ysfi1"
      })("visibility:", function (e) {
        return e.appearing ? "hidden" : "visible";
      }, ";opacity:", function (e) {
        return e.appearing ? 0 : 1;
      }, ";transition:opacity 200ms ease,visibility 0s linear ", function (e) {
        return e.appearing ? "200ms" : "0s";
      }, ";background:rgba(0,0,0,0.85);position:", function (e) {
        return e.isContained ? "absolute" : "fixed";
      }, ";overflow:", function (e) {
        return e.isContained ? "hidden" : "auto";
      }, ";left:0;top:0;right:0;bottom:0;z-index:10001;min-height:100%;"),
          S = (0, l.default)(_, {
        target: "e1o3ysfi2"
      })("width:", function (e) {
        return e.isContained ? "calc(100% - 80px)" : "calc(100vw - 80px)";
      }, ";height:", function (e) {
        return e.isContained ? "calc(100% - 80px)" : "calc(100vh - 80px)";
      }, ";top:40px;left:40px;transition:all 300ms ease-out;"),
          C = (0, l.default)(_, {
        target: "e1o3ysfi3"
      })("transition:all 400ms ease-out;width:", function (e) {
        return e.width;
      }, "px;height:100%;top:0;"),
          k = (0, l.default)(C, {
        target: "e1o3ysfi4"
      })("left:", function (e) {
        return e.open ? 0 : -(e.width - 30);
      }, "px;"),
          E = (0, l.default)(C, {
        target: "e1o3ysfi5"
      })("right:", function (e) {
        return e.open ? 0 : -(e.width - 30);
      }, "px;"),
          O = (0, l.default)("img", {
        target: "e1o3ysfi6"
      })("position:absolute;padding:8px;cursor:pointer;width:initial;max-width:initial;"),
          P = (0, l.default)(O, {
        target: "e1o3ysfi7"
      })("top:-34px;right:-34px;"),
          T = (0, l.default)(O, {
        target: "e1o3ysfi8"
      })("top:12px;right:-38px;"),
          A = (0, l.default)(O, {
        target: "e1o3ysfi9"
      })("top:12px;left:-38px;right:auto;"),
          j = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

          return n.state = {
            frameAnimate: !1,
            iframeLoaded: !1,
            popupAnimate: !0,
            transitionEnded: !1
          }, n.handleMessage = n.handleMessage.bind(n), n.handleKeyDown = (0, f.callIfEmbedIdMatches)(n.handleKeyDown.bind(n), n.props.embedId), n.handleAutoClose = (0, f.callIfEmbedIdMatches)(n.handleAutoClose.bind(n), n.props.embedId), n.handleClose = (0, f.callIfEmbedIdMatches)(n.handleClose.bind(n), n.props.embedId), n.handleFormSubmit = (0, f.callIfEmbedIdMatches)(n.handleFormSubmit.bind(n), n.props.embedId), n.handleIframeLoad = n.handleIframeLoad.bind(n), n.handleAnimateBeforeClose = n.handleAnimateBeforeClose.bind(n), n.handleTransitionEnd = n.handleTransitionEnd.bind(n), n.setWrapperRef = n.setWrapperRef.bind(n), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), i(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = this;
            window.addEventListener("message", this.handleMessage), window.addEventListener("keydown", this.handleKeyDown), window.addEventListener("form-close", this.handleClose), window.addEventListener("form-submit", this.handleFormSubmit), window.addEventListener("embed-auto-close-popup", this.handleAutoClose), window.addEventListener("redirect-after-submit", f.redirectToUrl), window.addEventListener("thank-you-screen-redirect", f.redirectToUrl), setTimeout(function () {
              e.setState({
                popupAnimate: !1
              });
            }, 100);
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            window.removeEventListener("message", this.handleMessage), window.removeEventListener("keydown", this.handleKeyDown), window.removeEventListener("form-close", this.handleClose), window.removeEventListener("form-submit", this.handleFormSubmit), window.removeEventListener("embed-auto-close-popup", this.handleAutoClose), window.removeEventListener("redirect-after-submit", f.redirectToUrl), window.removeEventListener("thank-you-screen-redirect", f.redirectToUrl);
          }
        }, {
          key: "setWrapperRef",
          value: function value(e) {
            this.wrapper = e;
          }
        }, {
          key: "getWrapperComponent",
          value: function value(e) {
            return e === w ? E : e === g ? k : S;
          }
        }, {
          key: "getCloseImage",
          value: function value(e) {
            return e === w ? A : e === g ? T : P;
          }
        }, {
          key: "handleIframeLoad",
          value: function value(e) {
            var t = this;
            this.setState({
              iframeLoaded: !0
            }, function () {
              setTimeout(function () {
                t.setState({
                  frameAnimate: !0
                }), e && e.contentWindow && e.contentWindow.focus();
              }, 500);
            });
          }
        }, {
          key: "handleAnimateBeforeClose",
          value: function value() {
            var e = this;
            this.setState({
              frameAnimate: !1,
              popupAnimate: !1
            }, function () {
              setTimeout(function () {
                e.setState({
                  popupAnimate: !0
                }, function () {
                  setTimeout(e.props.onClose, 400);
                });
              }, 400);
            });
          }
        }, {
          key: "handleClose",
          value: function value() {
            this.handleAnimateBeforeClose();
          }
        }, {
          key: "handleKeyDown",
          value: function value(e) {
            "Escape" !== e.code && 27 !== e.which || this.handleAnimateBeforeClose();
          }
        }, {
          key: "handleMessage",
          value: function value(e) {
            (0, f.broadcastMessage)(this.props.embedId, e);
          }
        }, {
          key: "handleAutoClose",
          value: function value(e) {
            var t = this,
                n = e.detail.isProPlus || e.detail.canSetAutocloseDelay,
                r = this.props.options,
                o = r.isAutoCloseEnabled,
                i = r.autoClose;
            o && setTimeout(function () {
              t.handleAnimateBeforeClose();
            }, 1e3 * (n ? i : v));
          }
        }, {
          key: "handleTransitionEnd",
          value: function value(e) {
            e.target === this.wrapper && this.setState({
              transitionEnded: this.state.frameAnimate
            });
          }
        }, {
          key: "handleFormSubmit",
          value: function value() {
            this.props.options.onSubmit && this.props.options.onSubmit();
          }
        }, {
          key: "render",
          value: function value() {
            var e = null,
                t = this.props,
                n = t.embedId,
                r = t.options,
                i = t.url,
                a = r.drawerWidth,
                c = r.hideScrollbars,
                l = r.isContained,
                m = r.mode;
            c && (e = {
              width: "calc(100% + " + (0, u.default)() + "px)"
            }), m === b && (e = o({}, e, {
              WebkitMaskImage: "-webkit-radial-gradient(circle, white, black)",
              WebkitTransform: "translateZ(0)"
            }));
            var y = (0, f.updateQueryStringParameter)("typeform-embed-id", n, i),
                v = this.getWrapperComponent(m),
                g = this.getCloseImage(m);
            return s.default.createElement(x, {
              appearing: this.state.popupAnimate,
              isContained: l
            }, s.default.createElement(p.default, {
              stopped: this.state.iframeLoaded
            }), s.default.createElement(v, {
              "data-qa": "popup-mode-" + m,
              innerRef: this.setWrapperRef,
              isContained: l,
              mode: m,
              onTransitionEnd: this.handleTransitionEnd,
              open: this.state.frameAnimate,
              width: a
            }, this.state.iframeLoaded && s.default.createElement(g, {
              alt: "close-typeform",
              "data-qa": "popup-close-button",
              mode: m,
              onClick: this.handleAnimateBeforeClose,
              src: h.default
            }), s.default.createElement(d.default, {
              onLoad: this.handleIframeLoad,
              src: y,
              style: e
            })));
          }
        }]), t;
      }(a.Component);

      j.propTypes = {
        embedId: c.default.string,
        height: c.default.number,
        onClose: c.default.func,
        options: c.default.object.isRequired,
        url: c.default.string.isRequired,
        width: c.default.number
      }, t.default = j;
    }, function (e, t, n) {
      t.a = function (e) {
        var t = {};
        return function (n) {
          return void 0 === t[n] && (t[n] = e(n)), t[n];
        };
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
          o = n(2),
          i = m(o),
          a = m(n(4)),
          s = n(17),
          c = m(s),
          u = m(n(98)),
          l = m(n(26)),
          d = m(n(49)),
          p = m(n(50)),
          f = n(9),
          h = n(46);

      function m(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      var y = (0, c.default)("div", {
        target: "e4550h40"
      })("visibility:", function (e) {
        return e.open ? "visible" : "hidden";
      }, ";opacity:", function (e) {
        return e.open ? 1 : 0;
      }, ";background-color:", function (e) {
        return e.backgroundColor;
      }, ";position:fixed !important;z-index:10001;left:0 !important;right:0 !important;top:0 !important;bottom:0 !important;overflow:hidden !important;height:100%;transition:all 400ms ease ", function (e) {
        return e.openDelay;
      }, "s;");
      (0, s.injectGlobal)(".__typeform-embed-mobile-modal-open{overflow:hidden !important;position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;}");

      var v = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

          return n.state = {
            backgroundColor: "transparent",
            buttonColor: "#FFF"
          }, n.handleMessage = n.handleMessage.bind(n), n.handleAutoClose = (0, f.callIfEmbedIdMatches)(n.handleAutoClose.bind(n), n.props.embedId), n.handleFormSubmit = (0, f.callIfEmbedIdMatches)(n.handleFormSubmit.bind(n), n.props.embedId), n.handleClose = n.handleClose.bind(n), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), r(t, [{
          key: "componentWillMount",
          value: function value() {
            var e = this,
                t = d.default.getUidFromURL(this.props.url);
            d.default.getFormData(t, "admin.typeform.com").then(function (n) {
              return (0, p.default)(t, "popup", e.props.url, e.props.buttonText, n);
            }).then(function (t) {
              var n = t.form;
              e.setState({
                backgroundColor: "#" + n["background-color"],
                buttonColor: "#" + n["button-color"]
              });
            });
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            window.addEventListener("message", this.handleMessage), window.addEventListener("embed-auto-close-popup", this.handleAutoClose), window.addEventListener("form-submit", this.handleFormSubmit), window.addEventListener("redirect-after-submit", f.redirectToUrl), window.addEventListener("thank-you-screen-redirect", f.redirectToUrl), this.props.open && this.open();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            !e.open && this.props.open && this.open();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            window.removeEventListener("message", this.handleMessage), window.removeEventListener("embed-auto-close-popup", this.handleAutoClose), window.removeEventListener("form-submit", this.handleFormSubmit), window.removeEventListener("redirect-after-submit", f.redirectToUrl), window.removeEventListener("thank-you-screen-redirect", f.redirectToUrl), document.body.classList.remove("__typeform-embed-mobile-modal-open");
          }
        }, {
          key: "handleMessage",
          value: function value(e) {
            (0, f.broadcastMessage)(this.props.embedId, e);
          }
        }, {
          key: "handleAutoClose",
          value: function value(e) {
            var t = this,
                n = e.detail.isProPlus || e.detail.canSetAutocloseDelay,
                r = this.props,
                o = r.isAutoCloseEnabled,
                i = r.autoClose,
                a = void 0 === i ? h.DEFAULT_AUTOCLOSE_TIMEOUT : i,
                s = 1e3 * (n ? a : h.DEFAULT_AUTOCLOSE_TIMEOUT);
            o && setTimeout(function () {
              t.handleClose();
            }, s);
          }
        }, {
          key: "handleFormSubmit",
          value: function value() {
            this.props.onSubmit && this.props.onSubmit();
          }
        }, {
          key: "open",
          value: function value() {
            var e = this;
            setTimeout(function () {
              e.originalBodyScrollTop = window.document.body.scrollTop, document.body.classList.add("__typeform-embed-mobile-modal-open");
            }, 1e3 * this.props.openDelay + 500);
          }
        }, {
          key: "handleClose",
          value: function value() {
            var e = this;
            document.body.classList.remove("__typeform-embed-mobile-modal-open"), setTimeout(function () {
              window.document.body.scrollTop = e.originalBodyScrollTop;
            }, 40), this.props.onClose && this.props.onClose();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.embedId,
                n = e.url,
                r = e.open,
                o = this.state,
                a = o.backgroundColor,
                s = o.buttonColor,
                c = (0, f.updateQueryStringParameter)("typeform-embed-id", t, n);
            return i.default.createElement(y, {
              backgroundColor: a,
              "data-qa": "mobile-modal",
              open: r,
              openDelay: this.props.openDelay
            }, r && i.default.createElement(l.default, {
              src: c
            }), i.default.createElement(u.default, {
              color: s,
              dataQa: "close-button-mobile",
              onClick: this.handleClose
            }));
          }
        }]), t;
      }(o.Component);

      v.propTypes = {
        url: a.default.string,
        open: a.default.bool,
        isAutoCloseEnabled: a.default.bool,
        buttonText: a.default.string,
        onClose: a.default.func,
        onSubmit: a.default.func,
        autoClose: a.default.number,
        openDelay: a.default.number,
        embedId: a.default.string
      }, v.defaultProps = {
        open: !1,
        openDelay: 0,
        autoClose: null
      }, t.default = v;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = i(n(99)),
          o = i(n(43));

      function i(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      var a = {
        generateURL: function generateURL(e, t) {
          return "https://" + t + "/app/embed/" + e + "?jsoncallback=?";
        },
        getFormData: function getFormData(e, t) {
          var n = this.generateURL(e, t);
          return (0, r.default)(n, {
            jsonpCallback: "jsoncallback"
          }).then(function (e) {
            return e.json();
          });
        },
        getAccountFromURL: function getAccountFromURL(e) {
          return e.split("/")[2].split(".")[0];
        },
        getUidFromURL: function getUidFromURL(e) {
          var t = (0, o.default)(e, !0),
              n = t.pathname,
              r = t.query,
              i = n.replace(/\/$/, "").replace(/\/to\/(.+)$/, "$1");
          return "/renderer" === i ? r.uid : i;
        },
        getDomainFromUrl: function getDomainFromUrl(e) {
          return e.split("/")[2];
        },
        getDOMElementData: function getDOMElementData(e) {
          return {
            url: e.data("url"),
            text: e.data("text")
          };
        }
      };
      t.default = a;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(16),
          o = {
        "account-name": "admin",
        name: "Typeform",
        "welcome-image": "",
        "font-google": "",
        "primary-color": "#222",
        "background-image": "",
        "background-color": "#DDD",
        "background-repeat": "",
        "background-brightness": "",
        "button-color": "#AAA"
      };

      t.default = function (e, t, n, i) {
        var a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : o;
        return {
          isMobile: (0, r.isMobile)(navigator.userAgent),
          "account-name": a["account-name"] || "admin",
          type: t,
          form: {
            uid: e,
            url: n,
            ready: !1,
            buttonText: i,
            name: a.name || "",
            "welcome-image": a["welcome-image"],
            "font-google": a["font-google"],
            "primary-color": a["primary-color"],
            "background-image": a["background-image"],
            "background-color": a["background-color"],
            "background-repeat": a["background-repeat"],
            "background-brightness": a["background-brightness"],
            "button-color": a["button-color"]
          }
        };
      };
    }, function (e, t, n) {
      var r = n(52),
          o = n(32);

      e.exports = Object.keys || function (e) {
        return r(e, o);
      };
    }, function (e, t, n) {
      var r = n(7),
          o = n(18),
          i = n(105)(!1),
          a = n(31);

      e.exports = function (e, t) {
        var n,
            s = o(e),
            c = 0,
            u = [];

        for (n in s) {
          !r(a, n) && r(s, n) && u.push(n);
        }

        for (; t.length > c;) {
          r(s, n = t[c++]) && (~i(u, n) || u.push(n));
        }

        return u;
      };
    }, function (e, t) {
      t.f = Object.getOwnPropertySymbols;
    }, function (e, t, n) {
      var r = {}.propertyIsEnumerable,
          o = Object.getOwnPropertyDescriptor,
          i = o && !r.call({
        1: 2
      }, 1);
      t.f = i ? function (e) {
        var t = o(this, e);
        return !!t && t.enumerable;
      } : r;
    }, function (e, t, n) {
      var r = n(5);

      e.exports = function (e, t) {
        if (!r(e)) return e;
        var n, o;
        if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
        if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
        if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (e, t, n) {
      e.exports = !n(13) && !n(10)(function () {
        return 7 != Object.defineProperty(n(36)("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (e, t, n) {
      e.exports = n(20)("native-function-to-string", Function.toString);
    }, function (e, t) {
      var n = 0,
          r = Math.random();

      e.exports = function (e) {
        return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + r).toString(36));
      };
    }, function (e, t, n) {
      var r = n(10),
          o = /#|\.prototype\./,
          i = function i(e, t) {
        var n = s[a(e)];
        return n == u || n != c && ("function" == typeof t ? r(t) : !!t);
      },
          a = i.normalize = function (e) {
        return String(e).replace(o, ".").toLowerCase();
      },
          s = i.data = {},
          c = i.NATIVE = "N",
          u = i.POLYFILL = "P";

      e.exports = i;
    }, function (e, t, n) {
      var r = n(1)("unscopables"),
          o = n(61),
          i = n(8),
          a = Array.prototype;
      null == a[r] && i(a, r, o(null)), e.exports = function (e) {
        a[r][e] = !0;
      };
    }, function (e, t, n) {
      var r = n(6),
          o = n(116),
          i = n(32),
          a = n(62),
          s = n(36),
          c = n(38)("IE_PROTO"),
          u = function u() {},
          _l = function l() {
        var e,
            t = s("iframe"),
            n = i.length;

        for (t.style.display = "none", a.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _l = e.F; n--;) {
          delete _l.prototype[i[n]];
        }

        return _l();
      };

      e.exports = Object.create || function (e, t) {
        var n;
        return null !== e ? (u.prototype = r(e), n = new u(), u.prototype = null, n[c] = e) : n = _l(), void 0 === t ? n : o(n, t);
      }, n(31)[c] = !0;
    }, function (e, t, n) {
      var r = n(0).document;
      e.exports = r && r.documentElement;
    }, function (e, t, n) {
      var r = n(11),
          o = n(1)("toStringTag"),
          i = "Arguments" == r(function () {
        return arguments;
      }());

      e.exports = function (e) {
        var t, n, a;
        return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
          try {
            return e[t];
          } catch (e) {}
        }(t = Object(e), o)) ? n : i ? r(t) : "Object" == (a = r(t)) && "function" == typeof t.callee ? "Arguments" : a;
      };
    }, function (e, t, n) {
      var r = n(12),
          o = n(124),
          i = n(66),
          a = n(126),
          s = n(40),
          c = n(8),
          u = n(19),
          l = n(21),
          d = n(1)("iterator"),
          p = n(15),
          f = n(65),
          h = f.IteratorPrototype,
          m = f.BUGGY_SAFARI_ITERATORS,
          y = function y() {
        return this;
      };

      e.exports = function (e, t, n, f, v, b, g) {
        o(n, t, f);

        var w,
            _,
            x,
            S = function S(e) {
          if (e === v && P) return P;
          if (!m && e in E) return E[e];

          switch (e) {
            case "keys":
            case "values":
            case "entries":
              return function () {
                return new n(this, e);
              };
          }

          return function () {
            return new n(this);
          };
        },
            C = t + " Iterator",
            k = !1,
            E = e.prototype,
            O = E[d] || E["@@iterator"] || v && E[v],
            P = !m && O || S(v),
            T = "Array" == t && E.entries || O;

        if (T && (w = i(T.call(new e())), h !== Object.prototype && w.next && (l || i(w) === h || (a ? a(w, h) : "function" != typeof w[d] && c(w, d, y)), s(w, C, !0, !0), l && (p[C] = y))), "values" == v && O && "values" !== O.name && (k = !0, P = function P() {
          return O.call(this);
        }), l && !g || E[d] === P || c(E, d, P), p[t] = P, v) if (_ = {
          values: S("values"),
          keys: b ? P : S("keys"),
          entries: S("entries")
        }, g) for (x in _) {
          (m || k || !(x in E)) && u(E, x, _[x]);
        } else r({
          target: t,
          proto: !0,
          forced: m || k
        }, _);
        return _;
      };
    }, function (e, t, n) {
      var r,
          o,
          i,
          a = n(66),
          s = n(8),
          c = n(7),
          u = n(21),
          l = n(1)("iterator"),
          d = !1;
      [].keys && ("next" in (i = [].keys()) ? (o = a(a(i))) !== Object.prototype && (r = o) : d = !0), null == r && (r = {}), u || c(r, l) || s(r, l, function () {
        return this;
      }), e.exports = {
        IteratorPrototype: r,
        BUGGY_SAFARI_ITERATORS: d
      };
    }, function (e, t, n) {
      var r = n(7),
          o = n(33),
          i = n(38)("IE_PROTO"),
          a = n(125),
          s = Object.prototype;
      e.exports = a ? Object.getPrototypeOf : function (e) {
        return e = o(e), r(e, i) ? e[i] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? s : null;
      };
    }, function (e, t, n) {
      var r = n(6),
          o = n(23),
          i = n(1)("species");

      e.exports = function (e, t) {
        var n,
            a = r(e).constructor;
        return void 0 === a || null == (n = r(a)[i]) ? t : o(n);
      };
    }, function (e, t, n) {
      var r,
          o,
          i,
          a = n(0),
          s = n(11),
          c = n(39),
          u = n(62),
          l = n(36),
          d = a.setImmediate,
          p = a.clearImmediate,
          f = a.process,
          h = a.MessageChannel,
          m = a.Dispatch,
          y = 0,
          v = {},
          b = function b() {
        var e = +this;

        if (v.hasOwnProperty(e)) {
          var t = v[e];
          delete v[e], t();
        }
      },
          g = function g(e) {
        b.call(e.data);
      };

      d && p || (d = function d(e) {
        for (var t = [], n = 1; arguments.length > n;) {
          t.push(arguments[n++]);
        }

        return v[++y] = function () {
          ("function" == typeof e ? e : Function(e)).apply(void 0, t);
        }, r(y), y;
      }, p = function p(e) {
        delete v[e];
      }, "process" == s(f) ? r = function r(e) {
        f.nextTick(c(b, e, 1));
      } : m && m.now ? r = function r(e) {
        m.now(c(b, e, 1));
      } : h ? (i = (o = new h()).port2, o.port1.onmessage = g, r = c(i.postMessage, i, 1)) : a.addEventListener && "function" == typeof postMessage && !a.importScripts ? (r = function r(e) {
        a.postMessage(e + "", "*");
      }, a.addEventListener("message", g, !1)) : r = "onreadystatechange" in l("script") ? function (e) {
        u.appendChild(l("script")).onreadystatechange = function () {
          u.removeChild(this), b.call(e);
        };
      } : function (e) {
        setTimeout(c(b, e, 1), 0);
      }), e.exports = {
        set: d,
        clear: p
      };
    }, function (e, t, n) {
      var r = n(0).navigator;
      e.exports = r && r.userAgent || "";
    }, function (e, t, n) {
      var r = n(6),
          o = n(5),
          i = n(71);

      e.exports = function (e, t) {
        if (r(e), o(t) && t.constructor === e) return t;
        var n = i.f(e);
        return (0, n.resolve)(t), n.promise;
      };
    }, function (e, t, n) {
      var r = n(23),
          o = function o(e) {
        var t, n;
        this.promise = new e(function (e, r) {
          if (void 0 !== t || void 0 !== n) throw TypeError("Bad Promise constructor");
          t = e, n = r;
        }), this.resolve = r(t), this.reject = r(n);
      };

      e.exports.f = function (e) {
        return new o(e);
      };
    }, function (e, t, n) {
      var r = n(41),
          o = n(0),
          i = function i(e) {
        return "function" == typeof e ? e : void 0;
      };

      e.exports = function (e, t) {
        return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.makeFullScreen = t.makeWidget = t.makePopup = void 0;
      var r = a(n(74)),
          o = a(n(100)),
          i = a(n(102));

      function a(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      n(103), n(111), n(117), n(119), t.makePopup = r.default, t.makeWidget = o.default, t.makeFullScreen = i.default;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      };

      t.default = function (e, t) {
        var n = (0, s.default)();
        if (t = r({}, f, t, {
          isAutoCloseEnabled: void 0 !== t.autoClose,
          embedType: u.POPUP_MODES[t.mode],
          embedId: n
        }), !Number.isSafeInteger(t.drawerWidth)) throw new Error("Whoops! You provided an invalid 'drawerWidth' option: \"" + t.drawerWidth + '". It must be a number.');
        var p = document.createElement("div");
        t.isContained = void 0 !== t.container, t.container = t.container || document.body, t.container.appendChild(p);
        var m = {
          open: function open() {
            !function (e, t, n, r) {
              var s = n.autoClose,
                  u = n.buttonText,
                  p = n.embedId,
                  f = n.isAutoCloseEnabled,
                  m = n.onSubmit,
                  y = (0, a.appendParamsToUrl)(e, (0, a.replaceExistingKeys)(n, h));
              !(0, c.isMobile)(navigator.userAgent) && (0, c.isScreenBig)() ? (0, i.render)(o.default.createElement(l.default, {
                embedId: p,
                onClose: r,
                options: n,
                url: y
              }), t) : ((0, a.ensureMetaViewport)(), (0, i.render)(o.default.createElement(d.default, {
                autoClose: s,
                buttonText: u,
                embedId: p,
                isAutoCloseEnabled: f,
                onClose: r,
                onSubmit: m,
                open: !0,
                url: y
              }), t));
            }(e, p, t, this.close);
          },
          close: function close() {
            window.postMessage({
              type: "form-closed",
              embedId: n
            }, "*"), (0, i.unmountComponentAtNode)(p);
          }
        };
        t.autoOpen && m.open();
        return m;
      };

      var o = p(n(2)),
          i = n(2),
          a = n(9),
          s = p(n(45)),
          c = n(16),
          u = n(46),
          l = p(u),
          d = p(n(48));

      function p(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      var f = {
        mode: u.POPUP,
        autoOpen: !1,
        isModalOpen: !1,
        autoClose: u.DEFAULT_AUTOCLOSE_TIMEOUT,
        hideFooter: !1,
        hideHeaders: !1,
        hideScrollbars: !1,
        disableTracking: !1,
        drawerWidth: 800,
        onSubmit: a.noop
      },
          h = {
        embedType: "typeform-embed",
        hideFooter: "embed-hide-footer",
        hideHeaders: "embed-hide-headers",
        disableTracking: "disable-tracking"
      };
    }, function (e, t, n) {
      /** @license React v16.8.1
           * react-is.production.min.js
           *
           * Copyright (c) Facebook, Inc. and its affiliates.
           *
           * This source code is licensed under the MIT license found in the
           * LICENSE file in the root directory of this source tree.
           */
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = "function" == typeof Symbol && Symbol.for,
          o = r ? Symbol.for("react.element") : 60103,
          i = r ? Symbol.for("react.portal") : 60106,
          a = r ? Symbol.for("react.fragment") : 60107,
          s = r ? Symbol.for("react.strict_mode") : 60108,
          c = r ? Symbol.for("react.profiler") : 60114,
          u = r ? Symbol.for("react.provider") : 60109,
          l = r ? Symbol.for("react.context") : 60110,
          d = r ? Symbol.for("react.async_mode") : 60111,
          p = r ? Symbol.for("react.concurrent_mode") : 60111,
          f = r ? Symbol.for("react.forward_ref") : 60112,
          h = r ? Symbol.for("react.suspense") : 60113,
          m = r ? Symbol.for("react.memo") : 60115,
          y = r ? Symbol.for("react.lazy") : 60116;

      function v(e) {
        if ("object" == typeof e && null !== e) {
          var t = e.$$typeof;

          switch (t) {
            case o:
              switch (e = e.type) {
                case d:
                case p:
                case a:
                case c:
                case s:
                case h:
                  return e;

                default:
                  switch (e = e && e.$$typeof) {
                    case l:
                    case f:
                    case u:
                      return e;

                    default:
                      return t;
                  }

              }

            case y:
            case m:
            case i:
              return t;
          }
        }
      }

      function b(e) {
        return v(e) === p;
      }

      t.typeOf = v, t.AsyncMode = d, t.ConcurrentMode = p, t.ContextConsumer = l, t.ContextProvider = u, t.Element = o, t.ForwardRef = f, t.Fragment = a, t.Lazy = y, t.Memo = m, t.Portal = i, t.Profiler = c, t.StrictMode = s, t.Suspense = h, t.isValidElementType = function (e) {
        return "string" == typeof e || "function" == typeof e || e === a || e === p || e === c || e === s || e === h || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === m || e.$$typeof === u || e.$$typeof === l || e.$$typeof === f);
      }, t.isAsyncMode = function (e) {
        return b(e) || v(e) === d;
      }, t.isConcurrentMode = b, t.isContextConsumer = function (e) {
        return v(e) === l;
      }, t.isContextProvider = function (e) {
        return v(e) === u;
      }, t.isElement = function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === o;
      }, t.isForwardRef = function (e) {
        return v(e) === f;
      }, t.isFragment = function (e) {
        return v(e) === a;
      }, t.isLazy = function (e) {
        return v(e) === y;
      }, t.isMemo = function (e) {
        return v(e) === m;
      }, t.isPortal = function (e) {
        return v(e) === i;
      }, t.isProfiler = function (e) {
        return v(e) === c;
      }, t.isStrictMode = function (e) {
        return v(e) === s;
      }, t.isSuspense = function (e) {
        return v(e) === h;
      };
    }, function (e, t, n) {
      (function (e) {
        /** @license React v16.8.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
        "production" !== e.env.NODE_ENV && function () {
          Object.defineProperty(t, "__esModule", {
            value: !0
          });
          var e = "function" == typeof Symbol && Symbol.for,
              n = e ? Symbol.for("react.element") : 60103,
              r = e ? Symbol.for("react.portal") : 60106,
              o = e ? Symbol.for("react.fragment") : 60107,
              i = e ? Symbol.for("react.strict_mode") : 60108,
              a = e ? Symbol.for("react.profiler") : 60114,
              s = e ? Symbol.for("react.provider") : 60109,
              c = e ? Symbol.for("react.context") : 60110,
              u = e ? Symbol.for("react.async_mode") : 60111,
              l = e ? Symbol.for("react.concurrent_mode") : 60111,
              d = e ? Symbol.for("react.forward_ref") : 60112,
              p = e ? Symbol.for("react.suspense") : 60113,
              f = e ? Symbol.for("react.memo") : 60115,
              h = e ? Symbol.for("react.lazy") : 60116;

          var m = function m(e) {
            for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              n[r - 1] = arguments[r];
            }

            var o = 0,
                i = "Warning: " + e.replace(/%s/g, function () {
              return n[o++];
            });
            "undefined" != typeof console && console.warn(i);

            try {
              throw new Error(i);
            } catch (e) {}
          },
              y = function y(e, t) {
            if (void 0 === t) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");

            if (!e) {
              for (var n = arguments.length, r = Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
                r[o - 2] = arguments[o];
              }

              m.apply(void 0, [t].concat(r));
            }
          };

          function v(e) {
            if ("object" == typeof e && null !== e) {
              var t = e.$$typeof;

              switch (t) {
                case n:
                  var m = e.type;

                  switch (m) {
                    case u:
                    case l:
                    case o:
                    case a:
                    case i:
                    case p:
                      return m;

                    default:
                      var y = m && m.$$typeof;

                      switch (y) {
                        case c:
                        case d:
                        case s:
                          return y;

                        default:
                          return t;
                      }

                  }

                case h:
                case f:
                case r:
                  return t;
              }
            }
          }

          var b = u,
              g = l,
              w = c,
              _ = s,
              x = n,
              S = d,
              C = o,
              k = h,
              E = f,
              O = r,
              P = a,
              T = i,
              A = p,
              j = !1;

          function N(e) {
            return v(e) === l;
          }

          t.typeOf = v, t.AsyncMode = b, t.ConcurrentMode = g, t.ContextConsumer = w, t.ContextProvider = _, t.Element = x, t.ForwardRef = S, t.Fragment = C, t.Lazy = k, t.Memo = E, t.Portal = O, t.Profiler = P, t.StrictMode = T, t.Suspense = A, t.isValidElementType = function (e) {
            return "string" == typeof e || "function" == typeof e || e === o || e === l || e === a || e === i || e === p || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === f || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d);
          }, t.isAsyncMode = function (e) {
            return j || (j = !0, y(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(e) || v(e) === u;
          }, t.isConcurrentMode = N, t.isContextConsumer = function (e) {
            return v(e) === c;
          }, t.isContextProvider = function (e) {
            return v(e) === s;
          }, t.isElement = function (e) {
            return "object" == typeof e && null !== e && e.$$typeof === n;
          }, t.isForwardRef = function (e) {
            return v(e) === d;
          }, t.isFragment = function (e) {
            return v(e) === o;
          }, t.isLazy = function (e) {
            return v(e) === h;
          }, t.isMemo = function (e) {
            return v(e) === f;
          }, t.isPortal = function (e) {
            return v(e) === r;
          }, t.isProfiler = function (e) {
            return v(e) === a;
          }, t.isStrictMode = function (e) {
            return v(e) === i;
          }, t.isSuspense = function (e) {
            return v(e) === p;
          };
        }();
      }).call(t, n(3));
    }, function (e, t, n) {
      (function (t) {
        var r = n(42),
            o = n(78),
            i = n(24),
            a = n(79),
            s = Function.call.bind(Object.prototype.hasOwnProperty),
            c = function c() {};

        function u() {
          return null;
        }

        "production" !== t.env.NODE_ENV && (c = function c(e) {
          var t = "Warning: " + e;
          "undefined" != typeof console && console.error(t);

          try {
            throw new Error(t);
          } catch (e) {}
        }), e.exports = function (e, n) {
          var l = "function" == typeof Symbol && Symbol.iterator;
          var d = {
            array: m("array"),
            bool: m("boolean"),
            func: m("function"),
            number: m("number"),
            object: m("object"),
            string: m("string"),
            symbol: m("symbol"),
            any: h(u),
            arrayOf: function arrayOf(e) {
              return h(function (t, n, r, o, a) {
                if ("function" != typeof e) return new f("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
                var s = t[n];
                if (!Array.isArray(s)) return new f("Invalid " + o + " `" + a + "` of type `" + v(s) + "` supplied to `" + r + "`, expected an array.");

                for (var c = 0; c < s.length; c++) {
                  var u = e(s, c, r, o, a + "[" + c + "]", i);
                  if (u instanceof Error) return u;
                }

                return null;
              });
            },
            element: h(function (t, n, r, o, i) {
              var a = t[n];
              return e(a) ? null : new f("Invalid " + o + " `" + i + "` of type `" + v(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
            }),
            elementType: h(function (e, t, n, o, i) {
              var a = e[t];
              return r.isValidElementType(a) ? null : new f("Invalid " + o + " `" + i + "` of type `" + v(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
            }),
            instanceOf: function instanceOf(e) {
              return h(function (t, n, r, o, i) {
                if (!(t[n] instanceof e)) {
                  var a = e.name || "<<anonymous>>";
                  return new f("Invalid " + o + " `" + i + "` of type `" + function (e) {
                    if (!e.constructor || !e.constructor.name) return "<<anonymous>>";
                    return e.constructor.name;
                  }(t[n]) + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
                }

                return null;
              });
            },
            node: h(function (e, t, n, r, o) {
              return y(e[t]) ? null : new f("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
            }),
            objectOf: function objectOf(e) {
              return h(function (t, n, r, o, a) {
                if ("function" != typeof e) return new f("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
                var c = t[n],
                    u = v(c);
                if ("object" !== u) return new f("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + r + "`, expected an object.");

                for (var l in c) {
                  if (s(c, l)) {
                    var d = e(c, l, r, o, a + "." + l, i);
                    if (d instanceof Error) return d;
                  }
                }

                return null;
              });
            },
            oneOf: function oneOf(e) {
              if (!Array.isArray(e)) return "production" !== t.env.NODE_ENV && (arguments.length > 1 ? c("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : c("Invalid argument supplied to oneOf, expected an array.")), u;

              function n(t, n, r, o, i) {
                for (var a = t[n], s = 0; s < e.length; s++) {
                  if (p(a, e[s])) return null;
                }

                var c = JSON.stringify(e, function (e, t) {
                  return "symbol" === v(t) ? String(t) : t;
                });
                return new f("Invalid " + o + " `" + i + "` of value `" + String(a) + "` supplied to `" + r + "`, expected one of " + c + ".");
              }

              return h(n);
            },
            oneOfType: function oneOfType(e) {
              if (!Array.isArray(e)) return "production" !== t.env.NODE_ENV && c("Invalid argument supplied to oneOfType, expected an instance of array."), u;

              for (var n = 0; n < e.length; n++) {
                var r = e[n];
                if ("function" != typeof r) return c("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + g(r) + " at index " + n + "."), u;
              }

              return h(function (t, n, r, o, a) {
                for (var s = 0; s < e.length; s++) {
                  if (null == (0, e[s])(t, n, r, o, a, i)) return null;
                }

                return new f("Invalid " + o + " `" + a + "` supplied to `" + r + "`.");
              });
            },
            shape: function shape(e) {
              return h(function (t, n, r, o, a) {
                var s = t[n],
                    c = v(s);
                if ("object" !== c) return new f("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");

                for (var u in e) {
                  var l = e[u];

                  if (l) {
                    var d = l(s, u, r, o, a + "." + u, i);
                    if (d) return d;
                  }
                }

                return null;
              });
            },
            exact: function exact(e) {
              return h(function (t, n, r, a, s) {
                var c = t[n],
                    u = v(c);
                if ("object" !== u) return new f("Invalid " + a + " `" + s + "` of type `" + u + "` supplied to `" + r + "`, expected `object`.");
                var l = o({}, t[n], e);

                for (var d in l) {
                  var p = e[d];
                  if (!p) return new f("Invalid " + a + " `" + s + "` key `" + d + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                  var h = p(c, d, r, a, s + "." + d, i);
                  if (h) return h;
                }

                return null;
              });
            }
          };

          function p(e, t) {
            return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
          }

          function f(e) {
            this.message = e, this.stack = "";
          }

          function h(e) {
            if ("production" !== t.env.NODE_ENV) var r = {},
                o = 0;

            function a(a, s, u, l, d, p, h) {
              if (l = l || "<<anonymous>>", p = p || u, h !== i) {
                if (n) {
                  var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                  throw m.name = "Invariant Violation", m;
                }

                if ("production" !== t.env.NODE_ENV && "undefined" != typeof console) {
                  var y = l + ":" + u;
                  !r[y] && o < 3 && (c("You are manually calling a React.PropTypes validation function for the `" + p + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[y] = !0, o++);
                }
              }

              return null == s[u] ? a ? null === s[u] ? new f("The " + d + " `" + p + "` is marked as required in `" + l + "`, but its value is `null`.") : new f("The " + d + " `" + p + "` is marked as required in `" + l + "`, but its value is `undefined`.") : null : e(s, u, l, d, p);
            }

            var s = a.bind(null, !1);
            return s.isRequired = a.bind(null, !0), s;
          }

          function m(e) {
            return h(function (t, n, r, o, i, a) {
              var s = t[n];
              return v(s) !== e ? new f("Invalid " + o + " `" + i + "` of type `" + b(s) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
            });
          }

          function y(t) {
            switch (typeof t) {
              case "number":
              case "string":
              case "undefined":
                return !0;

              case "boolean":
                return !t;

              case "object":
                if (Array.isArray(t)) return t.every(y);
                if (null === t || e(t)) return !0;

                var n = function (e) {
                  var t = e && (l && e[l] || e["@@iterator"]);
                  if ("function" == typeof t) return t;
                }(t);

                if (!n) return !1;
                var r,
                    o = n.call(t);

                if (n !== t.entries) {
                  for (; !(r = o.next()).done;) {
                    if (!y(r.value)) return !1;
                  }
                } else for (; !(r = o.next()).done;) {
                  var i = r.value;
                  if (i && !y(i[1])) return !1;
                }

                return !0;

              default:
                return !1;
            }
          }

          function v(e) {
            var t = typeof e;
            return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
              return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol;
            }(t, e) ? "symbol" : t;
          }

          function b(e) {
            if (null == e) return "" + e;
            var t = v(e);

            if ("object" === t) {
              if (e instanceof Date) return "date";
              if (e instanceof RegExp) return "regexp";
            }

            return t;
          }

          function g(e) {
            var t = b(e);

            switch (t) {
              case "array":
              case "object":
                return "an " + t;

              case "boolean":
              case "date":
              case "regexp":
                return "a " + t;

              default:
                return t;
            }
          }

          return f.prototype = Error.prototype, d.checkPropTypes = a, d.resetWarningCache = a.resetWarningCache, d.PropTypes = d, d;
        };
      }).call(t, n(3));
    }, function (e, t, n) {
      /*
          object-assign
          (c) Sindre Sorhus
          @license MIT
          */
      var r = Object.getOwnPropertySymbols,
          o = Object.prototype.hasOwnProperty,
          i = Object.prototype.propertyIsEnumerable;

      function a(e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }

      e.exports = function () {
        try {
          if (!Object.assign) return !1;
          var e = new String("abc");
          if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

          for (var t = {}, n = 0; n < 10; n++) {
            t["_" + String.fromCharCode(n)] = n;
          }

          if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
            return t[e];
          }).join("")) return !1;
          var r = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (e) {
            r[e] = e;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
        } catch (e) {
          return !1;
        }
      }() ? Object.assign : function (e, t) {
        for (var n, s, c = a(e), u = 1; u < arguments.length; u++) {
          for (var l in n = Object(arguments[u])) {
            o.call(n, l) && (c[l] = n[l]);
          }

          if (r) {
            s = r(n);

            for (var d = 0; d < s.length; d++) {
              i.call(n, s[d]) && (c[s[d]] = n[s[d]]);
            }
          }
        }

        return c;
      };
    }, function (e, t, n) {
      (function (t) {
        var r = function r() {};

        if ("production" !== t.env.NODE_ENV) {
          var o = n(24),
              i = {},
              a = Function.call.bind(Object.prototype.hasOwnProperty);

          r = function r(e) {
            var t = "Warning: " + e;
            "undefined" != typeof console && console.error(t);

            try {
              throw new Error(t);
            } catch (e) {}
          };
        }

        function s(e, n, s, c, u) {
          if ("production" !== t.env.NODE_ENV) for (var l in e) {
            if (a(e, l)) {
              var d;

              try {
                if ("function" != typeof e[l]) {
                  var p = Error((c || "React class") + ": " + s + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.");
                  throw p.name = "Invariant Violation", p;
                }

                d = e[l](n, l, c, s, null, o);
              } catch (e) {
                d = e;
              }

              if (!d || d instanceof Error || r((c || "React class") + ": type specification of " + s + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), d instanceof Error && !(d.message in i)) {
                i[d.message] = !0;
                var f = u ? u() : "";
                r("Failed " + s + " type: " + d.message + (null != f ? f : ""));
              }
            }
          }
        }

        s.resetWarningCache = function () {
          "production" !== t.env.NODE_ENV && (i = {});
        }, e.exports = s;
      }).call(t, n(3));
    }, function (e, t, n) {
      var r = n(24);

      function o() {}

      function i() {}

      i.resetWarningCache = o, e.exports = function () {
        function e(e, t, n, o, i, a) {
          if (a !== r) {
            var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw s.name = "Invariant Violation", s;
          }
        }

        function t() {
          return e;
        }

        e.isRequired = e;
        var n = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          elementType: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t,
          checkPropTypes: i,
          resetWarningCache: o
        };
        return n.PropTypes = n, n;
      };
    }, function (e, t, n) {
      n.d(t, "c", function () {
        return s;
      }), n.d(t, "b", function () {
        return d;
      }), n.d(t, "a", function () {
        return F;
      }), n.d(t, "e", function () {
        return U;
      }), n.d(t, "d", function () {
        return o;
      });

      var r = function r() {},
          o = {},
          i = [],
          a = [];

      function s(e, t) {
        var n,
            s,
            c,
            u,
            l = a;

        for (u = arguments.length; u-- > 2;) {
          i.push(arguments[u]);
        }

        for (t && null != t.children && (i.length || i.push(t.children), delete t.children); i.length;) {
          if ((s = i.pop()) && void 0 !== s.pop) for (u = s.length; u--;) {
            i.push(s[u]);
          } else "boolean" == typeof s && (s = null), (c = "function" != typeof e) && (null == s ? s = "" : "number" == typeof s ? s = String(s) : "string" != typeof s && (c = !1)), c && n ? l[l.length - 1] += s : l === a ? l = [s] : l.push(s), n = c;
        }

        var d = new r();
        return d.nodeName = e, d.children = l, d.attributes = null == t ? void 0 : t, d.key = null == t ? void 0 : t.key, void 0 !== o.vnode && o.vnode(d), d;
      }

      function c(e, t) {
        for (var n in t) {
          e[n] = t[n];
        }

        return e;
      }

      function u(e, t) {
        null != e && ("function" == typeof e ? e(t) : e.current = t);
      }

      var l = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

      function d(e, t) {
        return s(e.nodeName, c(c({}, e.attributes), t), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
      }

      var p = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
          f = [];

      function h(e) {
        !e._dirty && (e._dirty = !0) && 1 == f.push(e) && (o.debounceRendering || l)(m);
      }

      function m() {
        for (var e; e = f.pop();) {
          e._dirty && R(e);
        }
      }

      function y(e, t, n) {
        return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && v(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
      }

      function v(e, t) {
        return e.normalizedNodeName === t || e.nodeName.toLowerCase() === t.toLowerCase();
      }

      function b(e) {
        var t = c({}, e.attributes);
        t.children = e.children;
        var n = e.nodeName.defaultProps;
        if (void 0 !== n) for (var r in n) {
          void 0 === t[r] && (t[r] = n[r]);
        }
        return t;
      }

      function g(e) {
        var t = e.parentNode;
        t && t.removeChild(e);
      }

      function w(e, t, n, r, o) {
        if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) u(n, null), u(r, e);else if ("class" !== t || o) {
          if ("style" === t) {
            if (r && "string" != typeof r && "string" != typeof n || (e.style.cssText = r || ""), r && "object" == typeof r) {
              if ("string" != typeof n) for (var i in n) {
                i in r || (e.style[i] = "");
              }

              for (var i in r) {
                e.style[i] = "number" == typeof r[i] && !1 === p.test(i) ? r[i] + "px" : r[i];
              }
            }
          } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
            var a = t !== (t = t.replace(/Capture$/, ""));
            t = t.toLowerCase().substring(2), r ? n || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e._listeners || (e._listeners = {}))[t] = r;
          } else if ("list" !== t && "type" !== t && !o && t in e) {
            try {
              e[t] = null == r ? "" : r;
            } catch (e) {}

            null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
          } else {
            var s = o && t !== (t = t.replace(/^xlink:?/, ""));
            null == r || !1 === r ? s ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (s ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
          }
        } else e.className = r || "";
      }

      function _(e) {
        return this._listeners[e.type](o.event && o.event(e) || e);
      }

      var x = [],
          S = 0,
          C = !1,
          k = !1;

      function E() {
        for (var e; e = x.shift();) {
          o.afterMount && o.afterMount(e), e.componentDidMount && e.componentDidMount();
        }
      }

      function O(e, t, n, r, o, i) {
        S++ || (C = null != o && void 0 !== o.ownerSVGElement, k = null != e && !("__preactattr_" in e));
        var a = P(e, t, n, r, i);
        return o && a.parentNode !== o && o.appendChild(a), --S || (k = !1, i || E()), a;
      }

      function P(e, t, n, r, o) {
        var i = e,
            a = C;
        if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || o) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), T(e, !0))), i.__preactattr_ = !0, i;
        var s,
            c,
            u = t.nodeName;
        if ("function" == typeof u) return function (e, t, n, r) {
          var o = e && e._component,
              i = o,
              a = e,
              s = o && e._componentConstructor === t.nodeName,
              c = s,
              u = b(t);

          for (; o && !c && (o = o._parentComponent);) {
            c = o.constructor === t.nodeName;
          }

          o && c && (!r || o._component) ? (I(o, u, 3, n, r), e = o.base) : (i && !s && (L(i), e = a = null), o = N(t.nodeName, u, n), e && !o.nextBase && (o.nextBase = e, a = null), I(o, u, 1, n, r), e = o.base, a && e !== a && (a._component = null, T(a, !1)));
          return e;
        }(e, t, n, r);

        if (C = "svg" === u || "foreignObject" !== u && C, u = String(u), (!e || !v(e, u)) && (s = u, (c = C ? document.createElementNS("http://www.w3.org/2000/svg", s) : document.createElement(s)).normalizedNodeName = s, i = c, e)) {
          for (; e.firstChild;) {
            i.appendChild(e.firstChild);
          }

          e.parentNode && e.parentNode.replaceChild(i, e), T(e, !0);
        }

        var l = i.firstChild,
            d = i.__preactattr_,
            p = t.children;

        if (null == d) {
          d = i.__preactattr_ = {};

          for (var f = i.attributes, h = f.length; h--;) {
            d[f[h].name] = f[h].value;
          }
        }

        return !k && p && 1 === p.length && "string" == typeof p[0] && null != l && void 0 !== l.splitText && null == l.nextSibling ? l.nodeValue != p[0] && (l.nodeValue = p[0]) : (p && p.length || null != l) && function (e, t, n, r, o) {
          var i,
              a,
              s,
              c,
              u,
              l = e.childNodes,
              d = [],
              p = {},
              f = 0,
              h = 0,
              m = l.length,
              v = 0,
              b = t ? t.length : 0;
          if (0 !== m) for (var w = 0; w < m; w++) {
            var _ = l[w],
                x = _.__preactattr_;
            null != (S = b && x ? _._component ? _._component.__key : x.key : null) ? (f++, p[S] = _) : (x || (void 0 !== _.splitText ? !o || _.nodeValue.trim() : o)) && (d[v++] = _);
          }
          if (0 !== b) for (w = 0; w < b; w++) {
            var S;
            if (c = t[w], u = null, null != (S = c.key)) f && void 0 !== p[S] && (u = p[S], p[S] = void 0, f--);else if (h < v) for (i = h; i < v; i++) {
              if (void 0 !== d[i] && y(a = d[i], c, o)) {
                u = a, d[i] = void 0, i === v - 1 && v--, i === h && h++;
                break;
              }
            }
            u = P(u, c, n, r), s = l[w], u && u !== e && u !== s && (null == s ? e.appendChild(u) : u === s.nextSibling ? g(s) : e.insertBefore(u, s));
          }
          if (f) for (var w in p) {
            void 0 !== p[w] && T(p[w], !1);
          }

          for (; h <= v;) {
            void 0 !== (u = d[v--]) && T(u, !1);
          }
        }(i, p, n, r, k || null != d.dangerouslySetInnerHTML), function (e, t, n) {
          var r;

          for (r in n) {
            t && null != t[r] || null == n[r] || w(e, r, n[r], n[r] = void 0, C);
          }

          for (r in t) {
            "children" === r || "innerHTML" === r || r in n && t[r] === ("value" === r || "checked" === r ? e[r] : n[r]) || w(e, r, n[r], n[r] = t[r], C);
          }
        }(i, t.attributes, d), C = a, i;
      }

      function T(e, t) {
        var n = e._component;
        n ? L(n) : (null != e.__preactattr_ && u(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || g(e), A(e));
      }

      function A(e) {
        for (e = e.lastChild; e;) {
          var t = e.previousSibling;
          T(e, !0), e = t;
        }
      }

      var j = [];

      function N(e, t, n) {
        var r,
            o = j.length;

        for (e.prototype && e.prototype.render ? (r = new e(t, n), F.call(r, t, n)) : ((r = new F(t, n)).constructor = e, r.render = M); o--;) {
          if (j[o].constructor === e) return r.nextBase = j[o].nextBase, j.splice(o, 1), r;
        }

        return r;
      }

      function M(e, t, n) {
        return this.constructor(e, n);
      }

      function I(e, t, n, r, i) {
        e._disable || (e._disable = !0, e.__ref = t.ref, e.__key = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, r)), r && r !== e.context && (e.prevContext || (e.prevContext = e.context), e.context = r), e.prevProps || (e.prevProps = e.props), e.props = t, e._disable = !1, 0 !== n && (1 !== n && !1 === o.syncComponentUpdates && e.base ? h(e) : R(e, 1, i)), u(e.__ref, e));
      }

      function R(e, t, n, r) {
        if (!e._disable) {
          var i,
              a,
              s,
              u = e.props,
              l = e.state,
              d = e.context,
              p = e.prevProps || u,
              f = e.prevState || l,
              h = e.prevContext || d,
              m = e.base,
              y = e.nextBase,
              v = m || y,
              g = e._component,
              w = !1,
              _ = h;

          if (e.constructor.getDerivedStateFromProps && (l = c(c({}, l), e.constructor.getDerivedStateFromProps(u, l)), e.state = l), m && (e.props = p, e.state = f, e.context = h, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(u, l, d) ? w = !0 : e.componentWillUpdate && e.componentWillUpdate(u, l, d), e.props = u, e.state = l, e.context = d), e.prevProps = e.prevState = e.prevContext = e.nextBase = null, e._dirty = !1, !w) {
            i = e.render(u, l, d), e.getChildContext && (d = c(c({}, d), e.getChildContext())), m && e.getSnapshotBeforeUpdate && (_ = e.getSnapshotBeforeUpdate(p, f));
            var C,
                k,
                P = i && i.nodeName;

            if ("function" == typeof P) {
              var A = b(i);
              (a = g) && a.constructor === P && A.key == a.__key ? I(a, A, 1, d, !1) : (C = a, e._component = a = N(P, A, d), a.nextBase = a.nextBase || y, a._parentComponent = e, I(a, A, 0, d, !1), R(a, 1, n, !0)), k = a.base;
            } else s = v, (C = g) && (s = e._component = null), (v || 1 === t) && (s && (s._component = null), k = O(s, i, d, n || !m, v && v.parentNode, !0));

            if (v && k !== v && a !== g) {
              var j = v.parentNode;
              j && k !== j && (j.replaceChild(k, v), C || (v._component = null, T(v, !1)));
            }

            if (C && L(C), e.base = k, k && !r) {
              for (var M = e, F = e; F = F._parentComponent;) {
                (M = F).base = k;
              }

              k._component = M, k._componentConstructor = M.constructor;
            }
          }

          for (!m || n ? x.push(e) : w || (e.componentDidUpdate && e.componentDidUpdate(p, f, _), o.afterUpdate && o.afterUpdate(e)); e._renderCallbacks.length;) {
            e._renderCallbacks.pop().call(e);
          }

          S || r || E();
        }
      }

      function L(e) {
        o.beforeUnmount && o.beforeUnmount(e);
        var t = e.base;
        e._disable = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;
        var n = e._component;
        n ? L(n) : t && (null != t.__preactattr_ && u(t.__preactattr_.ref, null), e.nextBase = t, g(t), j.push(e), A(t)), u(e.__ref, null);
      }

      function F(e, t) {
        this._dirty = !0, this.context = t, this.props = e, this.state = this.state || {}, this._renderCallbacks = [];
      }

      function U(e, t, n) {
        return O(n, e, {}, !1, t, !1);
      }

      c(F.prototype, {
        setState: function setState(e, t) {
          this.prevState || (this.prevState = this.state), this.state = c(c({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), t && this._renderCallbacks.push(t), h(this);
        },
        forceUpdate: function forceUpdate(e) {
          e && this._renderCallbacks.push(e), R(this, 2);
        },
        render: function render() {}
      });
    }, function (e, t, n) {
      e.exports = function (e, t) {
        if (t = t.split(":")[0], !(e = +e)) return !1;

        switch (t) {
          case "http":
          case "ws":
            return 80 !== e;

          case "https":
          case "wss":
            return 443 !== e;

          case "ftp":
            return 21 !== e;

          case "gopher":
            return 70 !== e;

          case "file":
            return !1;
        }

        return 0 !== e;
      };
    }, function (e, t, n) {
      var r = Object.prototype.hasOwnProperty;

      function o(e) {
        return decodeURIComponent(e.replace(/\+/g, " "));
      }

      t.stringify = function (e, t) {
        t = t || "";
        var n,
            o,
            i = [];

        for (o in "string" != typeof t && (t = "?"), e) {
          r.call(e, o) && ((n = e[o]) || null != n && !isNaN(n) || (n = ""), i.push(encodeURIComponent(o) + "=" + encodeURIComponent(n)));
        }

        return i.length ? t + i.join("&") : "";
      }, t.parse = function (e) {
        for (var t, n = /([^=?&]+)=?([^&]*)/g, r = {}; t = n.exec(e);) {
          var i = o(t[1]),
              a = o(t[2]);
          i in r || (r[i] = a);
        }

        return r;
      };
    }, function (e, t, n) {
      (function (t) {
        var n = t.CustomEvent;
        e.exports = function () {
          try {
            var e = new n("cat", {
              detail: {
                foo: "bar"
              }
            });
            return "cat" === e.type && "bar" === e.detail.foo;
          } catch (e) {}

          return !1;
        }() ? n : "undefined" != typeof document && "function" == typeof document.createEvent ? function (e, t) {
          var n = document.createEvent("CustomEvent");
          return t ? n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail) : n.initCustomEvent(e, !1, !1, void 0), n;
        } : function (e, t) {
          var n = document.createEventObject();
          return n.type = e, t ? (n.bubbles = Boolean(t.bubbles), n.cancelable = Boolean(t.cancelable), n.detail = t.detail) : (n.bubbles = !1, n.cancelable = !1, n.detail = void 0), n;
        };
      }).call(t, n(25));
    }, function (e, t, n) {
      /*!
           * isobject <https://github.com/jonschlinkert/isobject>
           *
           * Copyright (c) 2014-2017, Jon Schlinkert.
           * Released under the MIT License.
           */
      e.exports = function (e) {
        return null != e && "object" == typeof e && !1 === Array.isArray(e);
      };
    }, function (e, t) {
      e.exports = function (e) {
        if ("string" != typeof e) return !1;
        var t = e.match(n);
        if (!t) return !1;
        var i = t[1];
        if (!i) return !1;
        if (r.test(i) || o.test(i)) return !0;
        return !1;
      };

      var n = /^(?:\w+:)?\/\/(\S+)$/,
          r = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/,
          o = /^[^\s\.]+\.\S{2,}$/;
    }, function (e, t, n) {
      var r;
      (function () {
        var n, o;
        o = null, n = function n(e) {
          var t, n;
          return null == e && (e = !1), null == o || e ? "loading" === document.readyState ? null : (t = document.createElement("div"), n = document.createElement("div"), t.style.width = n.style.width = t.style.height = n.style.height = "100px", t.style.overflow = "scroll", n.style.overflow = "hidden", document.body.appendChild(t), document.body.appendChild(n), o = Math.abs(t.scrollHeight - n.scrollHeight), document.body.removeChild(t), document.body.removeChild(n), o) : o;
        }, void 0 === (r = function () {
          return n;
        }.apply(t, [])) || (e.exports = r);
      }).call(this);
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        var r = n(47),
            o = n(89),
            i = n(90),
            a = n(91),
            s = n(92),
            c = n.n(s),
            u = /[A-Z]|^ms/g,
            l = Object(r.a)(function (e) {
          return e.replace(u, "-$&").toLowerCase();
        }),
            d = function d(e, t) {
          return null == t || "boolean" == typeof t ? "" : 1 === o.a[e] || 45 === e.charCodeAt(1) || isNaN(t) || 0 === t ? t : t + "px";
        };

        if ("production" !== e.env.NODE_ENV) {
          var p = /(attr|calc|counters?|url)\(/,
              f = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
              h = d;

          d = function d(e, t) {
            return "content" === e && ("string" != typeof t || -1 === f.indexOf(t) && !p.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0))) && console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`"), h(e, t);
          };
        }

        var m = function t(n) {
          for (var r = n.length, o = 0, i = ""; o < r; o++) {
            var a = n[o];

            if (null != a) {
              var s = void 0;

              switch (typeof a) {
                case "boolean":
                  break;

                case "function":
                  "production" !== e.env.NODE_ENV && console.error("Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\nPlease call the function before passing it to cx."), s = t([a()]);
                  break;

                case "object":
                  if (Array.isArray(a)) s = t(a);else for (var c in s = "", a) {
                    a[c] && c && (s && (s += " "), s += c);
                  }
                  break;

                default:
                  s = a;
              }

              s && (i && (i += " "), i += s);
            }
          }

          return i;
        },
            y = "undefined" != typeof document;

        function v(e) {
          var t = document.createElement("style");
          return t.setAttribute("data-emotion", e.key || ""), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), (void 0 !== e.container ? e.container : document.head).appendChild(t), t;
        }

        var b = function () {
          function t(t) {
            this.isSpeedy = "production" === e.env.NODE_ENV, this.tags = [], this.ctr = 0, this.opts = t;
          }

          var n = t.prototype;
          return n.inject = function () {
            if (this.injected) throw new Error("already injected!");
            this.tags[0] = v(this.opts), this.injected = !0;
          }, n.speedy = function (e) {
            if (0 !== this.ctr) throw new Error("cannot change speedy now");
            this.isSpeedy = !!e;
          }, n.insert = function (t, n) {
            if (this.isSpeedy) {
              var r = function (e) {
                if (e.sheet) return e.sheet;

                for (var t = 0; t < document.styleSheets.length; t++) {
                  if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
                }
              }(this.tags[this.tags.length - 1]);

              try {
                r.insertRule(t, r.cssRules.length);
              } catch (n) {
                "production" !== e.env.NODE_ENV && console.warn("illegal rule", t);
              }
            } else {
              var o = v(this.opts);
              this.tags.push(o), o.appendChild(document.createTextNode(t + (n || "")));
            }

            this.ctr++, this.ctr % 65e3 == 0 && this.tags.push(v(this.opts));
          }, n.flush = function () {
            this.tags.forEach(function (e) {
              return e.parentNode.removeChild(e);
            }), this.tags = [], this.ctr = 0, this.injected = !1;
          }, t;
        }();

        t.default = function (t, n) {
          if (void 0 !== t.__SECRET_EMOTION__) return t.__SECRET_EMOTION__;
          void 0 === n && (n = {});
          var r,
              o = n.key || "css";
          if ("production" !== e.env.NODE_ENV && /[^a-z-]/.test(o)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + o + '" was passed');
          var s,
              u = c()(function (e) {
            r += e, y && f.insert(e, v);
          });
          void 0 !== n.prefix && (s = {
            prefix: n.prefix
          });
          var p = {
            registered: {},
            inserted: {},
            nonce: n.nonce,
            key: o
          },
              f = new b(n);
          y && f.inject();
          var h = new a.a(s);
          h.use(n.stylisPlugins)(u);
          var v = "";

          function g(t, n) {
            if (null == t) return "";

            switch (typeof t) {
              case "boolean":
                return "";

              case "function":
                if (void 0 !== t.__emotion_styles) {
                  var r = t.toString();
                  if ("NO_COMPONENT_SELECTOR" === r && "production" !== e.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
                  return r;
                }

                return void 0 === this && "production" !== e.env.NODE_ENV && console.error("Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`"), g.call(this, void 0 === this ? t() : t(this.mergedProps, this.context), n);

              case "object":
                return S.call(this, t);

              default:
                var o = p.registered[t];
                return !1 === n && void 0 !== o ? o : t;
            }
          }

          var w,
              _,
              x = new WeakMap();

          function S(t) {
            if (x.has(t)) return x.get(t);
            var n = "";
            return Array.isArray(t) ? t.forEach(function (e) {
              n += g.call(this, e, !1);
            }, this) : Object.keys(t).forEach(function (r) {
              if ("object" != typeof t[r]) void 0 !== p.registered[t[r]] ? n += r + "{" + p.registered[t[r]] + "}" : n += l(r) + ":" + d(r, t[r]) + ";";else {
                if ("NO_COMPONENT_SELECTOR" === r && "production" !== e.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
                Array.isArray(t[r]) && "string" == typeof t[r][0] && void 0 === p.registered[t[r][0]] ? t[r].forEach(function (e) {
                  n += l(r) + ":" + d(r, e) + ";";
                }) : n += r + "{" + g.call(this, t[r], !1) + "}";
              }
            }, this), x.set(t, n), n;
          }

          var C = /label:\s*([^\s;\n{]+)\s*;/g,
              k = function k(e, t) {
            return Object(i.a)(e + t) + t;
          };

          if ("production" !== e.env.NODE_ENV) {
            var E = k,
                O = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

            k = function k(e, t) {
              return E(e.replace(O, function (e) {
                return v = e, "";
              }), t);
            };
          }

          var P = function P(e) {
            var t = !0,
                n = "",
                r = "";
            null == e || void 0 === e.raw ? (t = !1, n += g.call(this, e, !1)) : n += e[0];

            for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++) {
              i[a - 1] = arguments[a];
            }

            return i.forEach(function (r, o) {
              n += g.call(this, r, 46 === n.charCodeAt(n.length - 1)), !0 === t && void 0 !== e[o + 1] && (n += e[o + 1]);
            }, this), _ = n, n = n.replace(C, function (e, t) {
              return r += "-" + t, "";
            }), w = k(n, r), n;
          };

          if ("production" !== e.env.NODE_ENV) {
            var T = h;

            h = function h(e, t) {
              T(e, t), v = "";
            };
          }

          function A(e, t) {
            void 0 === p.inserted[w] && (r = "", h(e, t), p.inserted[w] = r);
          }

          var j = function j() {
            var e = P.apply(this, arguments),
                t = o + "-" + w;
            return void 0 === p.registered[t] && (p.registered[t] = _), A("." + t, e), t;
          };

          function N(e, t) {
            var n = "";
            return t.split(" ").forEach(function (t) {
              void 0 !== p.registered[t] ? e.push(t) : n += t + " ";
            }), n;
          }

          function M(e, t) {
            var n = [],
                r = N(n, e);
            return n.length < 2 ? e : r + j(n, t);
          }

          function I(e) {
            p.inserted[e] = !0;
          }

          if (y) {
            var R = document.querySelectorAll("[data-emotion-" + o + "]");
            Array.prototype.forEach.call(R, function (e) {
              f.tags[0].parentNode.insertBefore(e, f.tags[0]), e.getAttribute("data-emotion-" + o).split(" ").forEach(I);
            });
          }

          var L = {
            flush: function flush() {
              y && (f.flush(), f.inject()), p.inserted = {}, p.registered = {};
            },
            hydrate: function hydrate(e) {
              e.forEach(I);
            },
            cx: function cx() {
              for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                t[n] = arguments[n];
              }

              return M(m(t));
            },
            merge: M,
            getRegisteredStyles: N,
            injectGlobal: function injectGlobal() {
              var e = P.apply(this, arguments);
              A("", e);
            },
            keyframes: function keyframes() {
              var e = P.apply(this, arguments),
                  t = "animation-" + w;
              return A("", "@keyframes " + t + "{" + e + "}"), t;
            },
            css: j,
            sheet: f,
            caches: p
          };
          return t.__SECRET_EMOTION__ = L, L;
        };
      }.call(t, n(3));
    }, function (e, t, n) {
      t.a = {
        animationIterationCount: 1,
        borderImageOutset: 1,
        borderImageSlice: 1,
        borderImageWidth: 1,
        boxFlex: 1,
        boxFlexGroup: 1,
        boxOrdinalGroup: 1,
        columnCount: 1,
        columns: 1,
        flex: 1,
        flexGrow: 1,
        flexPositive: 1,
        flexShrink: 1,
        flexNegative: 1,
        flexOrder: 1,
        gridRow: 1,
        gridRowEnd: 1,
        gridRowSpan: 1,
        gridRowStart: 1,
        gridColumn: 1,
        gridColumnEnd: 1,
        gridColumnSpan: 1,
        gridColumnStart: 1,
        fontWeight: 1,
        lineHeight: 1,
        opacity: 1,
        order: 1,
        orphans: 1,
        tabSize: 1,
        widows: 1,
        zIndex: 1,
        zoom: 1,
        WebkitLineClamp: 1,
        fillOpacity: 1,
        floodOpacity: 1,
        stopOpacity: 1,
        strokeDasharray: 1,
        strokeDashoffset: 1,
        strokeMiterlimit: 1,
        strokeOpacity: 1,
        strokeWidth: 1
      };
    }, function (e, t, n) {
      t.a = function (e) {
        for (var t, n = e.length, r = n ^ n, o = 0; n >= 4;) {
          t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(o) | (255 & e.charCodeAt(++o)) << 8 | (255 & e.charCodeAt(++o)) << 16 | (255 & e.charCodeAt(++o)) << 24)) + ((1540483477 * (t >>> 16) & 65535) << 16), r = 1540483477 * (65535 & r) + ((1540483477 * (r >>> 16) & 65535) << 16) ^ (t = 1540483477 * (65535 & (t ^= t >>> 24)) + ((1540483477 * (t >>> 16) & 65535) << 16)), n -= 4, ++o;
        }

        switch (n) {
          case 3:
            r ^= (255 & e.charCodeAt(o + 2)) << 16;

          case 2:
            r ^= (255 & e.charCodeAt(o + 1)) << 8;

          case 1:
            r = 1540483477 * (65535 & (r ^= 255 & e.charCodeAt(o))) + ((1540483477 * (r >>> 16) & 65535) << 16);
        }

        return r = 1540483477 * (65535 & (r ^= r >>> 13)) + ((1540483477 * (r >>> 16) & 65535) << 16), ((r ^= r >>> 15) >>> 0).toString(36);
      };
    }, function (e, t, n) {
      t.a = function (e) {
        function t(e, t, r) {
          var o = t.trim().split(h);
          t = o;
          var i = o.length,
              a = e.length;

          switch (a) {
            case 0:
            case 1:
              var s = 0;

              for (e = 0 === a ? "" : e[0] + " "; s < i; ++s) {
                t[s] = n(e, t[s], r).trim();
              }

              break;

            default:
              var c = s = 0;

              for (t = []; s < i; ++s) {
                for (var u = 0; u < a; ++u) {
                  t[c++] = n(e[u] + " ", o[s], r).trim();
                }
              }

          }

          return t;
        }

        function n(e, t, n) {
          var r = t.charCodeAt(0);

          switch (33 > r && (r = (t = t.trim()).charCodeAt(0)), r) {
            case 38:
              return t.replace(m, "$1" + e.trim());

            case 58:
              return e.trim() + t.replace(m, "$1" + e.trim());

            default:
              if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(m, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
          }

          return e + t;
        }

        function r(e, t, n, i) {
          var a = e + ";",
              s = 2 * t + 3 * n + 4 * i;

          if (944 === s) {
            e = a.indexOf(":", 9) + 1;
            var c = a.substring(e, a.length - 1).trim();
            return c = a.substring(0, e).trim() + c + ";", 1 === T || 2 === T && o(c, 1) ? "-webkit-" + c + c : c;
          }

          if (0 === T || 2 === T && !o(a, 1)) return a;

          switch (s) {
            case 1015:
              return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;

            case 951:
              return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;

            case 963:
              return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;

            case 1009:
              if (100 !== a.charCodeAt(4)) break;

            case 969:
            case 942:
              return "-webkit-" + a + a;

            case 978:
              return "-webkit-" + a + "-moz-" + a + a;

            case 1019:
            case 983:
              return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;

            case 883:
              if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
              if (0 < a.indexOf("image-set(", 11)) return a.replace(k, "$1-webkit-$2") + a;
              break;

            case 932:
              if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
                case 103:
                  return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;

                case 115:
                  return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;

                case 98:
                  return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
              }
              return "-webkit-" + a + "-ms-" + a + a;

            case 964:
              return "-webkit-" + a + "-ms-flex-" + a + a;

            case 1023:
              if (99 !== a.charCodeAt(8)) break;
              return "-webkit-box-pack" + (c = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + a + "-ms-flex-pack" + c + a;

            case 1005:
              return p.test(a) ? a.replace(d, ":-webkit-") + a.replace(d, ":-moz-") + a : a;

            case 1e3:
              switch (t = (c = a.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(t)) {
                case 226:
                  c = a.replace(g, "tb");
                  break;

                case 232:
                  c = a.replace(g, "tb-rl");
                  break;

                case 220:
                  c = a.replace(g, "lr");
                  break;

                default:
                  return a;
              }

              return "-webkit-" + a + "-ms-" + c + a;

            case 1017:
              if (-1 === a.indexOf("sticky", 9)) break;

            case 975:
              switch (t = (a = e).length - 10, s = (c = (33 === a.charCodeAt(t) ? a.substring(0, t) : a).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))) {
                case 203:
                  if (111 > c.charCodeAt(8)) break;

                case 115:
                  a = a.replace(c, "-webkit-" + c) + ";" + a;
                  break;

                case 207:
                case 102:
                  a = a.replace(c, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + a.replace(c, "-webkit-" + c) + ";" + a.replace(c, "-ms-" + c + "box") + ";" + a;
              }

              return a + ";";

            case 938:
              if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
                case 105:
                  return c = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + c + "-ms-flex-" + c + a;

                case 115:
                  return "-webkit-" + a + "-ms-flex-item-" + a.replace(x, "") + a;

                default:
                  return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(x, "") + a;
              }
              break;

            case 973:
            case 989:
              if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

            case 931:
            case 953:
              if (!0 === C.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? r(e.replace("stretch", "fill-available"), t, n, i).replace(":fill-available", ":stretch") : a.replace(c, "-webkit-" + c) + a.replace(c, "-moz-" + c.replace("fill-", "")) + a;
              break;

            case 962:
              if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === n + i && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(f, "$1-webkit-$2") + a;
          }

          return a;
        }

        function o(e, t) {
          var n = e.indexOf(1 === t ? ":" : "{"),
              r = e.substring(0, 3 !== t ? n : 10);
          return n = e.substring(n + 1, e.length - 1), M(2 !== t ? r : r.replace(S, "$1"), n, t);
        }

        function i(e, t) {
          var n = r(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
          return n !== t + ";" ? n.replace(_, " or ($1)").substring(4) : "(" + t + ")";
        }

        function a(e, t, n, r, o, i, a, s, u, l) {
          for (var d, p = 0, f = t; p < N; ++p) {
            switch (d = j[p].call(c, e, f, n, r, o, i, a, s, u, l)) {
              case void 0:
              case !1:
              case !0:
              case null:
                break;

              default:
                f = d;
            }
          }

          if (f !== t) return f;
        }

        function s(e) {
          return void 0 !== (e = e.prefix) && (M = null, e ? "function" != typeof e ? T = 1 : (T = 2, M = e) : T = 0), s;
        }

        function c(e, n) {
          var s = e;

          if (33 > s.charCodeAt(0) && (s = s.trim()), s = [s], 0 < N) {
            var c = a(-1, n, s, s, O, E, 0, 0, 0, 0);
            void 0 !== c && "string" == typeof c && (n = c);
          }

          var d = function e(n, s, c, d, p) {
            for (var f, h, m, g, _, x = 0, S = 0, C = 0, k = 0, j = 0, M = 0, R = m = f = 0, L = 0, F = 0, U = 0, D = 0, V = c.length, W = V - 1, $ = "", z = "", B = "", q = ""; L < V;) {
              if (h = c.charCodeAt(L), L === W && 0 !== S + k + C + x && (0 !== S && (h = 47 === S ? 10 : 47), k = C = x = 0, V++, W++), 0 === S + k + C + x) {
                if (L === W && (0 < F && ($ = $.replace(l, "")), 0 < $.trim().length)) {
                  switch (h) {
                    case 32:
                    case 9:
                    case 59:
                    case 13:
                    case 10:
                      break;

                    default:
                      $ += c.charAt(L);
                  }

                  h = 59;
                }

                switch (h) {
                  case 123:
                    for (f = ($ = $.trim()).charCodeAt(0), m = 1, D = ++L; L < V;) {
                      switch (h = c.charCodeAt(L)) {
                        case 123:
                          m++;
                          break;

                        case 125:
                          m--;
                          break;

                        case 47:
                          switch (h = c.charCodeAt(L + 1)) {
                            case 42:
                            case 47:
                              e: {
                                for (R = L + 1; R < W; ++R) {
                                  switch (c.charCodeAt(R)) {
                                    case 47:
                                      if (42 === h && 42 === c.charCodeAt(R - 1) && L + 2 !== R) {
                                        L = R + 1;
                                        break e;
                                      }

                                      break;

                                    case 10:
                                      if (47 === h) {
                                        L = R + 1;
                                        break e;
                                      }

                                  }
                                }

                                L = R;
                              }

                          }

                          break;

                        case 91:
                          h++;

                        case 40:
                          h++;

                        case 34:
                        case 39:
                          for (; L++ < W && c.charCodeAt(L) !== h;) {
                            ;
                          }

                      }

                      if (0 === m) break;
                      L++;
                    }

                    switch (m = c.substring(D, L), 0 === f && (f = ($ = $.replace(u, "").trim()).charCodeAt(0)), f) {
                      case 64:
                        switch (0 < F && ($ = $.replace(l, "")), h = $.charCodeAt(1)) {
                          case 100:
                          case 109:
                          case 115:
                          case 45:
                            F = s;
                            break;

                          default:
                            F = A;
                        }

                        if (D = (m = e(s, F, m, h, p + 1)).length, 0 < N && (_ = a(3, m, F = t(A, $, U), s, O, E, D, h, p, d), $ = F.join(""), void 0 !== _ && 0 === (D = (m = _.trim()).length) && (h = 0, m = "")), 0 < D) switch (h) {
                          case 115:
                            $ = $.replace(w, i);

                          case 100:
                          case 109:
                          case 45:
                            m = $ + "{" + m + "}";
                            break;

                          case 107:
                            m = ($ = $.replace(y, "$1 $2")) + "{" + m + "}", m = 1 === T || 2 === T && o("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                            break;

                          default:
                            m = $ + m, 112 === d && (z += m, m = "");
                        } else m = "";
                        break;

                      default:
                        m = e(s, t(s, $, U), m, d, p + 1);
                    }

                    B += m, m = U = F = R = f = 0, $ = "", h = c.charCodeAt(++L);
                    break;

                  case 125:
                  case 59:
                    if (1 < (D = ($ = (0 < F ? $.replace(l, "") : $).trim()).length)) switch (0 === R && (f = $.charCodeAt(0), 45 === f || 96 < f && 123 > f) && (D = ($ = $.replace(" ", ":")).length), 0 < N && void 0 !== (_ = a(1, $, s, n, O, E, z.length, d, p, d)) && 0 === (D = ($ = _.trim()).length) && ($ = "\0\0"), f = $.charCodeAt(0), h = $.charCodeAt(1), f) {
                      case 0:
                        break;

                      case 64:
                        if (105 === h || 99 === h) {
                          q += $ + c.charAt(L);
                          break;
                        }

                      default:
                        58 !== $.charCodeAt(D - 1) && (z += r($, f, h, $.charCodeAt(2)));
                    }
                    U = F = R = f = 0, $ = "", h = c.charCodeAt(++L);
                }
              }

              switch (h) {
                case 13:
                case 10:
                  47 === S ? S = 0 : 0 === 1 + f && 107 !== d && 0 < $.length && (F = 1, $ += "\0"), 0 < N * I && a(0, $, s, n, O, E, z.length, d, p, d), E = 1, O++;
                  break;

                case 59:
                case 125:
                  if (0 === S + k + C + x) {
                    E++;
                    break;
                  }

                default:
                  switch (E++, g = c.charAt(L), h) {
                    case 9:
                    case 32:
                      if (0 === k + x + S) switch (j) {
                        case 44:
                        case 58:
                        case 9:
                        case 32:
                          g = "";
                          break;

                        default:
                          32 !== h && (g = " ");
                      }
                      break;

                    case 0:
                      g = "\\0";
                      break;

                    case 12:
                      g = "\\f";
                      break;

                    case 11:
                      g = "\\v";
                      break;

                    case 38:
                      0 === k + S + x && (F = U = 1, g = "\f" + g);
                      break;

                    case 108:
                      if (0 === k + S + x + P && 0 < R) switch (L - R) {
                        case 2:
                          112 === j && 58 === c.charCodeAt(L - 3) && (P = j);

                        case 8:
                          111 === M && (P = M);
                      }
                      break;

                    case 58:
                      0 === k + S + x && (R = L);
                      break;

                    case 44:
                      0 === S + C + k + x && (F = 1, g += "\r");
                      break;

                    case 34:
                    case 39:
                      0 === S && (k = k === h ? 0 : 0 === k ? h : k);
                      break;

                    case 91:
                      0 === k + S + C && x++;
                      break;

                    case 93:
                      0 === k + S + C && x--;
                      break;

                    case 41:
                      0 === k + S + x && C--;
                      break;

                    case 40:
                      if (0 === k + S + x) {
                        if (0 === f) switch (2 * j + 3 * M) {
                          case 533:
                            break;

                          default:
                            f = 1;
                        }
                        C++;
                      }

                      break;

                    case 64:
                      0 === S + C + k + x + R + m && (m = 1);
                      break;

                    case 42:
                    case 47:
                      if (!(0 < k + x + C)) switch (S) {
                        case 0:
                          switch (2 * h + 3 * c.charCodeAt(L + 1)) {
                            case 235:
                              S = 47;
                              break;

                            case 220:
                              D = L, S = 42;
                          }

                          break;

                        case 42:
                          47 === h && 42 === j && D + 2 !== L && (33 === c.charCodeAt(D + 2) && (z += c.substring(D, L + 1)), g = "", S = 0);
                      }
                  }

                  0 === S && ($ += g);
              }

              M = j, j = h, L++;
            }

            if (0 < (D = z.length)) {
              if (F = s, 0 < N && void 0 !== (_ = a(2, z, F, n, O, E, D, d, p, d)) && 0 === (z = _).length) return q + z + B;

              if (z = F.join(",") + "{" + z + "}", 0 != T * P) {
                switch (2 !== T || o(z, 2) || (P = 0), P) {
                  case 111:
                    z = z.replace(b, ":-moz-$1") + z;
                    break;

                  case 112:
                    z = z.replace(v, "::-webkit-input-$1") + z.replace(v, "::-moz-$1") + z.replace(v, ":-ms-input-$1") + z;
                }

                P = 0;
              }
            }

            return q + z + B;
          }(A, s, n, 0, 0);

          return 0 < N && void 0 !== (c = a(-2, d, s, s, O, E, d.length, 0, 0, 0)) && (d = c), "", P = 0, E = O = 1, d;
        }

        var u = /^\0+/g,
            l = /[\0\r\f]/g,
            d = /: */g,
            p = /zoo|gra/,
            f = /([,: ])(transform)/g,
            h = /,\r+?/g,
            m = /([\t\r\n ])*\f?&/g,
            y = /@(k\w+)\s*(\S*)\s*/,
            v = /::(place)/g,
            b = /:(read-only)/g,
            g = /[svh]\w+-[tblr]{2}/,
            w = /\(\s*(.*)\s*\)/g,
            _ = /([\s\S]*?);/g,
            x = /-self|flex-/g,
            S = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
            C = /stretch|:\s*\w+\-(?:conte|avail)/,
            k = /([^-])(image-set\()/,
            E = 1,
            O = 1,
            P = 0,
            T = 1,
            A = [],
            j = [],
            N = 0,
            M = null,
            I = 0;
        return c.use = function e(t) {
          switch (t) {
            case void 0:
            case null:
              N = j.length = 0;
              break;

            default:
              switch (t.constructor) {
                case Array:
                  for (var n = 0, r = t.length; n < r; ++n) {
                    e(t[n]);
                  }

                  break;

                case Function:
                  j[N++] = t;
                  break;

                case Boolean:
                  I = 0 | !!t;
              }

          }

          return e;
        }, c.set = s, void 0 !== e && s(e), c;
      };
    }, function (e, t, n) {
      e.exports = function (e) {
        function t(t) {
          if (t) try {
            e(t + "}");
          } catch (e) {}
        }

        return function (n, r, o, i, a, s, c, u, l, d) {
          switch (n) {
            case 1:
              if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
              break;

            case 2:
              if (0 === u) return r + "/*|*/";
              break;

            case 3:
              switch (u) {
                case 102:
                case 112:
                  return e(o[0] + r), "";

                default:
                  return r + (0 === d ? "/*|*/" : "");
              }

            case -2:
              r.split("/*|*/}").forEach(t);
          }
        };
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        var r = n(4),
            o = n.n(r),
            i = n(94);

        function a(e, t) {
          e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
        }

        var s,
            c = "__EMOTION_THEMING__",
            u = ((s = {})[c] = o.a.object, s);

        function l(e) {
          this.setState({
            theme: e
          });
        }

        var d = i.a,
            p = function p(e) {
          return "theme" !== e && "innerRef" !== e;
        },
            f = function f() {
          return !0;
        },
            h = function h(e, t) {
          for (var n = 2, r = arguments.length; n < r; n++) {
            var o = arguments[n],
                i = void 0;

            for (i in o) {
              e(i) && (t[i] = o[i]);
            }
          }

          return t;
        },
            m = !1;

        t.default = function (t, n) {
          var _r9 = function r(o, i) {
            if ("production" !== e.env.NODE_ENV && void 0 === o) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
            var s, y, v, b;
            void 0 !== i && (s = i.e, y = i.label, v = i.target, b = o.__emotion_forwardProp && i.shouldForwardProp ? function (e) {
              return o.__emotion_forwardProp(e) && i.shouldForwardProp(e);
            } : i.shouldForwardProp);
            var g = o.__emotion_real === o,
                w = void 0 === s && g && o.__emotion_base || o;
            return "function" != typeof b && (b = "string" == typeof w && w.charAt(0) === w.charAt(0).toLowerCase() ? d : p), function () {
              var d = arguments,
                  p = g && void 0 !== o.__emotion_styles ? o.__emotion_styles.slice(0) : [];
              if (void 0 !== y && p.push("label:" + y + ";"), void 0 === s) {
                if (null == d[0] || void 0 === d[0].raw) p.push.apply(p, d);else {
                  p.push(d[0][0]);

                  for (var _ = d.length, x = 1; x < _; x++) {
                    p.push(d[x], d[0][x]);
                  }
                }
              } else "production" === e.env.NODE_ENV || m || (console.warn("extractStatic is deprecated and will be removed in emotion@10. We recommend disabling extractStatic or using other libraries like linaria or css-literal-loader"), m = !0);

              var S = function (e) {
                function r() {
                  return e.apply(this, arguments) || this;
                }

                a(r, e);
                var o = r.prototype;
                return o.componentWillMount = function () {
                  void 0 !== this.context[c] && (this.unsubscribe = this.context[c].subscribe(l.bind(this)));
                }, o.componentWillUnmount = function () {
                  void 0 !== this.unsubscribe && this.context[c].unsubscribe(this.unsubscribe);
                }, o.render = function () {
                  var e = this.props,
                      r = this.state;
                  this.mergedProps = h(f, {}, e, {
                    theme: null !== r && r.theme || e.theme || {}
                  });
                  var o = "",
                      i = [];
                  return e.className && (o += void 0 === s ? t.getRegisteredStyles(i, e.className) : e.className + " "), o += void 0 === s ? t.css.apply(this, p.concat(i)) : s, void 0 !== v && (o += " " + v), n.createElement(w, h(b, {}, e, {
                    className: o,
                    ref: e.innerRef
                  }));
                }, r;
              }(n.Component);

              return S.displayName = void 0 !== y ? y : "Styled(" + ("string" == typeof w ? w : w.displayName || w.name || "Component") + ")", void 0 !== o.defaultProps && (S.defaultProps = o.defaultProps), S.contextTypes = u, S.__emotion_styles = p, S.__emotion_base = w, S.__emotion_real = S, S.__emotion_forwardProp = b, Object.defineProperty(S, "toString", {
                value: function value() {
                  return "production" !== e.env.NODE_ENV && void 0 === v ? "NO_COMPONENT_SELECTOR" : "." + v;
                }
              }), S.withComponent = function (e, t) {
                return _r9(e, void 0 !== t ? h(f, {}, i, t) : i).apply(void 0, p);
              }, S;
            };
          };

          return "production" !== e.env.NODE_ENV && "undefined" != typeof Proxy && (_r9 = new Proxy(_r9, {
            get: function get(e, t) {
              switch (t) {
                case "__proto__":
                case "name":
                case "prototype":
                case "displayName":
                  return e[t];

                default:
                  throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion.\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + t + "')` instead of `styled." + t + "`)");
              }
            }
          })), _r9;
        };
      }.call(t, n(3));
    }, function (e, t, n) {
      var r = n(47),
          o = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i,
          i = Object(r.a)(o.test.bind(o));
      t.a = i;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      },
          o = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
          i = n(2),
          a = u(i),
          s = u(n(4)),
          c = u(n(96));

      function u(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      var l = {
        lines: 16,
        length: 3,
        width: 3,
        radius: 14,
        color: "#FFFFFF",
        speed: 2.1,
        trail: 60,
        shadow: !1,
        hwaccel: !1,
        top: "50%",
        left: "50%",
        position: "absolute",
        zIndex: 999
      },
          d = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

          return n.getRef = n.getRef.bind(n), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), o(t, [{
          key: "componentDidMount",
          value: function value() {
            this.instantiateSpinner(this.props);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            e.config.color !== this.props.config.color ? (this.spinner.stop(), this.instantiateSpinner(e)) : !0 !== e.stopped || this.props.stopped ? e.stopped || !0 !== this.props.stopped || this.spinner.spin(this.container) : this.spinner.stop();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.spinner.stop();
          }
        }, {
          key: "getRef",
          value: function value(e) {
            this.container = e;
          }
        }, {
          key: "instantiateSpinner",
          value: function value(e) {
            this.spinner = new c.default(r({}, l, e.config)), e.stopped || this.spinner.spin(this.container);
          }
        }, {
          key: "render",
          value: function value() {
            return a.default.createElement("div", {
              ref: this.getRef
            });
          }
        }]), t;
      }(i.Component);

      d.propTypes = {
        config: s.default.object,
        stopped: s.default.bool,
        className: s.default.string,
        style: s.default.object
      }, d.defaultProps = {
        config: l,
        className: "",
        style: {}
      }, t.default = d;
    }, function (e, t, n) {
      var r, o, i;
      i = function i() {
        var e,
            t,
            n = ["webkit", "Moz", "ms", "O"],
            r = {};

        function o(e, t) {
          var n,
              r = document.createElement(e || "div");

          for (n in t) {
            r[n] = t[n];
          }

          return r;
        }

        function i(e) {
          for (var t = 1, n = arguments.length; t < n; t++) {
            e.appendChild(arguments[t]);
          }

          return e;
        }

        function a(n, o, i, a) {
          var s = ["opacity", o, ~~(100 * n), i, a].join("-"),
              c = .01 + i / a * 100,
              u = Math.max(1 - (1 - n) / o * (100 - c), n),
              l = e.substring(0, e.indexOf("Animation")).toLowerCase(),
              d = l && "-" + l + "-" || "";
          return r[s] || (t.insertRule("@" + d + "keyframes " + s + "{0%{opacity:" + u + "}" + c + "%{opacity:" + n + "}" + (c + .01) + "%{opacity:1}" + (c + o) % 100 + "%{opacity:" + n + "}100%{opacity:" + u + "}}", t.cssRules.length), r[s] = 1), s;
        }

        function s(e, t) {
          var r,
              o,
              i = e.style;
          if (void 0 !== i[t = t.charAt(0).toUpperCase() + t.slice(1)]) return t;

          for (o = 0; o < n.length; o++) {
            if (void 0 !== i[r = n[o] + t]) return r;
          }
        }

        function c(e, t) {
          for (var n in t) {
            e.style[s(e, n) || n] = t[n];
          }

          return e;
        }

        function u(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              void 0 === e[r] && (e[r] = n[r]);
            }
          }

          return e;
        }

        function l(e, t) {
          return "string" == typeof e ? e : e[t % e.length];
        }

        var d,
            p = {
          lines: 12,
          length: 7,
          width: 5,
          radius: 10,
          scale: 1,
          corners: 1,
          color: "#000",
          opacity: 1 / 4,
          rotate: 0,
          direction: 1,
          speed: 1,
          trail: 100,
          fps: 20,
          zIndex: 2e9,
          className: "spinner",
          top: "50%",
          left: "50%",
          shadow: !1,
          hwaccel: !1,
          position: "absolute"
        };

        function f(e) {
          this.opts = u(e || {}, f.defaults, p);
        }

        if (f.defaults = {}, u(f.prototype, {
          spin: function spin(t) {
            this.stop();
            var n = this,
                r = n.opts,
                i = n.el = o(null, {
              className: r.className
            });

            if (c(i, {
              position: r.position,
              width: 0,
              zIndex: r.zIndex,
              left: r.left,
              top: r.top
            }), t && t.insertBefore(i, t.firstChild || null), i.setAttribute("role", "progressbar"), n.lines(i, n.opts), !e) {
              var a,
                  s = 0,
                  u = (r.lines - 1) * (1 - r.direction) / 2,
                  l = r.fps,
                  d = l / r.speed,
                  p = (1 - r.opacity) / (d * r.trail / 100),
                  f = d / r.lines;
              !function e() {
                s++;

                for (var t = 0; t < r.lines; t++) {
                  a = Math.max(1 - (s + (r.lines - t) * f) % d * p, r.opacity), n.opacity(i, t * r.direction + u, a, r);
                }

                n.timeout = n.el && setTimeout(e, ~~(1e3 / l));
              }();
            }

            return n;
          },
          stop: function stop() {
            var e = this.el;
            return e && (clearTimeout(this.timeout), e.parentNode && e.parentNode.removeChild(e), this.el = void 0), this;
          },
          lines: function lines(t, n) {
            var r,
                s = 0,
                u = (n.lines - 1) * (1 - n.direction) / 2;

            function d(e, t) {
              return c(o(), {
                position: "absolute",
                width: n.scale * (n.length + n.width) + "px",
                height: n.scale * n.width + "px",
                background: e,
                boxShadow: t,
                transformOrigin: "left",
                transform: "rotate(" + ~~(360 / n.lines * s + n.rotate) + "deg) translate(" + n.scale * n.radius + "px,0)",
                borderRadius: (n.corners * n.scale * n.width >> 1) + "px"
              });
            }

            for (; s < n.lines; s++) {
              r = c(o(), {
                position: "absolute",
                top: 1 + ~(n.scale * n.width / 2) + "px",
                transform: n.hwaccel ? "translate3d(0,0,0)" : "",
                opacity: n.opacity,
                animation: e && a(n.opacity, n.trail, u + s * n.direction, n.lines) + " " + 1 / n.speed + "s linear infinite"
              }), n.shadow && i(r, c(d("#000", "0 0 4px #000"), {
                top: "2px"
              })), i(t, i(r, d(l(n.color, s), "0 0 1px rgba(0,0,0,.1)")));
            }

            return t;
          },
          opacity: function opacity(e, t, n) {
            t < e.childNodes.length && (e.childNodes[t].style.opacity = n);
          }
        }), "undefined" != typeof document) {
          d = o("style", {
            type: "text/css"
          }), i(document.getElementsByTagName("head")[0], d), t = d.sheet || d.styleSheet;
          var h = c(o("group"), {
            behavior: "url(#default#VML)"
          });
          !s(h, "transform") && h.adj ? function () {
            function e(e, t) {
              return o("<" + e + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', t);
            }

            t.addRule(".spin-vml", "behavior:url(#default#VML)"), f.prototype.lines = function (t, n) {
              var r = n.scale * (n.length + n.width),
                  o = 2 * n.scale * r;

              function a() {
                return c(e("group", {
                  coordsize: o + " " + o,
                  coordorigin: -r + " " + -r
                }), {
                  width: o,
                  height: o
                });
              }

              var s,
                  u = -(n.width + n.length) * n.scale * 2 + "px",
                  d = c(a(), {
                position: "absolute",
                top: u,
                left: u
              });

              function p(t, o, s) {
                i(d, i(c(a(), {
                  rotation: 360 / n.lines * t + "deg",
                  left: ~~o
                }), i(c(e("roundrect", {
                  arcsize: n.corners
                }), {
                  width: r,
                  height: n.scale * n.width,
                  left: n.scale * n.radius,
                  top: -n.scale * n.width >> 1,
                  filter: s
                }), e("fill", {
                  color: l(n.color, t),
                  opacity: n.opacity
                }), e("stroke", {
                  opacity: 0
                }))));
              }

              if (n.shadow) for (s = 1; s <= n.lines; s++) {
                p(s, -2, "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");
              }

              for (s = 1; s <= n.lines; s++) {
                p(s);
              }

              return i(t, d);
            }, f.prototype.opacity = function (e, t, n, r) {
              var o = e.firstChild;
              r = r.shadow && r.lines || 0, o && t + r < o.childNodes.length && (o = (o = (o = o.childNodes[t + r]) && o.firstChild) && o.firstChild) && (o.opacity = n);
            };
          }() : e = s(h, "animation");
        }

        return f;
      }, "object" == typeof e && e.exports ? e.exports = i() : void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o);
    }, function (e, t) {
      e.exports = "data:image/gif;base64,R0lGODlhEQARAIAAAODn7P///yH5BAEHAAEALAAAAAARABEAAAIqBIKpab3v3EMyVHWtWZluf0za0XFNKDJfCq5i5JpomdUxqKLQVmInqyoAADs=";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = s(n(2)),
          o = s(n(4)),
          i = n(17),
          a = s(i);

      function s(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      var c = (0, a.default)("div", {
        target: "e1m9xwad0"
      })("position:absolute;z-index:1001;top:0;right:0;font-size:20px;font-family:sans-serif;width:50px;height:50px;"),
          u = (0, i.css)("border-radius:0;display:block;height:2px;width:25px;position:absolute;right:6px;top:6px;"),
          l = (0, a.default)("span", {
        target: "e1m9xwad1"
      })(u, " background-color:", function (e) {
        return e.backgroundColor;
      }, ";transform:translate(0,13px) rotate3d(0,0,1,-135deg);"),
          d = (0, a.default)("span", {
        target: "e1m9xwad2"
      })(u, " background-color:", function (e) {
        return e.backgroundColor;
      }, ";transform:translate(0,13px) rotate3d(0,0,1,-45deg);"),
          p = function p(e) {
        var t = e.color,
            n = e.onClick,
            o = e.dataQa;
        return r.default.createElement(c, {
          "data-qa": o,
          onClick: n
        }, r.default.createElement(l, {
          backgroundColor: t
        }), r.default.createElement(d, {
          backgroundColor: t
        }));
      };

      p.propTypes = {
        color: o.default.string,
        dataQa: o.default.string,
        onClick: o.default.func
      }, t.default = p;
    }, function (e, t, n) {
      var r, o, i;
      o = [t, e], void 0 === (i = "function" == typeof (r = function r(e, t) {
        var n = 5e3,
            r = "callback";

        function o() {
          return "jsonp_" + Date.now() + "_" + Math.ceil(1e5 * Math.random());
        }

        function i(e) {
          try {
            delete window[e];
          } catch (t) {
            window[e] = void 0;
          }
        }

        function a(e) {
          var t = document.getElementById(e);
          t && document.getElementsByTagName("head")[0].removeChild(t);
        }

        t.exports = function (e) {
          var t = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
              s = e,
              c = t.timeout || n,
              u = t.jsonpCallback || r,
              l = void 0;
          return new Promise(function (n, r) {
            var d = t.jsonpCallbackFunction || o(),
                p = u + "_" + d;
            window[d] = function (e) {
              n({
                ok: !0,
                json: function json() {
                  return Promise.resolve(e);
                }
              }), l && clearTimeout(l), a(p), i(d);
            }, s += -1 === s.indexOf("?") ? "?" : "&";
            var f = document.createElement("script");
            f.setAttribute("src", "" + s + u + "=" + d), t.charset && f.setAttribute("charset", t.charset), f.id = p, document.getElementsByTagName("head")[0].appendChild(f), l = setTimeout(function () {
              r(new Error("JSONP request to " + e + " timed out")), i(d), a(p), window[d] = function () {
                i(d);
              };
            }, c), f.onerror = function () {
              r(new Error("JSONP request to " + e + " failed")), i(d), a(p), l && clearTimeout(l);
            };
          });
        };
      }) ? r.apply(t, o) : r) || (e.exports = i);
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      };

      t.default = function (e, t, n) {
        n = r({}, l, n);
        var u = (0, s.isMobile)(navigator.userAgent),
            p = (0, a.replaceExistingKeys)(n, d);
        u && (p = r({}, (0, a.omit)("embed-opacity", p), {
          "add-placeholder-ws": !0
        }));
        var f = (0, a.appendParamsToUrl)(t, p);
        (0, i.render)(o.default.createElement(c.default, {
          enabledFullscreen: u,
          options: n,
          url: f
        }), e);
      };

      var o = u(n(2)),
          i = n(2),
          a = n(9),
          s = n(16),
          c = u(n(101));

      function u(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      var l = {
        mode: "embed-widget",
        hideFooter: !1,
        hideHeaders: !1,
        hideScrollbars: !1,
        disableTracking: !1,
        onSubmit: a.noop
      },
          d = {
        mode: "typeform-embed",
        hideFooter: "embed-hide-footer",
        hideHeaders: "embed-hide-headers",
        opacity: "embed-opacity",
        disableTracking: "disable-tracking"
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
          o = n(2),
          i = m(o),
          a = m(n(4)),
          s = n(17),
          c = m(s),
          u = n(9),
          l = m(n(45)),
          d = m(n(49)),
          p = m(n(50)),
          f = m(n(26)),
          h = m(n(48));

      function m(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      var y = (0, c.default)("div", {
        target: "e12baen60"
      })("height:100%;position:relative;"),
          v = (0, s.keyframes)("10%{opacity:1;}25%{top:0;left:0;width:100%;height:100%;opacity:1;}70%{top:0;left:0;width:100%;height:100%;opacity:1;}100%{top:0;left:0;width:100%;height:100%;opacity:0;}"),
          b = (0, s.keyframes)("100%{opacity:0;}75%{opacity:1;}25%{opacity:1;}0%{opacity:0;}"),
          g = (0, c.default)("div", {
        target: "e12baen61"
      })("position:fixed;top:", function (e) {
        return e.top;
      }, "px;left:", function (e) {
        return e.left;
      }, "px;height:", function (e) {
        return e.height ? e.height + "px" : "100%";
      }, ";width:", function (e) {
        return e.width ? e.width + "px" : "100%";
      }, ";animation:", function (e) {
        return e.open ? v : b;
      }, " 1.5s ease;visibility:", function (e) {
        return e.visible ? "visible" : "hidden";
      }, ";background:", function (e) {
        return e.backgroundColor;
      }, ";opacity:0;pointer-events:none;"),
          w = (0, c.default)("div", {
        target: "e12baen62"
      })("height:100%;width:100%;overflow:hidden;background:", function (e) {
        return e.backgroundColor;
      }, ";"),
          _ = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

          return n.embedId = (0, l.default)(), n.mobileEmbedId = (0, l.default)(), n.state = {
            isFormReady: !1,
            isIframeFocused: !1,
            isFullscreen: !1,
            closeIconColor: "black",
            backgroundColor: "transparent"
          }, n.handleMessage = n.handleMessage.bind(n), n.handleFormReady = (0, u.callIfEmbedIdMatches)(n.handleFormReady.bind(n), n.embedId), n.handleFormSubmit = (0, u.callIfEmbedIdMatches)(n.handleFormSubmit.bind(n), n.embedId), n.goFullScreen = (0, u.callIfEmbedIdMatches)(n.goFullScreen.bind(n), n.embedId), n.focusIframe = n.focusIframe.bind(n), n.handleClose = n.handleClose.bind(n), n.reloadIframe = n.reloadIframe.bind(n), n.debouncedScroll = (0, u.debounce)(n.focusIframe, 200, n), n.setIframeRef = n.setIframeRef.bind(n), n;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), r(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = this;
            window.addEventListener("message", this.handleMessage), window.addEventListener("form-ready", this.handleFormReady), window.addEventListener("scroll", this.debouncedScroll), window.addEventListener("form-submit", this.handleFormSubmit), window.addEventListener("welcome-screen-hidden", this.goFullScreen), window.addEventListener("redirect-after-submit", u.redirectToUrl), window.addEventListener("thank-you-screen-redirect", u.redirectToUrl);
            var t = d.default.getUidFromURL(this.props.url);
            d.default.getFormData(t, u.DOMAIN).then(function (n) {
              return (0, p.default)(t, "", e.props.url, "", n);
            }).then(function (t) {
              e.setState({
                closeIconColor: "#" + t.form["button-color"],
                backgroundColor: "#" + t.form["background-color"]
              });
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            window.removeEventListener("message", this.handleMessage), window.removeEventListener("form-ready", this.handleFormReady), window.removeEventListener("scroll", this.debouncedScroll), window.removeEventListener("form-submit", this.handleFormSubmit), window.removeEventListener("welcome-screen-hidden", this.goFullScreen), window.removeEventListener("redirect-after-submit", u.redirectToUrl), window.removeEventListener("thank-you-screen-redirect", u.redirectToUrl);
          }
        }, {
          key: "setIframeRef",
          value: function value(e) {
            this.iframe = e;
          }
        }, {
          key: "goFullScreen",
          value: function value() {
            this.props.enabledFullscreen && (this.setState({
              isFullscreen: !0
            }), setTimeout(this.reloadIframe, 3e3));
          }
        }, {
          key: "handleClose",
          value: function value() {
            this.setState({
              isFullscreen: !1
            });
          }
        }, {
          key: "handleFormReady",
          value: function value() {
            var e = this;
            this.setState({
              isFormReady: !0
            }, function () {
              e.focusIframe();
            });
          }
        }, {
          key: "handleMessage",
          value: function value(e) {
            (0, u.broadcastMessage)(this.embedId, e);
          }
        }, {
          key: "handleFormSubmit",
          value: function value() {
            this.props.options.onSubmit && this.props.options.onSubmit();
          }
        }, {
          key: "reloadIframe",
          value: function value() {
            this.iframe.iframeRef.src = this.iframe.iframeRef.src;
          }
        }, {
          key: "focusIframe",
          value: function value() {
            if (!this.props.enabledFullscreen) {
              var e = this.iframe.iframeRef;

              if (e && e.contentWindow) {
                var t = (0, u.isElementInViewport)(e);
                this.state.isFormReady && !this.state.isIframeFocused && t && null != e.contentWindow && (e.contentWindow.postMessage("embed-focus", "*"), this.setState({
                  isIframeFocused: !0
                }));
              }
            }
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.state,
                t = e.isFullscreen,
                n = e.closeIconColor,
                r = e.backgroundColor,
                o = e.isFormReady,
                a = this.props,
                s = a.enabledFullscreen,
                c = a.options,
                l = a.url,
                d = this.iframe && this.iframe.iframeRef.getBoundingClientRect(),
                p = (0, u.updateQueryStringParameter)("typeform-embed-id", this.embedId, l);
            s && (p = (0, u.updateQueryStringParameter)("disable-tracking", "true", p));
            var m = (0, u.updateQueryStringParameter)("typeform-welcome", "0", l);
            return i.default.createElement(y, null, i.default.createElement(w, {
              backgroundColor: s ? r : "transparent"
            }, i.default.createElement(f.default, {
              frameBorder: "0",
              height: "100%",
              ref: this.setIframeRef,
              src: p,
              width: "100%"
            })), s && i.default.createElement(g, {
              backgroundColor: r,
              bottom: d && d.bottom,
              height: d && d.height,
              left: d && d.left,
              open: t,
              right: d && d.right,
              top: d && d.top,
              visible: o,
              width: d && d.width
            }), s && i.default.createElement(h.default, {
              backgroundColor: r,
              buttonColor: n,
              embedId: this.mobileEmbedId,
              onClose: this.handleClose,
              onSubmit: c.onSubmit,
              open: t,
              openDelay: .3,
              url: m
            }));
          }
        }]), t;
      }(o.Component);

      _.propTypes = {
        url: a.default.string,
        options: a.default.object.isRequired,
        enabledFullscreen: a.default.bool,
        embedId: a.default.string
      }, _.defaultProps = {
        options: {},
        enabledFullscreen: !1
      }, t.default = _;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      };

      t.default = function (e, t, n) {
        n = r({}, c, n), e.src = (0, i.appendParamsToUrl)(t, (0, i.replaceExistingKeys)(n, u));
        (0, i.ensureMetaViewport)(), e.onload = function () {
          setTimeout(function () {
            e.style.height = "", (0, i.applyIOSFooterHack)(e), (0, i.applyIOSIframeResizeHack)(e);
          }, 1), e.contentWindow.focus();
        }, window.addEventListener("message", s.default), window.addEventListener("form-submit", function () {
          n.onSubmit();
        }), window.addEventListener("redirect-after-submit", i.redirectToUrl), window.addEventListener("thank-you-screen-redirect", i.redirectToUrl);
      };

      var o,
          i = n(9),
          a = n(44),
          s = (o = a) && o.__esModule ? o : {
        default: o
      };
      var c = {
        mode: "embed-fullpage",
        disableTracking: !1,
        onSubmit: i.noop
      },
          u = {
        mode: "typeform-embed",
        disableTracking: "disable-tracking"
      };
    }, function (e, t, n) {
      var r = n(104);
      n(12)({
        target: "Object",
        stat: !0,
        forced: Object.assign !== r
      }, {
        assign: r
      });
    }, function (e, t, n) {
      var r = n(51),
          o = n(53),
          i = n(54),
          a = n(33),
          s = n(27),
          c = Object.assign;
      e.exports = !c || n(10)(function () {
        var e = {},
            t = {},
            n = Symbol();
        return e[n] = 7, "abcdefghijklmnopqrst".split("").forEach(function (e) {
          t[e] = e;
        }), 7 != c({}, e)[n] || "abcdefghijklmnopqrst" != r(c({}, t)).join("");
      }) ? function (e, t) {
        for (var n = a(e), c = arguments.length, u = 1, l = o.f, d = i.f; c > u;) {
          for (var p, f = s(arguments[u++]), h = l ? r(f).concat(l(f)) : r(f), m = h.length, y = 0; m > y;) {
            d.call(f, p = h[y++]) && (n[p] = f[p]);
          }
        }

        return n;
      } : c;
    }, function (e, t, n) {
      var r = n(18),
          o = n(29),
          i = n(106);

      e.exports = function (e) {
        return function (t, n, a) {
          var s,
              c = r(t),
              u = o(c.length),
              l = i(a, u);

          if (e && n != n) {
            for (; u > l;) {
              if ((s = c[l++]) != s) return !0;
            }
          } else for (; u > l; l++) {
            if ((e || l in c) && c[l] === n) return e || l || 0;
          }

          return !e && -1;
        };
      };
    }, function (e, t, n) {
      var r = n(30),
          o = Math.max,
          i = Math.min;

      e.exports = function (e, t) {
        var n = r(e);
        return n < 0 ? o(n + t, 0) : i(n, t);
      };
    }, function (e, t, n) {
      var r = n(57),
          o = n(0).WeakMap;
      e.exports = "function" == typeof o && /native code/.test(r.call(o));
    }, function (e, t, n) {
      var r = n(7),
          o = n(109),
          i = n(34),
          a = n(14);

      e.exports = function (e, t) {
        for (var n = o(t), s = a.f, c = i.f, u = 0; u < n.length; u++) {
          var l = n[u];
          r(e, l) || s(e, l, c(t, l));
        }
      };
    }, function (e, t, n) {
      var r = n(110),
          o = n(53),
          i = n(6),
          a = n(0).Reflect;

      e.exports = a && a.ownKeys || function (e) {
        var t = r.f(i(e)),
            n = o.f;
        return n ? t.concat(n(e)) : t;
      };
    }, function (e, t, n) {
      var r = n(52),
          o = n(32).concat("length", "prototype");

      t.f = Object.getOwnPropertyNames || function (e) {
        return r(e, o);
      };
    }, function (e, t, n) {
      var r = n(112)(5),
          o = !0;
      "find" in [] && Array(1).find(function () {
        o = !1;
      }), n(12)({
        target: "Array",
        proto: !0,
        forced: o
      }, {
        find: function find(e) {
          return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), n(60)("find");
    }, function (e, t, n) {
      var r = n(39),
          o = n(27),
          i = n(33),
          a = n(29),
          s = n(113);

      e.exports = function (e, t) {
        var n = 1 == e,
            c = 2 == e,
            u = 3 == e,
            l = 4 == e,
            d = 6 == e,
            p = 5 == e || d,
            f = t || s;
        return function (t, s, h) {
          for (var m, y, v = i(t), b = o(v), g = r(s, h, 3), w = a(b.length), _ = 0, x = n ? f(t, w) : c ? f(t, 0) : void 0; w > _; _++) {
            if ((p || _ in b) && (y = g(m = b[_], _, v), e)) if (n) x[_] = y;else if (y) switch (e) {
              case 3:
                return !0;

              case 5:
                return m;

              case 6:
                return _;

              case 2:
                x.push(m);
            } else if (l) return !1;
          }

          return d ? -1 : u || l ? l : x;
        };
      };
    }, function (e, t, n) {
      var r = n(5),
          o = n(114),
          i = n(1)("species");

      e.exports = function (e, t) {
        var n;
        return o(e) && ("function" != typeof (n = e.constructor) || n !== Array && !o(n.prototype) ? r(n) && null === (n = n[i]) && (n = void 0) : n = void 0), new (void 0 === n ? Array : n)(0 === t ? 0 : t);
      };
    }, function (e, t, n) {
      var r = n(11);

      e.exports = Array.isArray || function (e) {
        return "Array" == r(e);
      };
    }, function (e, t, n) {
      e.exports = !n(10)(function () {
        return !String(Symbol());
      });
    }, function (e, t, n) {
      var r = n(13),
          o = n(14),
          i = n(6),
          a = n(51);
      e.exports = r ? Object.defineProperties : function (e, t) {
        i(e);

        for (var n, r = a(t), s = r.length, c = 0; s > c;) {
          o.f(e, n = r[c++], t[n]);
        }

        return e;
      };
    }, function (e, t, n) {
      var r = n(118),
          o = Math.abs;
      n(12)({
        target: "Number",
        stat: !0
      }, {
        isSafeInteger: function isSafeInteger(e) {
          return r(e) && o(e) <= 9007199254740991;
        }
      });
    }, function (e, t, n) {
      var r = n(5),
          o = Math.floor;

      e.exports = function (e) {
        return !r(e) && isFinite(e) && o(e) === e;
      };
    }, function (e, t, n) {
      n(120), n(122), n(128), n(131), n(143), e.exports = n(41).Promise;
    }, function (e, t, n) {
      var r = n(121),
          o = Object.prototype;
      r !== o.toString && n(19)(o, "toString", r, {
        unsafe: !0
      });
    }, function (e, t, n) {
      var r = n(63),
          o = {};
      o[n(1)("toStringTag")] = "z", e.exports = "[object z]" !== String(o) ? function () {
        return "[object " + r(this) + "]";
      } : o.toString;
    }, function (e, t, n) {
      var r = n(123),
          o = n(22),
          i = n(64),
          a = o.set,
          s = o.getterFor("String Iterator");
      i(String, "String", function (e) {
        a(this, {
          type: "String Iterator",
          string: String(e),
          index: 0
        });
      }, function () {
        var e,
            t = s(this),
            n = t.string,
            o = t.index;
        return o >= n.length ? {
          value: void 0,
          done: !0
        } : (e = r(n, o, !0), t.index += e.length, {
          value: e,
          done: !1
        });
      });
    }, function (e, t, n) {
      var r = n(30),
          o = n(28);

      e.exports = function (e, t, n) {
        var i,
            a,
            s = String(o(e)),
            c = r(t),
            u = s.length;
        return c < 0 || c >= u ? n ? "" : void 0 : (i = s.charCodeAt(c)) < 55296 || i > 56319 || c + 1 === u || (a = s.charCodeAt(c + 1)) < 56320 || a > 57343 ? n ? s.charAt(c) : i : n ? s.slice(c, c + 2) : a - 56320 + (i - 55296 << 10) + 65536;
      };
    }, function (e, t, n) {
      var r = n(65).IteratorPrototype,
          o = n(61),
          i = n(35),
          a = n(40),
          s = n(15),
          c = function c() {
        return this;
      };

      e.exports = function (e, t, n) {
        var u = t + " Iterator";
        return e.prototype = o(r, {
          next: i(1, n)
        }), a(e, u, !1, !0), s[u] = c, e;
      };
    }, function (e, t, n) {
      e.exports = !n(10)(function () {
        function e() {}

        return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
      });
    }, function (e, t, n) {
      var r = n(127);
      e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
        var e,
            t = !1,
            n = {};

        try {
          (e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(n, []), t = n instanceof Array;
        } catch (e) {}

        return function (n, o) {
          return r(n, o), t ? e.call(n, o) : n.__proto__ = o, n;
        };
      }() : void 0);
    }, function (e, t, n) {
      var r = n(5),
          o = n(6);

      e.exports = function (e, t) {
        if (o(e), !r(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
      };
    }, function (e, t, n) {
      var r = n(129),
          o = n(130),
          i = n(0),
          a = n(8),
          s = n(1),
          c = s("iterator"),
          u = s("toStringTag"),
          l = o.values;

      for (var d in r) {
        var p = i[d],
            f = p && p.prototype;

        if (f) {
          if (f[c] !== l) try {
            a(f, c, l);
          } catch (e) {
            f[c] = l;
          }
          if (f[u] || a(f, u, d), r[d]) for (var h in o) {
            if (f[h] !== o[h]) try {
              a(f, h, o[h]);
            } catch (e) {
              f[h] = o[h];
            }
          }
        }
      }
    }, function (e, t) {
      e.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
      };
    }, function (e, t, n) {
      var r = n(18),
          o = n(60),
          i = n(15),
          a = n(22),
          s = n(64),
          c = a.set,
          u = a.getterFor("Array Iterator");
      e.exports = s(Array, "Array", function (e, t) {
        c(this, {
          type: "Array Iterator",
          target: r(e),
          index: 0,
          kind: t
        });
      }, function () {
        var e = u(this),
            t = e.target,
            n = e.kind,
            r = e.index++;
        return !t || r >= t.length ? (e.target = void 0, {
          value: void 0,
          done: !0
        }) : "keys" == n ? {
          value: r,
          done: !1
        } : "values" == n ? {
          value: t[r],
          done: !1
        } : {
          value: [r, t[r]],
          done: !1
        };
      }, "values"), i.Arguments = i.Array, o("keys"), o("values"), o("entries");
    }, function (e, t, n) {
      var r,
          o,
          i,
          a = "Promise",
          s = n(21),
          c = n(0),
          u = n(12),
          l = n(5),
          d = n(23),
          p = n(132),
          f = n(11),
          h = n(133),
          m = n(137),
          y = n(67),
          v = n(68).set,
          b = n(138),
          g = n(70),
          w = n(139),
          _ = n(71),
          x = n(140),
          S = n(69),
          C = n(1)("species"),
          k = n(22),
          E = n(59),
          O = k.get,
          P = k.set,
          T = k.getterFor(a),
          _A = c[a],
          j = c.TypeError,
          N = c.document,
          M = c.process,
          I = c.fetch,
          R = M && M.versions,
          L = R && R.v8 || "",
          F = _.f,
          U = F,
          D = "process" == f(M),
          V = !!(N && N.createEvent && c.dispatchEvent),
          W = E(a, function () {
        var e = _A.resolve(1),
            t = function t() {},
            n = (e.constructor = {})[C] = function (e) {
          e(t, t);
        };

        return !((D || "function" == typeof PromiseRejectionEvent) && (!s || e.finally) && e.then(t) instanceof n && 0 !== L.indexOf("6.6") && -1 === S.indexOf("Chrome/66"));
      }),
          $ = W || !m(function (e) {
        _A.all(e).catch(function () {});
      }),
          z = function z(e) {
        var t;
        return !(!l(e) || "function" != typeof (t = e.then)) && t;
      },
          B = function B(e, t, n) {
        if (!t.notified) {
          t.notified = !0;
          var r = t.reactions;
          b(function () {
            for (var o = t.value, i = 1 == t.state, a = 0, s = function s(n) {
              var r,
                  a,
                  s,
                  c = i ? n.ok : n.fail,
                  u = n.resolve,
                  l = n.reject,
                  d = n.domain;

              try {
                c ? (i || (2 === t.rejection && K(e, t), t.rejection = 1), !0 === c ? r = o : (d && d.enter(), r = c(o), d && (d.exit(), s = !0)), r === n.promise ? l(j("Promise-chain cycle")) : (a = z(r)) ? a.call(r, u, l) : u(r)) : l(o);
              } catch (e) {
                d && !s && d.exit(), l(e);
              }
            }; r.length > a;) {
              s(r[a++]);
            }

            t.reactions = [], t.notified = !1, n && !t.rejection && H(e, t);
          });
        }
      },
          q = function q(e, t, n) {
        var r, o;
        V ? ((r = N.createEvent("Event")).promise = t, r.reason = n, r.initEvent(e, !1, !0), c.dispatchEvent(r)) : r = {
          promise: t,
          reason: n
        }, (o = c["on" + e]) ? o(r) : "unhandledrejection" === e && w("Unhandled promise rejection", n);
      },
          H = function H(e, t) {
        v.call(c, function () {
          var n,
              r = t.value;
          if (G(t) && (n = x(function () {
            D ? M.emit("unhandledRejection", r, e) : q("unhandledrejection", e, r);
          }), t.rejection = D || G(t) ? 2 : 1, n.error)) throw n.value;
        });
      },
          G = function G(e) {
        return 1 !== e.rejection && !e.parent;
      },
          K = function K(e, t) {
        v.call(c, function () {
          D ? M.emit("rejectionHandled", e) : q("rejectionhandled", e, t.value);
        });
      },
          Y = function Y(e, t, n, r) {
        return function (o) {
          e(t, n, o, r);
        };
      },
          J = function J(e, t, n, r) {
        t.done || (t.done = !0, r && (t = r), t.value = n, t.state = 2, B(e, t, !0));
      },
          Q = function Q(e, t, n, r) {
        if (!t.done) {
          t.done = !0, r && (t = r);

          try {
            if (e === n) throw j("Promise can't be resolved itself");
            var o = z(n);
            o ? b(function () {
              var r = {
                done: !1
              };

              try {
                o.call(n, Y(Q, e, r, t), Y(J, e, r, t));
              } catch (n) {
                J(e, r, n, t);
              }
            }) : (t.value = n, t.state = 1, B(e, t, !1));
          } catch (n) {
            J(e, {
              done: !1
            }, n, t);
          }
        }
      };

      W && (_A = function A(e) {
        p(this, _A, a), d(e), r.call(this);
        var t = O(this);

        try {
          e(Y(Q, this, t), Y(J, this, t));
        } catch (e) {
          J(this, t, e);
        }
      }, (r = function r(e) {
        P(this, {
          type: a,
          done: !1,
          notified: !1,
          parent: !1,
          reactions: [],
          rejection: !1,
          state: 0,
          value: void 0
        });
      }).prototype = n(141)(_A.prototype, {
        then: function then(e, t) {
          var n = T(this),
              r = F(y(this, _A));
          return r.ok = "function" != typeof e || e, r.fail = "function" == typeof t && t, r.domain = D ? M.domain : void 0, n.parent = !0, n.reactions.push(r), 0 != n.state && B(this, n, !1), r.promise;
        },
        catch: function _catch(e) {
          return this.then(void 0, e);
        }
      }), o = function o() {
        var e = new r(),
            t = O(e);
        this.promise = e, this.resolve = Y(Q, e, t), this.reject = Y(J, e, t);
      }, _.f = F = function F(e) {
        return e === _A || e === i ? new o(e) : U(e);
      }, s || "function" != typeof I || u({
        global: !0,
        enumerable: !0,
        forced: !0
      }, {
        fetch: function fetch(e) {
          return g(_A, I.apply(c, arguments));
        }
      })), u({
        global: !0,
        wrap: !0,
        forced: W
      }, {
        Promise: _A
      }), n(40)(_A, a, !1, !0), n(142)(a), i = n(41)[a], u({
        target: a,
        stat: !0,
        forced: W
      }, {
        reject: function reject(e) {
          var t = F(this);
          return t.reject.call(void 0, e), t.promise;
        }
      }), u({
        target: a,
        stat: !0,
        forced: s || W
      }, {
        resolve: function resolve(e) {
          return g(s && this === i ? _A : this, e);
        }
      }), u({
        target: a,
        stat: !0,
        forced: $
      }, {
        all: function all(e) {
          var t = this,
              n = F(t),
              r = n.resolve,
              o = n.reject,
              i = x(function () {
            var n = [],
                i = 0,
                a = 1;
            h(e, function (e) {
              var s = i++,
                  c = !1;
              n.push(void 0), a++, t.resolve(e).then(function (e) {
                c || (c = !0, n[s] = e, --a || r(n));
              }, o);
            }), --a || r(n);
          });
          return i.error && o(i.value), n.promise;
        },
        race: function race(e) {
          var t = this,
              n = F(t),
              r = n.reject,
              o = x(function () {
            h(e, function (e) {
              t.resolve(e).then(n.resolve, r);
            });
          });
          return o.error && r(o.value), n.promise;
        }
      });
    }, function (e, t) {
      e.exports = function (e, t, n) {
        if (!(e instanceof t)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
        return e;
      };
    }, function (e, t, n) {
      var r = n(6),
          o = n(134),
          i = n(29),
          a = n(39),
          s = n(135),
          c = n(136),
          u = {};
      (e.exports = function (e, t, n, l, d) {
        var p,
            f,
            h,
            m,
            y,
            v = a(t, n, l ? 2 : 1);
        if (d) p = e;else {
          if ("function" != typeof (f = s(e))) throw TypeError("Target is not iterable");

          if (o(f)) {
            for (h = 0, m = i(e.length); m > h; h++) {
              if ((l ? v(r(y = e[h])[0], y[1]) : v(e[h])) === u) return u;
            }

            return;
          }

          p = f.call(e);
        }

        for (; !(y = p.next()).done;) {
          if (c(p, v, y.value, l) === u) return u;
        }
      }).BREAK = u;
    }, function (e, t, n) {
      var r = n(15),
          o = n(1)("iterator"),
          i = Array.prototype;

      e.exports = function (e) {
        return void 0 !== e && (r.Array === e || i[o] === e);
      };
    }, function (e, t, n) {
      var r = n(63),
          o = n(1)("iterator"),
          i = n(15);

      e.exports = function (e) {
        if (null != e) return e[o] || e["@@iterator"] || i[r(e)];
      };
    }, function (e, t, n) {
      var r = n(6);

      e.exports = function (e, t, n, o) {
        try {
          return o ? t(r(n)[0], n[1]) : t(n);
        } catch (t) {
          var i = e.return;
          throw void 0 !== i && r(i.call(e)), t;
        }
      };
    }, function (e, t, n) {
      var r = n(1)("iterator"),
          o = !1;

      try {
        var i = 0,
            a = {
          next: function next() {
            return {
              done: !!i++
            };
          },
          return: function _return() {
            o = !0;
          }
        };
        a[r] = function () {
          return this;
        }, Array.from(a, function () {
          throw 2;
        });
      } catch (e) {}

      e.exports = function (e, t) {
        if (!t && !o) return !1;
        var n = !1;

        try {
          var i = {};
          i[r] = function () {
            return {
              next: function next() {
                return {
                  done: n = !0
                };
              }
            };
          }, e(i);
        } catch (e) {}

        return n;
      };
    }, function (e, t, n) {
      var r,
          o,
          i,
          a,
          s,
          c,
          u,
          l = n(0),
          d = n(34).f,
          p = n(11),
          f = n(68).set,
          h = n(69),
          m = l.MutationObserver || l.WebKitMutationObserver,
          y = l.process,
          v = l.Promise,
          b = "process" == p(y),
          g = d(l, "queueMicrotask"),
          w = g && g.value;
      w || (r = function r() {
        var e, t;

        for (b && (e = y.domain) && e.exit(); o;) {
          t = o.fn, o = o.next;

          try {
            t();
          } catch (e) {
            throw o ? a() : i = void 0, e;
          }
        }

        i = void 0, e && e.enter();
      }, b ? a = function a() {
        y.nextTick(r);
      } : m && !/(iPhone|iPod|iPad).*AppleWebKit/i.test(h) ? (s = !0, c = document.createTextNode(""), new m(r).observe(c, {
        characterData: !0
      }), a = function a() {
        c.data = s = !s;
      }) : v && v.resolve ? (u = v.resolve(void 0), a = function a() {
        u.then(r);
      }) : a = function a() {
        f.call(l, r);
      }), e.exports = w || function (e) {
        var t = {
          fn: e,
          next: void 0
        };
        i && (i.next = t), o || (o = t, a()), i = t;
      };
    }, function (e, t, n) {
      var r = n(0);

      e.exports = function (e, t) {
        var n = r.console;
        n && n.error && (1 === arguments.length ? n.error(e) : n.error(e, t));
      };
    }, function (e, t) {
      e.exports = function (e) {
        try {
          return {
            error: !1,
            value: e()
          };
        } catch (e) {
          return {
            error: !0,
            value: e
          };
        }
      };
    }, function (e, t, n) {
      var r = n(19);

      e.exports = function (e, t, n) {
        for (var o in t) {
          r(e, o, t[o], n);
        }

        return e;
      };
    }, function (e, t, n) {
      var r = n(72),
          o = n(14),
          i = n(13),
          a = n(1)("species");

      e.exports = function (e) {
        var t = r(e),
            n = o.f;
        i && t && !t[a] && n(t, a, {
          configurable: !0,
          get: function get() {
            return this;
          }
        });
      };
    }, function (e, t, n) {
      var r = n(72),
          o = n(67),
          i = n(70);
      n(12)({
        target: "Promise",
        proto: !0,
        real: !0
      }, {
        finally: function _finally(e) {
          var t = o(this, r("Promise")),
              n = "function" == typeof e;
          return this.then(n ? function (n) {
            return i(t, e()).then(function () {
              return n;
            });
          } : e, n ? function (n) {
            return i(t, e()).then(function () {
              throw n;
            });
          } : e);
        }
      });
    }]);
  }),
      ie = (re = oe) && re.__esModule && Object.prototype.hasOwnProperty.call(re, "default") ? re.default : re;

  var ae = function ae(e) {
    return e && "false" !== String(e).toLowerCase();
  },
      se = function se(e) {
    return /^[+-]?[0-9]+.?([0-9]+)?(%|cm|em|ex|in|mm|pc|pt|px|vh|vw)$/.test(e);
  },
      ce = function ce() {
    return I(_templateObject());
  },
      ue = function ue(e) {
    return /^(https?):\/\/.+\.typeform\.com\/to\/([0-9a-zA-Z]{6,8})([$?].+)?/.test(e);
  },
      le = ["opacity", "buttonText", "hideScrollbars", "hideFooter", "hideHeaders"];

  e.TypeformWidget = /*#__PURE__*/function (_ne) {
    _inherits(_class2, _ne);

    var _super5 = _createSuper(_class2);

    function _class2() {
      var _this11;

      _classCallCheck(this, _class2);

      _this11 = _super5.apply(this, arguments), _this11.hideScrollbars = !1, _this11.hideFooter = !1, _this11.hideHeaders = !1;
      return _this11;
    }

    _createClass(_class2, [{
      key: "createRenderRoot",
      value: function createRenderRoot() {
        return this;
      }
    }, {
      key: "render",
      value: function render() {
        return ue(this.url) ? I(_templateObject2(), se(this.height) ? this.height : "500px", se(this.width) ? this.width : "100%") : ce();
      }
    }, {
      key: "updated",
      value: function updated(e) {
        var t = [].concat(le, ["url"]);

        var _iterator6 = _createForOfIteratorHelper(t),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _n12 = _step6.value;
            if (e.has(_n12) && e.get(_n12) !== this[_n12]) return this._renderForm();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }, {
      key: "_onSubmit",
      value: function _onSubmit() {
        this.dispatchEvent(new Event("submit"));
      }
    }, {
      key: "_renderForm",
      value: function _renderForm() {
        var _this12 = this;

        if (!ue(this.url)) return;
        var e = this.querySelector("div");
        e.innerHTML = "";
        var t = {
          onSubmit: function onSubmit() {
            return _this12._onSubmit();
          }
        };
        le.forEach(function (e) {
          return _this12[e] ? t[e] = _this12[e] : null;
        }), ie.makeWidget(e, this.url, t);
      }
    }]);

    return _class2;
  }(ne), t([Q({
    type: String
  })], e.TypeformWidget.prototype, "url", void 0), t([Q({
    type: String
  })], e.TypeformWidget.prototype, "height", void 0), t([Q({
    type: String
  })], e.TypeformWidget.prototype, "width", void 0), t([Q({
    type: Number
  })], e.TypeformWidget.prototype, "opacity", void 0), t([Q({
    type: String,
    attribute: "button-text"
  })], e.TypeformWidget.prototype, "buttonText", void 0), t([Q({
    type: Boolean,
    attribute: "hide-scrollbars",
    converter: ae
  })], e.TypeformWidget.prototype, "hideScrollbars", void 0), t([Q({
    type: Boolean,
    attribute: "hide-footer",
    converter: ae
  })], e.TypeformWidget.prototype, "hideFooter", void 0), t([Q({
    type: Boolean,
    attribute: "hide-headers",
    converter: ae
  })], e.TypeformWidget.prototype, "hideHeaders", void 0), e.TypeformWidget = t([Y("typeform-widget")], e.TypeformWidget);

  var de = function de(e) {
    if ("string" == typeof e) return new ee(String('* {\n  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; }\n' + e), X);
    return Object.entries(e).reduce(function (e, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          t = _ref3[0],
          n = _ref3[1];

      return "".concat(e).concat(t, ":").concat(n, ";");
    }, "");
  };

  var pe = ["mode", "autoOpen", "autoClose", "hideScrollbars", "hideFooter", "hideHeaders", "drawerWidth"];
  return e.TypeformPopup = /*#__PURE__*/function (_ne2) {
    _inherits(_class3, _ne2);

    var _super6 = _createSuper(_class3);

    function _class3() {
      _classCallCheck(this, _class3);

      return _super6.apply(this, arguments);
    }

    _createClass(_class3, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this13 = this;

        setTimeout(function () {
          return _this13.autoOpen ? _this13._openPopup() : null;
        }, 1e3), _get(_getPrototypeOf(_class3.prototype), "connectedCallback", this).call(this);
      }
    }, {
      key: "render",
      value: function render() {
        return ue(this.url) ? this.customStyle ? I(_templateObject3(), this._openPopup, this.customStyle) : I(_templateObject4(), this._openPopup) : ce();
      }
    }, {
      key: "_destroyPopup",
      value: function _destroyPopup() {
        this._popup && this._popup.close(), this._popup = null;
      }
    }, {
      key: "_onSubmit",
      value: function _onSubmit() {
        this.dispatchEvent(new Event("submit"));
      }
    }, {
      key: "_openPopup",
      value: function _openPopup() {
        var _this14 = this;

        if (this._destroyPopup(), !ue(this.url)) return;
        var e = {
          autoOpen: !0,
          onSubmit: function onSubmit() {
            return _this14._onSubmit();
          }
        };
        pe.forEach(function (t) {
          return _this14[t] ? e[t] = _this14[t] : null;
        }), this._popup = ie.makePopup(this.url, e);
      }
    }], [{
      key: "styles",
      get: function get() {
        return de(":host {\n  display: inline-block;\n  height: auto;\n  width: auto; }\n  :host button.typeform-button {\n    display: inline-block;\n    text-decoration: none;\n    background-color: #267DDD;\n    color: white;\n    cursor: pointer;\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 20px;\n    line-height: 50px;\n    text-align: center;\n    margin: 0;\n    height: 50px;\n    padding: 0px 33px;\n    border-radius: 25px;\n    max-width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-weight: bold;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    outline: none; }\n    :host button.typeform-button:focus {\n      outline: none; }\n");
      }
    }]);

    return _class3;
  }(ne), t([Q({
    type: String
  })], e.TypeformPopup.prototype, "url", void 0), t([Q({
    type: String
  })], e.TypeformPopup.prototype, "mode", void 0), t([Q({
    type: Boolean,
    attribute: "auto-open",
    converter: ae
  })], e.TypeformPopup.prototype, "autoOpen", void 0), t([Q({
    type: Number,
    attribute: "auto-close"
  })], e.TypeformPopup.prototype, "autoClose", void 0), t([Q({
    type: String,
    attribute: "custom-style"
  })], e.TypeformPopup.prototype, "customStyle", void 0), t([Q({
    type: Number,
    attribute: "drawer-width"
  })], e.TypeformPopup.prototype, "drawerWidth", void 0), t([Q({
    type: Boolean,
    attribute: "hide-scrollbars",
    converter: ae
  })], e.TypeformPopup.prototype, "hideScrollbars", void 0), t([Q({
    type: Boolean,
    attribute: "hide-footer",
    converter: ae
  })], e.TypeformPopup.prototype, "hideFooter", void 0), t([Q({
    type: Boolean,
    attribute: "hide-headers",
    converter: ae
  })], e.TypeformPopup.prototype, "hideHeaders", void 0), e.TypeformPopup = t([Y("typeform-popup")], e.TypeformPopup), e;
}({});